import { PublicKey, LAMPORTS_PER_SOL, SystemProgram, TransactionInstruction, Transaction, SYSVAR_CLOCK_PUBKEY, StakeProgram, Keypair } from '@solana/web3.js';
import { TOKEN_PROGRAM_ID, createAssociatedTokenAccountInstruction, getAssociatedTokenAddress } from '@solana/spl-token';
import { struct, u8, nu64, u32 } from '@solana/buffer-layout';
import BN from 'bn.js';
import require$$0 from 'buffer';
import * as React from 'react';
import React__default, { forwardRef, useState, useCallback, useEffect, useRef, Children, isValidElement, cloneElement, useLayoutEffect, createContext, useMemo, createElement, useReducer } from 'react';
import styled, { css as css$1, keyframes, useTheme, ThemeProvider } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import ReactDOM, { render } from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$c = function() {
    __assign$c = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject$q(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var _a$1, _b;
var INSTRUCTION;
(function (INSTRUCTION) {
    INSTRUCTION[INSTRUCTION["STAKE"] = 1] = "STAKE";
    INSTRUCTION[INSTRUCTION["UNSTAKE"] = 2] = "UNSTAKE";
})(INSTRUCTION || (INSTRUCTION = {}));
var INSTRUCTION_V2;
(function (INSTRUCTION_V2) {
    INSTRUCTION_V2[INSTRUCTION_V2["STAKE"] = 1] = "STAKE";
    INSTRUCTION_V2[INSTRUCTION_V2["UNSTAKE"] = 23] = "UNSTAKE";
})(INSTRUCTION_V2 || (INSTRUCTION_V2 = {}));
var TX_STAGE;
(function (TX_STAGE) {
    TX_STAGE[TX_STAGE["IDLE"] = 0] = "IDLE";
    TX_STAGE[TX_STAGE["AWAITING_SIGNING"] = 1] = "AWAITING_SIGNING";
    TX_STAGE[TX_STAGE["AWAITING_BLOCK"] = 2] = "AWAITING_BLOCK";
    TX_STAGE[TX_STAGE["SUCCESS"] = 3] = "SUCCESS";
    TX_STAGE[TX_STAGE["ERROR"] = 4] = "ERROR";
})(TX_STAGE || (TX_STAGE = {}));
var LidoVersion;
(function (LidoVersion) {
    LidoVersion[LidoVersion["v1"] = 0] = "v1";
    LidoVersion[LidoVersion["v2"] = 1] = "v2";
})(LidoVersion || (LidoVersion = {}));
var MAINNET_PROGRAM_ADDRESSES = Object.freeze({
    solidoProgramId: new PublicKey('CrX7kMhLC3cSsXJdT7JDgqrRVWGnUpX3gfEfxxU2NVLi'),
    solidoInstanceId: new PublicKey('49Yi1TKkNyYjPAFdR9LBvoHcUjuPX4Df5T5yv39w2XTn'),
    stSolMintAddress: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
});
var TESTNET_PROGRAM_ADDRESSES = Object.freeze({
    solidoProgramId: new PublicKey('6RRggYnFe2EcD543QXrE3Wxp1Kgcq8qctwRrNnvjoYsL'),
    solidoInstanceId: new PublicKey('Hcqw2G2FkBhBiDZz3PXFBUKuMQiKMJmXvcfqRaXkyNXF'),
    stSolMintAddress: new PublicKey('Bz2UPiXJmCQYT8XQHaPPXG3fywNp2TENav5dcJdX9q21'),
});
var clusterProgramAddresses = {
    'mainnet-beta': MAINNET_PROGRAM_ADDRESSES,
    testnet: TESTNET_PROGRAM_ADDRESSES,
};
var MEMO_PROGRAM_ID = new PublicKey('MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr');
var SOL_API_HOST = 'https://sol-api-pub.lido.fi';
// 1xx - blockchain error
// 2xx - protocol errors
// 3xx - sdk errors
// 4xx - user's errors
var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["CANNOT_CONFIRM_TRANSACTION"] = 100] = "CANNOT_CONFIRM_TRANSACTION";
    ERROR_CODE[ERROR_CODE["NO_VALIDATORS"] = 200] = "NO_VALIDATORS";
    ERROR_CODE[ERROR_CODE["UNSUPPORTED_CLUSTER"] = 300] = "UNSUPPORTED_CLUSTER";
    ERROR_CODE[ERROR_CODE["UNSTAKE_UNAVAILABLE"] = 301] = "UNSTAKE_UNAVAILABLE";
    ERROR_CODE[ERROR_CODE["NO_PUBLIC_KEY"] = 302] = "NO_PUBLIC_KEY";
    ERROR_CODE[ERROR_CODE["NO_ACCOUNT_INFO"] = 303] = "NO_ACCOUNT_INFO";
    ERROR_CODE[ERROR_CODE["EXCEED_MAX"] = 400] = "EXCEED_MAX";
})(ERROR_CODE || (ERROR_CODE = {}));
var ERROR_CODE_DESC = (_a$1 = {},
    _a$1[ERROR_CODE.CANNOT_CONFIRM_TRANSACTION] = 'CANNOT_CONFIRM_TRANSACTION',
    _a$1[ERROR_CODE.NO_VALIDATORS] = 'NO_VALIDATORS',
    _a$1[ERROR_CODE.UNSUPPORTED_CLUSTER] = 'UNSUPPORTED_CLUSTER',
    _a$1[ERROR_CODE.UNSTAKE_UNAVAILABLE] = 'UNSTAKE_UNAVAILABLE',
    _a$1[ERROR_CODE.NO_PUBLIC_KEY] = 'NO_PUBLIC_KEY',
    _a$1[ERROR_CODE.NO_ACCOUNT_INFO] = 'NO_ACCOUNT_INFO',
    _a$1[ERROR_CODE.EXCEED_MAX] = 'EXCEED_MAX',
    _a$1);
var ERROR_MESSAGE = (_b = {},
    _b[ERROR_CODE.NO_VALIDATORS] = "Couldn't fetch validators list",
    _b[ERROR_CODE.UNSUPPORTED_CLUSTER] = "SolidoSDK doesn't support devnet, please specify mainnet-beta or testnet",
    _b[ERROR_CODE.UNSTAKE_UNAVAILABLE] = 'Sorry, unStake is not available right now. Please contact lido developers for details.',
    _b[ERROR_CODE.NO_PUBLIC_KEY] = 'SolidoSDK: publicKey is null in wallet',
    _b[ERROR_CODE.NO_ACCOUNT_INFO] = "Couldn't fetch getAccountInfo",
    _b);

var formatWithCommas = function (x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
// To use the lower(floor) value while calculating decimal precision
var toPrecision = function (value, precision) {
    return Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
};
var lamportsToSol = function (balanceInLamports, precision) {
    if (precision === void 0) { precision = 4; }
    return toPrecision(balanceInLamports / LAMPORTS_PER_SOL, precision);
};
var solToLamports = function (balanceInSol) { return balanceInSol * LAMPORTS_PER_SOL; };

function findProgramAddress(bufferFrom) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, solidoInstanceId, solidoProgramId, bufferArray, programAddress;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = this.programAddresses, solidoInstanceId = _a.solidoInstanceId, solidoProgramId = _a.solidoProgramId;
                    bufferArray = [solidoInstanceId.toBuffer(), Buffer.from(bufferFrom)];
                    return [4 /*yield*/, PublicKey.findProgramAddress(bufferArray, solidoProgramId)];
                case 1:
                    programAddress = _b.sent();
                    return [2 /*return*/, programAddress[0]];
            }
        });
    });
}
function getDepositInstruction(props) {
    return __awaiter(this, void 0, void 0, function () {
        var amount, payerAddress, recipientStSolAddress, _a, solidoProgramId, stSolMintAddress, solidoInstanceId, dataLayout, data, reserveAccount, mintAuthority, keys;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    amount = props.amount, payerAddress = props.payerAddress, recipientStSolAddress = props.recipientStSolAddress;
                    _a = this.programAddresses, solidoProgramId = _a.solidoProgramId, stSolMintAddress = _a.stSolMintAddress, solidoInstanceId = _a.solidoInstanceId;
                    dataLayout = struct([u8('instruction'), nu64('amount')]);
                    data = Buffer.alloc(dataLayout.span);
                    dataLayout.encode({
                        instruction: INSTRUCTION.STAKE,
                        amount: new BN(solToLamports(amount)),
                    }, data);
                    return [4 /*yield*/, this.findProgramAddress('reserve_account')];
                case 1:
                    reserveAccount = _b.sent();
                    return [4 /*yield*/, this.findProgramAddress('mint_authority')];
                case 2:
                    mintAuthority = _b.sent();
                    keys = [
                        { pubkey: solidoInstanceId, isSigner: false, isWritable: true },
                        { pubkey: payerAddress, isSigner: true, isWritable: true },
                        { pubkey: recipientStSolAddress, isSigner: false, isWritable: true },
                        { pubkey: stSolMintAddress, isSigner: false, isWritable: true },
                        { pubkey: reserveAccount, isSigner: false, isWritable: true },
                        { pubkey: mintAuthority, isSigner: false, isWritable: false },
                        { pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                        { pubkey: SystemProgram.programId, isSigner: false, isWritable: false },
                    ];
                    return [2 /*return*/, new TransactionInstruction({
                            keys: keys,
                            programId: solidoProgramId,
                            data: data,
                        })];
            }
        });
    });
}

var getMemoInstruction = function (data, payerAddress) {
    return new TransactionInstruction({
        programId: MEMO_PROGRAM_ID,
        data: Buffer.from(JSON.stringify(data)),
        keys: [{ isSigner: true, isWritable: false, pubkey: payerAddress }],
    });
};

var ErrorWrapper = /** @class */ (function (_super) {
    __extends(ErrorWrapper, _super);
    function ErrorWrapper(_a) {
        var code = _a.code, _b = _a.error, error = _b === void 0 ? {} : _b, _c = _a.message, message = _c === void 0 ? ERROR_MESSAGE[code] : _c;
        var _this = _super.call(this, message) || this;
        Object.assign(_this, error);
        _this.codeDesc = ERROR_CODE_DESC[code];
        _this.code = code;
        return _this;
    }
    return ErrorWrapper;
}(Error));

var checkMaxExceed = function (amount, maxInLamports) {
    if (solToLamports(amount) > maxInLamports) {
        throw new ErrorWrapper({
            code: ERROR_CODE.EXCEED_MAX,
            message: "Amount must not exceed MAX(".concat(lamportsToSol(maxInLamports), ")"),
        });
    }
};

var ensureTokenAccount = function (transaction, payer, stSolMint) { return __awaiter(void 0, void 0, void 0, function () {
    var associatedStSolAccount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAssociatedTokenAddress(stSolMint, payer)];
            case 1:
                associatedStSolAccount = _a.sent();
                transaction.add(createAssociatedTokenAccountInstruction(payer, associatedStSolAccount, payer, stSolMint));
                return [2 /*return*/, associatedStSolAccount];
        }
    });
}); };

function getStakeTransaction(props) {
    return __awaiter(this, void 0, void 0, function () {
        var payerAddress, amount, stSolMintAddress, maxInLamports, transaction, blockhash, stSolAccount, stSolAccountAddress, depositInstruction, memoData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payerAddress = props.payerAddress, amount = props.amount;
                    stSolMintAddress = this.programAddresses.stSolMintAddress;
                    return [4 /*yield*/, this.calculateMaxStakeAmount(payerAddress)];
                case 1:
                    maxInLamports = _a.sent();
                    checkMaxExceed(amount, maxInLamports);
                    transaction = new Transaction({ feePayer: payerAddress });
                    return [4 /*yield*/, this.connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    return [4 /*yield*/, this.getStSolAccountsForUser(payerAddress)];
                case 3:
                    stSolAccount = (_a.sent())[0];
                    stSolAccountAddress = stSolAccount === null || stSolAccount === void 0 ? void 0 : stSolAccount.address;
                    if (!!stSolAccountAddress) return [3 /*break*/, 5];
                    return [4 /*yield*/, ensureTokenAccount(transaction, payerAddress, stSolMintAddress)];
                case 4:
                    stSolAccountAddress = _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, this.getDepositInstruction(__assign$c(__assign$c({}, props), { recipientStSolAddress: stSolAccountAddress }))];
                case 6:
                    depositInstruction = _a.sent();
                    transaction.add(depositInstruction);
                    memoData = this.referrerId;
                    if (memoData) {
                        transaction.add(getMemoInstruction({ referrer: memoData }, payerAddress));
                    }
                    return [2 /*return*/, { transaction: transaction, stSolAccountAddress: stSolAccountAddress }];
            }
        });
    });
}

function calculateMaxStakeAmount(address) {
    return __awaiter(this, void 0, void 0, function () {
        var fee, accountInfo, accountRent, balanceInLamports;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.connection.getRecentBlockhash()];
                case 1:
                    fee = (_a.sent()).feeCalculator.lamportsPerSignature;
                    return [4 /*yield*/, this.connection.getAccountInfo(address)];
                case 2:
                    accountInfo = _a.sent();
                    if (accountInfo === null) {
                        return [2 /*return*/, 0];
                    }
                    return [4 /*yield*/, this.connection.getMinimumBalanceForRentExemption(accountInfo.data.byteLength)];
                case 3:
                    accountRent = _a.sent();
                    balanceInLamports = accountInfo.lamports;
                    return [2 /*return*/, Math.max(balanceInLamports - accountRent - 50 * fee, 0)];
            }
        });
    });
}

var getHeaviestValidator = function (validatorEntries) {
    return validatorEntries.reduce(function (validatorB, validatorA) {
        var effectiveStakeBalanceValidatorA = validatorA.effective_stake_balance;
        var effectiveStakeBalanceValidatorB = validatorB.effective_stake_balance;
        return effectiveStakeBalanceValidatorB.gt(effectiveStakeBalanceValidatorA) ? validatorB : validatorA;
    });
};
var getValidatorIndex = function (validatorEntries, validator) {
    return validatorEntries.findIndex(function (_a) {
        var voteAccountAddress = _a.vote_account_address;
        return voteAccountAddress.toString() === validator.vote_account_address.toString();
    });
};
function calculateStakeAccountAddress(heaviestValidator) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, solidoInstanceId, solidoProgramId, validator, validators, validatorVoteAccount, seed, bufferArray, stakeAccountAddress;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = this.programAddresses, solidoInstanceId = _a.solidoInstanceId, solidoProgramId = _a.solidoProgramId;
                    validator = heaviestValidator;
                    if (!!validator) return [3 /*break*/, 2];
                    return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    validators = (_b.sent()).validators;
                    validator = getHeaviestValidator(validators);
                    _b.label = 2;
                case 2:
                    validatorVoteAccount = new PublicKey(validator.vote_account_address);
                    seed = validator.stake_seeds.begin;
                    bufferArray = [
                        solidoInstanceId.toBuffer(),
                        validatorVoteAccount.toBuffer(),
                        Buffer.from('validator_stake_account'),
                        seed.toArray('le', 8),
                    ];
                    return [4 /*yield*/, PublicKey.findProgramAddress(bufferArray, solidoProgramId)];
                case 3:
                    stakeAccountAddress = (_b.sent())[0];
                    return [2 /*return*/, stakeAccountAddress];
            }
        });
    });
}
function getWithdrawInstruction(props) {
    return __awaiter(this, void 0, void 0, function () {
        var senderStSolAccountAddress, payerAddress, amount, stakeAccount, _a, solidoProgramId, stSolMintAddress, solidoInstanceId, _b, validators, accountInfo, lidoVersion, validator, data, dataLayout, dataLayout, stakeAuthority, validatorStakeAccount, keys;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    senderStSolAccountAddress = props.senderStSolAccountAddress, payerAddress = props.payerAddress, amount = props.amount, stakeAccount = props.stakeAccount;
                    _a = this.programAddresses, solidoProgramId = _a.solidoProgramId, stSolMintAddress = _a.stSolMintAddress, solidoInstanceId = _a.solidoInstanceId;
                    return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    _b = _c.sent(), validators = _b.validators, accountInfo = _b.accountInfo, lidoVersion = _b.lidoVersion;
                    validator = getHeaviestValidator(validators);
                    if (lidoVersion === LidoVersion.v1) {
                        dataLayout = struct([u8('instruction'), nu64('amount')]);
                        data = Buffer.alloc(dataLayout.span);
                        dataLayout.encode({
                            instruction: INSTRUCTION.UNSTAKE,
                            amount: new BN(solToLamports(amount)),
                        }, data);
                    }
                    else {
                        dataLayout = struct([
                            u8('instruction'),
                            nu64('amount'),
                            u32('validator_index'),
                        ]);
                        data = Buffer.alloc(dataLayout.span);
                        dataLayout.encode({
                            instruction: INSTRUCTION_V2.UNSTAKE,
                            amount: new BN(solToLamports(amount)),
                            validator_index: getValidatorIndex(validators, validator),
                        }, data);
                    }
                    return [4 /*yield*/, this.findProgramAddress('stake_authority')];
                case 2:
                    stakeAuthority = _c.sent();
                    return [4 /*yield*/, this.calculateStakeAccountAddress(validator)];
                case 3:
                    validatorStakeAccount = _c.sent();
                    keys = [
                        { pubkey: solidoInstanceId, isSigner: false, isWritable: true },
                        { pubkey: payerAddress, isSigner: true, isWritable: false },
                        { pubkey: senderStSolAccountAddress, isSigner: false, isWritable: true },
                        { pubkey: stSolMintAddress, isSigner: false, isWritable: true },
                        { pubkey: new PublicKey(validator.vote_account_address), isSigner: false, isWritable: false },
                        { pubkey: validatorStakeAccount, isSigner: false, isWritable: true },
                        { pubkey: stakeAccount, isSigner: true, isWritable: true },
                        { pubkey: stakeAuthority, isSigner: false, isWritable: false },
                        { pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                        { pubkey: SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
                        { pubkey: SystemProgram.programId, isSigner: false, isWritable: false },
                        { pubkey: StakeProgram.programId, isSigner: false, isWritable: false },
                    ];
                    if (lidoVersion === LidoVersion.v2) {
                        // for v2 we will add also validator_list after stakeAuthority
                        keys.splice(8, 0, {
                            pubkey: new PublicKey(accountInfo.validator_list),
                            isSigner: false,
                            isWritable: true,
                        });
                    }
                    return [2 /*return*/, new TransactionInstruction({
                            keys: keys,
                            programId: solidoProgramId,
                            data: data,
                        })];
            }
        });
    });
}

function getUnStakeTransaction(props) {
    return __awaiter(this, void 0, void 0, function () {
        var isUnStakeAvailable, payerAddress, amount, maxInLamports, newStakeAccount, newStakeAccountPubkey, transaction, blockhash, stSolAccount, withdrawInstruction, deactivateTransaction;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.isUnStakeAvailable()];
                case 1:
                    isUnStakeAvailable = _a.sent();
                    if (!isUnStakeAvailable) {
                        throw new ErrorWrapper({ code: ERROR_CODE.UNSTAKE_UNAVAILABLE });
                    }
                    payerAddress = props.payerAddress, amount = props.amount;
                    return [4 /*yield*/, this.calculateMaxUnStakeAmount(payerAddress)];
                case 2:
                    maxInLamports = _a.sent();
                    checkMaxExceed(amount, maxInLamports);
                    newStakeAccount = Keypair.generate();
                    newStakeAccountPubkey = newStakeAccount.publicKey;
                    transaction = new Transaction({ feePayer: payerAddress });
                    return [4 /*yield*/, this.connection.getLatestBlockhash()];
                case 3:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    return [4 /*yield*/, this.getStSolAccountsForUser(payerAddress)];
                case 4:
                    stSolAccount = (_a.sent())[0];
                    return [4 /*yield*/, this.getWithdrawInstruction(__assign$c(__assign$c({}, props), { senderStSolAccountAddress: stSolAccount.address, stakeAccount: newStakeAccountPubkey }))];
                case 5:
                    withdrawInstruction = _a.sent();
                    transaction.add(withdrawInstruction);
                    deactivateTransaction = StakeProgram.deactivate({
                        authorizedPubkey: payerAddress,
                        stakePubkey: newStakeAccountPubkey,
                    });
                    deactivateTransaction.instructions.forEach(function (instruction) {
                        var txInstruction = new TransactionInstruction(instruction);
                        transaction.add(txInstruction);
                    });
                    transaction.partialSign(newStakeAccount);
                    return [2 /*return*/, { transaction: transaction, deactivatingSolAccountAddress: newStakeAccountPubkey }];
            }
        });
    });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var lib$1 = {};

var safeBuffer = {exports: {}};

/* eslint-disable node/no-deprecated-api */

(function (module, exports) {
	var buffer = require$$0;
	var Buffer = buffer.Buffer;

	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key];
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer;
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports);
	  exports.Buffer = SafeBuffer;
	}

	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}

	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer);

	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	};

	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size);
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding);
	    } else {
	      buf.fill(fill);
	    }
	  } else {
	    buf.fill(0);
	  }
	  return buf
	};

	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	};

	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	};
} (safeBuffer, safeBuffer.exports));

// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
// @ts-ignore
var _Buffer = safeBuffer.exports.Buffer;
function base (ALPHABET) {
  if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
  var BASE_MAP = new Uint8Array(256);
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255;
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i);
    var xc = x.charCodeAt(0);
    if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
    BASE_MAP[xc] = i;
  }
  var BASE = ALPHABET.length;
  var LEADER = ALPHABET.charAt(0);
  var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
  var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
  function encode (source) {
    if (Array.isArray(source) || source instanceof Uint8Array) { source = _Buffer.from(source); }
    if (!_Buffer.isBuffer(source)) { throw new TypeError('Expected Buffer') }
    if (source.length === 0) { return '' }
        // Skip & count leading zeroes.
    var zeroes = 0;
    var length = 0;
    var pbegin = 0;
    var pend = source.length;
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++;
      zeroes++;
    }
        // Allocate enough space in big-endian base58 representation.
    var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
    var b58 = new Uint8Array(size);
        // Process the bytes.
    while (pbegin !== pend) {
      var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
      var i = 0;
      for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
        carry += (256 * b58[it1]) >>> 0;
        b58[it1] = (carry % BASE) >>> 0;
        carry = (carry / BASE) >>> 0;
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i;
      pbegin++;
    }
        // Skip leading zeroes in base58 result.
    var it2 = size - length;
    while (it2 !== size && b58[it2] === 0) {
      it2++;
    }
        // Translate the result into a string.
    var str = LEADER.repeat(zeroes);
    for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]); }
    return str
  }
  function decodeUnsafe (source) {
    if (typeof source !== 'string') { throw new TypeError('Expected String') }
    if (source.length === 0) { return _Buffer.alloc(0) }
    var psz = 0;
        // Skip and count leading '1's.
    var zeroes = 0;
    var length = 0;
    while (source[psz] === LEADER) {
      zeroes++;
      psz++;
    }
        // Allocate enough space in big-endian base256 representation.
    var size = (((source.length - psz) * FACTOR) + 1) >>> 0; // log(58) / log(256), rounded up.
    var b256 = new Uint8Array(size);
        // Process the characters.
    while (source[psz]) {
            // Decode character
      var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
      if (carry === 255) { return }
      var i = 0;
      for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
        carry += (BASE * b256[it3]) >>> 0;
        b256[it3] = (carry % 256) >>> 0;
        carry = (carry / 256) >>> 0;
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i;
      psz++;
    }
        // Skip leading zeroes in b256.
    var it4 = size - length;
    while (it4 !== size && b256[it4] === 0) {
      it4++;
    }
    var vch = _Buffer.allocUnsafe(zeroes + (size - it4));
    vch.fill(0x00, 0, zeroes);
    var j = zeroes;
    while (it4 !== size) {
      vch[j++] = b256[it4++];
    }
    return vch
  }
  function decode (string) {
    var buffer = decodeUnsafe(string);
    if (buffer) { return buffer }
    throw new Error('Non-base' + BASE + ' character')
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  }
}
var src = base;

var basex = src;
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

var bs58 = basex(ALPHABET);

var encoding_lib = {};

// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

//
// Utilities
//

/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */
function inRange(a, min, max) {
  return min <= a && a <= max;
}

/**
 * @param {*} o
 * @return {Object}
 */
function ToDictionary(o) {
  if (o === undefined) return {};
  if (o === Object(o)) return o;
  throw TypeError('Could not convert argument to dictionary');
}

/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */
function stringToCodePoints(string) {
  // https://heycam.github.io/webidl/#dfn-obtain-unicode

  // 1. Let S be the DOMString value.
  var s = String(string);

  // 2. Let n be the length of S.
  var n = s.length;

  // 3. Initialize i to 0.
  var i = 0;

  // 4. Initialize U to be an empty sequence of Unicode characters.
  var u = [];

  // 5. While i < n:
  while (i < n) {

    // 1. Let c be the code unit in S at index i.
    var c = s.charCodeAt(i);

    // 2. Depending on the value of c:

    // c < 0xD800 or c > 0xDFFF
    if (c < 0xD800 || c > 0xDFFF) {
      // Append to U the Unicode character with code point c.
      u.push(c);
    }

    // 0xDC00 ≤ c ≤ 0xDFFF
    else if (0xDC00 <= c && c <= 0xDFFF) {
      // Append to U a U+FFFD REPLACEMENT CHARACTER.
      u.push(0xFFFD);
    }

    // 0xD800 ≤ c ≤ 0xDBFF
    else if (0xD800 <= c && c <= 0xDBFF) {
      // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
      // CHARACTER.
      if (i === n - 1) {
        u.push(0xFFFD);
      }
      // 2. Otherwise, i < n−1:
      else {
        // 1. Let d be the code unit in S at index i+1.
        var d = string.charCodeAt(i + 1);

        // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
        if (0xDC00 <= d && d <= 0xDFFF) {
          // 1. Let a be c & 0x3FF.
          var a = c & 0x3FF;

          // 2. Let b be d & 0x3FF.
          var b = d & 0x3FF;

          // 3. Append to U the Unicode character with code point
          // 2^16+2^10*a+b.
          u.push(0x10000 + (a << 10) + b);

          // 4. Set i to i+1.
          i += 1;
        }

        // 3. Otherwise, d < 0xDC00 or d > 0xDFFF. Append to U a
        // U+FFFD REPLACEMENT CHARACTER.
        else  {
          u.push(0xFFFD);
        }
      }
    }

    // 3. Set i to i+1.
    i += 1;
  }

  // 6. Return U.
  return u;
}

/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */
function codePointsToString(code_points) {
  var s = '';
  for (var i = 0; i < code_points.length; ++i) {
    var cp = code_points[i];
    if (cp <= 0xFFFF) {
      s += String.fromCharCode(cp);
    } else {
      cp -= 0x10000;
      s += String.fromCharCode((cp >> 10) + 0xD800,
                               (cp & 0x3FF) + 0xDC00);
    }
  }
  return s;
}


//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//

//
// 3. Terminology
//

/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var end_of_stream = -1;

/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */
function Stream(tokens) {
  /** @type {!Array.<number>} */
  this.tokens = [].slice.call(tokens);
}

Stream.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },

  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
   read: function() {
    if (!this.tokens.length)
      return end_of_stream;
     return this.tokens.shift();
   },

  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.unshift(tokens.pop());
    } else {
      this.tokens.unshift(token);
    }
  },

  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.push(tokens.shift());
    } else {
      this.tokens.push(token);
    }
  }
};

//
// 4. Encodings
//

// 4.1 Encoders and decoders

/** @const */
var finished = -1;

/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */
function decoderError(fatal, opt_code_point) {
  if (fatal)
    throw TypeError('Decoder error');
  return opt_code_point || 0xFFFD;
}

//
// 7. API
//

/** @const */ var DEFAULT_ENCODING = 'utf-8';

// 7.1 Interface TextDecoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextDecoder$1(encoding, options) {
  if (!(this instanceof TextDecoder$1)) {
    return new TextDecoder$1(encoding, options);
  }
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {boolean} */
  this._BOMseen = false;
  /** @private @type {?Decoder} */
  this._decoder = null;
  /** @private @type {boolean} */
  this._fatal = Boolean(options['fatal']);
  /** @private @type {boolean} */
  this._ignoreBOM = Boolean(options['ignoreBOM']);

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
  Object.defineProperty(this, 'fatal', {value: this._fatal});
  Object.defineProperty(this, 'ignoreBOM', {value: this._ignoreBOM});
}

TextDecoder$1.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function decode(input, options) {
    var bytes;
    if (typeof input === 'object' && input instanceof ArrayBuffer) {
      bytes = new Uint8Array(input);
    } else if (typeof input === 'object' && 'buffer' in input &&
               input.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(input.buffer,
                             input.byteOffset,
                             input.byteLength);
    } else {
      bytes = new Uint8Array(0);
    }

    options = ToDictionary(options);

    if (!this._streaming) {
      this._decoder = new UTF8Decoder({fatal: this._fatal});
      this._BOMseen = false;
    }
    this._streaming = Boolean(options['stream']);

    var input_stream = new Stream(bytes);

    var code_points = [];

    /** @type {?(number|!Array.<number>)} */
    var result;

    while (!input_stream.endOfStream()) {
      result = this._decoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (result === null)
        continue;
      if (Array.isArray(result))
        code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
      else
        code_points.push(result);
    }
    if (!this._streaming) {
      do {
        result = this._decoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (result === null)
          continue;
        if (Array.isArray(result))
          code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
        else
          code_points.push(result);
      } while (!input_stream.endOfStream());
      this._decoder = null;
    }

    if (code_points.length) {
      // If encoding is one of utf-8, utf-16be, and utf-16le, and
      // ignore BOM flag and BOM seen flag are unset, run these
      // subsubsteps:
      if (['utf-8'].indexOf(this.encoding) !== -1 &&
          !this._ignoreBOM && !this._BOMseen) {
        // If token is U+FEFF, set BOM seen flag.
        if (code_points[0] === 0xFEFF) {
          this._BOMseen = true;
          code_points.shift();
        } else {
          // Otherwise, if token is not end-of-stream, set BOM seen
          // flag and append token to output.
          this._BOMseen = true;
        }
      }
    }

    return codePointsToString(code_points);
  }
};

// 7.2 Interface TextEncoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextEncoder(encoding, options) {
  if (!(this instanceof TextEncoder))
    return new TextEncoder(encoding, options);
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {?Encoder} */
  this._encoder = null;
  /** @private @type {{fatal: boolean}} */
  this._options = {fatal: Boolean(options['fatal'])};

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
}

TextEncoder.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function encode(opt_string, options) {
    opt_string = opt_string ? String(opt_string) : '';
    options = ToDictionary(options);

    // NOTE: This option is nonstandard. None of the encodings
    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
    // so streaming is not necessary.
    if (!this._streaming)
      this._encoder = new UTF8Encoder(this._options);
    this._streaming = Boolean(options['stream']);

    var bytes = [];
    var input_stream = new Stream(stringToCodePoints(opt_string));
    /** @type {?(number|!Array.<number>)} */
    var result;
    while (!input_stream.endOfStream()) {
      result = this._encoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (Array.isArray(result))
        bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
      else
        bytes.push(result);
    }
    if (!this._streaming) {
      while (true) {
        result = this._encoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (Array.isArray(result))
          bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
        else
          bytes.push(result);
      }
      this._encoder = null;
    }
    return new Uint8Array(bytes);
  }
};

//
// 8. The encoding
//

// 8.1 utf-8

/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Decoder(options) {
  var fatal = options.fatal;

  // utf-8's decoder's has an associated utf-8 code point, utf-8
  // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
  // lower boundary (initially 0x80), and a utf-8 upper boundary
  // (initially 0xBF).
  var /** @type {number} */ utf8_code_point = 0,
      /** @type {number} */ utf8_bytes_seen = 0,
      /** @type {number} */ utf8_bytes_needed = 0,
      /** @type {number} */ utf8_lower_boundary = 0x80,
      /** @type {number} */ utf8_upper_boundary = 0xBF;

  /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */
  this.handler = function(stream, bite) {
    // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
    // set utf-8 bytes needed to 0 and return error.
    if (bite === end_of_stream && utf8_bytes_needed !== 0) {
      utf8_bytes_needed = 0;
      return decoderError(fatal);
    }

    // 2. If byte is end-of-stream, return finished.
    if (bite === end_of_stream)
      return finished;

    // 3. If utf-8 bytes needed is 0, based on byte:
    if (utf8_bytes_needed === 0) {

      // 0x00 to 0x7F
      if (inRange(bite, 0x00, 0x7F)) {
        // Return a code point whose value is byte.
        return bite;
      }

      // 0xC2 to 0xDF
      if (inRange(bite, 0xC2, 0xDF)) {
        // Set utf-8 bytes needed to 1 and utf-8 code point to byte
        // − 0xC0.
        utf8_bytes_needed = 1;
        utf8_code_point = bite - 0xC0;
      }

      // 0xE0 to 0xEF
      else if (inRange(bite, 0xE0, 0xEF)) {
        // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
        if (bite === 0xE0)
          utf8_lower_boundary = 0xA0;
        // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
        if (bite === 0xED)
          utf8_upper_boundary = 0x9F;
        // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
        // byte − 0xE0.
        utf8_bytes_needed = 2;
        utf8_code_point = bite - 0xE0;
      }

      // 0xF0 to 0xF4
      else if (inRange(bite, 0xF0, 0xF4)) {
        // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
        if (bite === 0xF0)
          utf8_lower_boundary = 0x90;
        // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
        if (bite === 0xF4)
          utf8_upper_boundary = 0x8F;
        // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
        // byte − 0xF0.
        utf8_bytes_needed = 3;
        utf8_code_point = bite - 0xF0;
      }

      // Otherwise
      else {
        // Return error.
        return decoderError(fatal);
      }

      // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
      // point to utf-8 code point << (6 × utf-8 bytes needed) and
      // return continue.
      utf8_code_point = utf8_code_point << (6 * utf8_bytes_needed);
      return null;
    }

    // 4. If byte is not in the range utf-8 lower boundary to utf-8
    // upper boundary, run these substeps:
    if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {

      // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
      // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
      // utf-8 upper boundary to 0xBF.
      utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
      utf8_lower_boundary = 0x80;
      utf8_upper_boundary = 0xBF;

      // 2. Prepend byte to stream.
      stream.prepend(bite);

      // 3. Return error.
      return decoderError(fatal);
    }

    // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
    // to 0xBF.
    utf8_lower_boundary = 0x80;
    utf8_upper_boundary = 0xBF;

    // 6. Increase utf-8 bytes seen by one and set utf-8 code point
    // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
    // needed − utf-8 bytes seen)).
    utf8_bytes_seen += 1;
    utf8_code_point += (bite - 0x80) << (6 * (utf8_bytes_needed - utf8_bytes_seen));

    // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
    // continue.
    if (utf8_bytes_seen !== utf8_bytes_needed)
      return null;

    // 8. Let code point be utf-8 code point.
    var code_point = utf8_code_point;

    // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
    // seen to 0.
    utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;

    // 10. Return a code point whose value is code point.
    return code_point;
  };
}

/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Encoder(options) {
  options.fatal;
  /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */
  this.handler = function(stream, code_point) {
    // 1. If code point is end-of-stream, return finished.
    if (code_point === end_of_stream)
      return finished;

    // 2. If code point is in the range U+0000 to U+007F, return a
    // byte whose value is code point.
    if (inRange(code_point, 0x0000, 0x007f))
      return code_point;

    // 3. Set count and offset based on the range code point is in:
    var count, offset;
    // U+0080 to U+07FF:    1 and 0xC0
    if (inRange(code_point, 0x0080, 0x07FF)) {
      count = 1;
      offset = 0xC0;
    }
    // U+0800 to U+FFFF:    2 and 0xE0
    else if (inRange(code_point, 0x0800, 0xFFFF)) {
      count = 2;
      offset = 0xE0;
    }
    // U+10000 to U+10FFFF: 3 and 0xF0
    else if (inRange(code_point, 0x10000, 0x10FFFF)) {
      count = 3;
      offset = 0xF0;
    }

    // 4.Let bytes be a byte sequence whose first byte is (code
    // point >> (6 × count)) + offset.
    var bytes = [(code_point >> (6 * count)) + offset];

    // 5. Run these substeps while count is greater than 0:
    while (count > 0) {

      // 1. Set temp to code point >> (6 × (count − 1)).
      var temp = code_point >> (6 * (count - 1));

      // 2. Append to bytes 0x80 | (temp & 0x3F).
      bytes.push(0x80 | (temp & 0x3F));

      // 3. Decrease count by one.
      count -= 1;
    }

    // 6. Return bytes bytes, in order.
    return bytes;
  };
}

encoding_lib.TextEncoder = TextEncoder;
encoding_lib.TextDecoder = TextDecoder$1;

var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (commonjsGlobal && commonjsGlobal.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(lib$1, "__esModule", { value: true });
var deserializeUnchecked_1 = lib$1.deserializeUnchecked = lib$1.deserialize = lib$1.serialize = lib$1.BinaryReader = lib$1.BinaryWriter = lib$1.BorshError = lib$1.baseDecode = lib$1.baseEncode = void 0;
const bn_js_1 = __importDefault(BN);
const bs58_1 = __importDefault(bs58);
// TODO: Make sure this polyfill not included when not required
const encoding = __importStar(encoding_lib);
const ResolvedTextDecoder = typeof TextDecoder !== "function" ? encoding.TextDecoder : TextDecoder;
const textDecoder = new ResolvedTextDecoder("utf-8", { fatal: true });
function baseEncode(value) {
    if (typeof value === "string") {
        value = Buffer.from(value, "utf8");
    }
    return bs58_1.default.encode(Buffer.from(value));
}
lib$1.baseEncode = baseEncode;
function baseDecode(value) {
    return Buffer.from(bs58_1.default.decode(value));
}
lib$1.baseDecode = baseDecode;
const INITIAL_LENGTH = 1024;
class BorshError extends Error {
    constructor(message) {
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
lib$1.BorshError = BorshError;
/// Binary encoder.
class BinaryWriter {
    constructor() {
        this.buf = Buffer.alloc(INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) {
            this.buf = Buffer.concat([this.buf, Buffer.alloc(INITIAL_LENGTH)]);
        }
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer(Buffer.from(new bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = Buffer.concat([
            Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            Buffer.alloc(INITIAL_LENGTH),
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer(Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array) {
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
lib$1.BinaryWriter = BinaryWriter;
function handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function (...args) {
        try {
            return originalMethod.apply(this, args);
        }
        catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(code) >= 0) {
                    throw new BorshError("Reached the end of buffer when deserializing");
                }
            }
            throw e;
        }
    };
}
class BinaryReader {
    constructor(buf) {
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) {
            throw new BorshError(`Expected buffer length ${len} isn't within bounds`);
        }
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return textDecoder.decode(buf);
        }
        catch (e) {
            throw new BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for (let i = 0; i < len; ++i) {
            result.push(fn());
        }
        return result;
    }
}
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU8", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU16", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU32", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU64", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU128", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU256", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readU512", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readString", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readFixedArray", null);
__decorate([
    handlingRangeError
], BinaryReader.prototype, "readArray", null);
lib$1.BinaryReader = BinaryReader;
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") {
            writer[`write${capitalizeFirstLetter(fieldType)}`](value);
        }
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) {
                    throw new BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                }
                writer.writeFixedArray(value);
            }
            else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) {
                    throw new BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                }
                for (let i = 0; i < fieldType[1]; i++) {
                    serializeField(schema, null, value[i], fieldType[0], writer);
                }
            }
            else {
                writer.writeArray(value, (item) => {
                    serializeField(schema, fieldName, item, fieldType[0], writer);
                });
            }
        }
        else if (fieldType.kind !== undefined) {
            switch (fieldType.kind) {
                case "option": {
                    if (value === null || value === undefined) {
                        writer.writeU8(0);
                    }
                    else {
                        writer.writeU8(1);
                        serializeField(schema, fieldName, value, fieldType.type, writer);
                    }
                    break;
                }
                case "map": {
                    writer.writeU32(value.size);
                    value.forEach((val, key) => {
                        serializeField(schema, fieldName, key, fieldType.key, writer);
                        serializeField(schema, fieldName, val, fieldType.value, writer);
                    });
                    break;
                }
                default:
                    throw new BorshError(`FieldType ${fieldType} unrecognized`);
            }
        }
        else {
            serializeStruct(schema, value, writer);
        }
    }
    catch (error) {
        if (error instanceof BorshError) {
            error.addToFieldPath(fieldName);
        }
        throw error;
    }
}
function serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) {
        throw new BorshError(`Class ${obj.constructor.name} is missing in schema`);
    }
    if (structSchema.kind === "struct") {
        structSchema.fields.map(([fieldName, fieldType]) => {
            serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
        });
    }
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for (let idx = 0; idx < structSchema.values.length; ++idx) {
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    }
    else {
        throw new BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
    }
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function serialize(schema, obj, Writer = BinaryWriter) {
    const writer = new Writer();
    serializeStruct(schema, obj, writer);
    return writer.toArray();
}
lib$1.serialize = serialize;
function deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") {
            return reader[`read${capitalizeFirstLetter(fieldType)}`]();
        }
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                return reader.readFixedArray(fieldType[0]);
            }
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for (let i = 0; i < fieldType[1]; i++) {
                    arr.push(deserializeField(schema, null, fieldType[0], reader));
                }
                return arr;
            }
            else {
                return reader.readArray(() => deserializeField(schema, fieldName, fieldType[0], reader));
            }
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) {
                return deserializeField(schema, fieldName, fieldType.type, reader);
            }
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for (let i = 0; i < length; i++) {
                const key = deserializeField(schema, fieldName, fieldType.key, reader);
                const val = deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return deserializeStruct(schema, fieldType, reader);
    }
    catch (error) {
        if (error instanceof BorshError) {
            error.addToFieldPath(fieldName);
        }
        throw error;
    }
}
function deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") {
        return classType.borshDeserialize(reader);
    }
    const structSchema = schema.get(classType);
    if (!structSchema) {
        throw new BorshError(`Class ${classType.name} is missing in schema`);
    }
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields) {
            result[fieldName] = deserializeField(schema, fieldName, fieldType, reader);
        }
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) {
            throw new BorshError(`Enum index: ${idx} is out of range`);
        }
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = deserializeField(schema, fieldName, fieldType, reader);
        return new classType({ [fieldName]: fieldValue });
    }
    throw new BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function deserialize(schema, classType, buffer, Reader = BinaryReader) {
    const reader = new Reader(buffer);
    const result = deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) {
        throw new BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    }
    return result;
}
lib$1.deserialize = deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function deserializeUnchecked(schema, classType, buffer, Reader = BinaryReader) {
    const reader = new Reader(buffer);
    return deserializeStruct(schema, classType, reader);
}
deserializeUnchecked_1 = lib$1.deserializeUnchecked = deserializeUnchecked;

var Lido = /** @class */ (function () {
    function Lido(data) {
        Object.assign(this, data);
    }
    return Lido;
}());
var SeedRange = /** @class */ (function () {
    function SeedRange(data) {
        Object.assign(this, data);
    }
    return SeedRange;
}());
var ValidatorClass = /** @class */ (function () {
    function ValidatorClass(data) {
        Object.assign(this, data);
    }
    return ValidatorClass;
}());
var PubKeyAndEntry = /** @class */ (function () {
    function PubKeyAndEntry(data) {
        Object.assign(this, data);
    }
    return PubKeyAndEntry;
}());
var PubKeyAndEntryMaintainer = /** @class */ (function () {
    function PubKeyAndEntryMaintainer(data) {
        Object.assign(this, data);
    }
    return PubKeyAndEntryMaintainer;
}());
var RewardDistribution = /** @class */ (function () {
    function RewardDistribution(data) {
        Object.assign(this, data);
    }
    return RewardDistribution;
}());
var FeeRecipients = /** @class */ (function () {
    function FeeRecipients(data) {
        Object.assign(this, data);
    }
    return FeeRecipients;
}());
var Validators = /** @class */ (function () {
    function Validators(data) {
        Object.assign(this, data);
    }
    return Validators;
}());
var Maintainers = /** @class */ (function () {
    function Maintainers(data) {
        Object.assign(this, data);
    }
    return Maintainers;
}());
var ExchangeRate = /** @class */ (function () {
    function ExchangeRate(data) {
        Object.assign(this, data);
    }
    return ExchangeRate;
}());
var Metrics = /** @class */ (function () {
    function Metrics(data) {
        Object.assign(this, data);
    }
    return Metrics;
}());
var LamportsHistogram = /** @class */ (function () {
    function LamportsHistogram(data) {
        Object.assign(this, data);
    }
    return LamportsHistogram;
}());
var WithdrawMetric = /** @class */ (function () {
    function WithdrawMetric(data) {
        Object.assign(this, data);
    }
    return WithdrawMetric;
}());
var AccountList = /** @class */ (function () {
    function AccountList(data) {
        Object.assign(this, data);
    }
    return AccountList;
}());
var ListHeader = /** @class */ (function () {
    function ListHeader(data) {
        Object.assign(this, data);
    }
    return ListHeader;
}());
var accountInfoV1Scheme = new Map([
    [
        ExchangeRate,
        {
            kind: 'struct',
            fields: [
                ['computed_in_epoch', 'u64'],
                ['st_sol_supply', 'u64'],
                ['sol_balance', 'u64'],
            ],
        },
    ],
    [
        LamportsHistogram,
        {
            kind: 'struct',
            fields: [
                ['counts1', 'u64'],
                ['counts2', 'u64'],
                ['counts3', 'u64'],
                ['counts4', 'u64'],
                ['counts5', 'u64'],
                ['counts6', 'u64'],
                ['counts7', 'u64'],
                ['counts8', 'u64'],
                ['counts9', 'u64'],
                ['counts10', 'u64'],
                ['counts11', 'u64'],
                ['counts12', 'u64'],
                ['total', 'u64'],
            ],
        },
    ],
    [
        WithdrawMetric,
        {
            kind: 'struct',
            fields: [
                ['total_st_sol_amount', 'u64'],
                ['total_sol_amount', 'u64'],
                ['count', 'u64'],
            ],
        },
    ],
    [
        Metrics,
        {
            kind: 'struct',
            fields: [
                ['fee_treasury_sol_total', 'u64'],
                ['fee_validation_sol_total', 'u64'],
                ['fee_developer_sol_total', 'u64'],
                ['st_sol_appreciation_sol_total', 'u64'],
                ['fee_treasury_st_sol_total', 'u64'],
                ['fee_validation_st_sol_total', 'u64'],
                ['fee_developer_st_sol_total', 'u64'],
                ['deposit_amount', LamportsHistogram],
                ['withdraw_amount', WithdrawMetric],
            ],
        },
    ],
    [
        SeedRange,
        {
            kind: 'struct',
            fields: [
                ['begin', 'u64'],
                ['end', 'u64'],
            ],
        },
    ],
    [
        ValidatorClass,
        {
            kind: 'struct',
            fields: [
                ['fee_credit', 'u64'],
                ['fee_address', [32]],
                ['stake_seeds', SeedRange],
                ['unstake_seeds', SeedRange],
                ['stake_accounts_balance', 'u64'],
                ['unstake_accounts_balance', 'u64'],
                ['active', 'u8'],
            ],
        },
    ],
    [
        PubKeyAndEntry,
        {
            kind: 'struct',
            fields: [
                ['pubkey', [32]],
                ['entry', ValidatorClass],
            ],
        },
    ],
    [
        PubKeyAndEntryMaintainer,
        {
            kind: 'struct',
            fields: [
                ['pubkey', [32]],
                ['entry', [0]],
            ],
        },
    ],
    [
        RewardDistribution,
        {
            kind: 'struct',
            fields: [
                ['treasury_fee', 'u32'],
                ['validation_fee', 'u32'],
                ['developer_fee', 'u32'],
                ['st_sol_appreciation', 'u32'],
            ],
        },
    ],
    [
        FeeRecipients,
        {
            kind: 'struct',
            fields: [
                ['treasury_account', [32]],
                ['developer_account', [32]],
            ],
        },
    ],
    [
        Validators,
        {
            kind: 'struct',
            fields: [
                ['entries', [PubKeyAndEntry]],
                ['maximum_entries', 'u32'],
            ],
        },
    ],
    [
        Maintainers,
        {
            kind: 'struct',
            fields: [
                ['entries', [PubKeyAndEntryMaintainer]],
                ['maximum_entries', 'u32'],
            ],
        },
    ],
    [
        Lido,
        {
            kind: 'struct',
            fields: [
                ['lido_version', 'u8'],
                ['manager', [32]],
                ['st_sol_mint', [32]],
                ['exchange_rate', ExchangeRate],
                ['sol_reserve_authority_bump_seed', 'u8'],
                ['stake_authority_bump_seed', 'u8'],
                ['mint_authority_bump_seed', 'u8'],
                ['rewards_withdraw_authority_bump_seed', 'u8'],
                ['reward_distribution', RewardDistribution],
                ['fee_recipients', FeeRecipients],
                ['metrics', Metrics],
                ['validators', Validators],
                ['maintainers', Maintainers],
            ],
        },
    ],
]);
var accountInfoV2Scheme = new Map([
    [
        ExchangeRate,
        {
            kind: 'struct',
            fields: [
                ['computed_in_epoch', 'u64'],
                ['st_sol_supply', 'u64'],
                ['sol_balance', 'u64'],
            ],
        },
    ],
    [
        LamportsHistogram,
        {
            kind: 'struct',
            fields: [
                ['counts1', 'u64'],
                ['counts2', 'u64'],
                ['counts3', 'u64'],
                ['counts4', 'u64'],
                ['counts5', 'u64'],
                ['counts6', 'u64'],
                ['counts7', 'u64'],
                ['counts8', 'u64'],
                ['counts9', 'u64'],
                ['counts10', 'u64'],
                ['counts11', 'u64'],
                ['counts12', 'u64'],
                ['total', 'u64'],
            ],
        },
    ],
    [
        WithdrawMetric,
        {
            kind: 'struct',
            fields: [
                ['total_st_sol_amount', 'u64'],
                ['total_sol_amount', 'u64'],
                ['count', 'u64'],
            ],
        },
    ],
    [
        Metrics,
        {
            kind: 'struct',
            fields: [
                ['fee_treasury_sol_total', 'u64'],
                ['fee_validation_sol_total', 'u64'],
                ['fee_developer_sol_total', 'u64'],
                ['st_sol_appreciation_sol_total', 'u64'],
                ['fee_treasury_st_sol_total', 'u64'],
                ['fee_validation_st_sol_total', 'u64'],
                ['fee_developer_st_sol_total', 'u64'],
                ['deposit_amount', LamportsHistogram],
                ['withdraw_amount', WithdrawMetric],
            ],
        },
    ],
    [
        RewardDistribution,
        {
            kind: 'struct',
            fields: [
                ['treasury_fee', 'u32'],
                ['developer_fee', 'u32'],
                ['st_sol_appreciation', 'u32'],
            ],
        },
    ],
    [
        FeeRecipients,
        {
            kind: 'struct',
            fields: [
                ['treasury_account', [32]],
                ['developer_account', [32]],
            ],
        },
    ],
    [
        Lido,
        {
            kind: 'struct',
            fields: [
                ['account_type', 'u8'],
                ['lido_version', 'u8'],
                ['manager', [32]],
                ['st_sol_mint', [32]],
                ['exchange_rate', ExchangeRate],
                ['sol_reserve_authority_bump_seed', 'u8'],
                ['stake_authority_bump_seed', 'u8'],
                ['mint_authority_bump_seed', 'u8'],
                ['reward_distribution', RewardDistribution],
                ['fee_recipients', FeeRecipients],
                ['metrics', Metrics],
                ['validator_list', [32]],
                ['maintainer_list', [32]],
                ['max_commission_percentage', 'u8'],
            ],
        },
    ],
]);
var validatorsSchema = new Map([
    [
        ListHeader,
        {
            kind: 'struct',
            fields: [
                ['account_type', 'u8'],
                ['lido_version', 'u8'],
                ['max_entries', 'u32'],
            ],
        },
    ],
    [
        SeedRange,
        {
            kind: 'struct',
            fields: [
                ['begin', 'u64'],
                ['end', 'u64'],
            ],
        },
    ],
    [
        ValidatorClass,
        {
            kind: 'struct',
            fields: [
                ['vote_account_address', [32]],
                ['stake_seeds', SeedRange],
                ['unstake_seeds', SeedRange],
                ['stake_accounts_balance', 'u64'],
                ['unstake_accounts_balance', 'u64'],
                ['effective_stake_balance', 'u64'],
                ['active', 'u8'],
            ],
        },
    ],
    [
        AccountList,
        {
            kind: 'struct',
            fields: [
                ['header', ListHeader],
                ['entries', [ValidatorClass]],
            ],
        },
    ],
]);
function getAccountInfo() {
    return __awaiter(this, void 0, void 0, function () {
        var solidoInstanceId, accountInfo, deserializedAccountInfo, validators, deserializedAccountInfo, validatorsList, validators, deserializedValidators;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // save answer only for clients
                    if (this.solidoAccountInfo && typeof window !== 'undefined') {
                        return [2 /*return*/, this.solidoAccountInfo];
                    }
                    solidoInstanceId = this.programAddresses.solidoInstanceId;
                    return [4 /*yield*/, this.connection.getAccountInfo(solidoInstanceId)];
                case 1:
                    accountInfo = _b.sent();
                    if (accountInfo === null) {
                        throw new ErrorWrapper({ code: ERROR_CODE.NO_ACCOUNT_INFO });
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 3, , 5]);
                    deserializedAccountInfo = deserializeUnchecked_1(accountInfoV1Scheme, Lido, accountInfo.data);
                    validators = deserializedAccountInfo.validators.entries.map(function (_a) {
                        var entry = _a.entry, pubkey = _a.pubkey;
                        return (__assign$c(__assign$c({ vote_account_address: pubkey }, entry), { 
                            // effective_stake_balance doesn't exist in first version of protocol as a property
                            // https://github.com/lidofinance/solido/blob/4a5fe34b2ecf937344a9dfcd389ffe120e587cfd/program/src/state.rs#L705-L708
                            effective_stake_balance: entry.stake_accounts_balance.sub(entry.unstake_accounts_balance) }));
                    });
                    this.lidoVersion = LidoVersion.v1;
                    this.solidoAccountInfo = {
                        lidoVersion: LidoVersion.v1,
                        accountInfo: deserializedAccountInfo,
                        validators: validators,
                    };
                    return [3 /*break*/, 5];
                case 3:
                    _b.sent();
                    deserializedAccountInfo = deserializeUnchecked_1(accountInfoV2Scheme, Lido, accountInfo.data);
                    validatorsList = new PublicKey(deserializedAccountInfo.validator_list);
                    return [4 /*yield*/, this.connection.getAccountInfo(validatorsList)];
                case 4:
                    validators = _b.sent();
                    if (validators === null) {
                        throw new ErrorWrapper({ code: ERROR_CODE.NO_VALIDATORS });
                    }
                    deserializedValidators = deserializeUnchecked_1(validatorsSchema, AccountList, validators.data);
                    this.lidoVersion = LidoVersion.v2;
                    this.solidoAccountInfo = {
                        lidoVersion: LidoVersion.v2,
                        accountInfo: deserializedAccountInfo,
                        validators: deserializedValidators.entries,
                    };
                    return [3 /*break*/, 5];
                case 5:
                    setTimeout(function () {
                        // clear cache after 7 seconds, in order to avoid outdated data
                        _this.solidoAccountInfo = undefined;
                    }, 7 * 1000);
                    return [2 /*return*/, this.solidoAccountInfo];
            }
        });
    });
}

function calculateMaxUnStakeAmount(address) {
    return __awaiter(this, void 0, void 0, function () {
        var stSolAccount, isUnStakeAvailable, sourceStakeAccount, stakeAccountBalance, maxWithdrawAmount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getStSolAccountsForUser(address)];
                case 1:
                    stSolAccount = (_a.sent())[0];
                    return [4 /*yield*/, this.isUnStakeAvailable()];
                case 2:
                    isUnStakeAvailable = _a.sent();
                    if (!stSolAccount || !isUnStakeAvailable) {
                        return [2 /*return*/, 0];
                    }
                    return [4 /*yield*/, this.calculateStakeAccountAddress()];
                case 3:
                    sourceStakeAccount = _a.sent();
                    return [4 /*yield*/, this.connection.getBalance(sourceStakeAccount)];
                case 4:
                    stakeAccountBalance = _a.sent();
                    maxWithdrawAmount = stakeAccountBalance * 0.1 + 10 * LAMPORTS_PER_SOL;
                    return [2 /*return*/, Math.min(stSolAccount.balanceInLamports, maxWithdrawAmount)];
            }
        });
    });
}

function isUnStakeAvailable() {
    return __awaiter(this, void 0, void 0, function () {
        var validators, areValidatorsEmpty, areExistSomeActiveValidators, isExistOneValidatorWithPositiveBalance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    validators = (_a.sent()).validators;
                    areValidatorsEmpty = validators.length === 0;
                    areExistSomeActiveValidators = validators.some(function (_a) {
                        var active = _a.active;
                        return active;
                    });
                    isExistOneValidatorWithPositiveBalance = validators.some(function (_a) {
                        var effective_stake_balance = _a.effective_stake_balance;
                        return !effective_stake_balance.isZero();
                    });
                    return [2 /*return*/, !areValidatorsEmpty && areExistSomeActiveValidators && isExistOneValidatorWithPositiveBalance];
            }
        });
    });
}

function getExchangeRate(precision) {
    if (precision === void 0) { precision = 4; }
    return __awaiter(this, void 0, void 0, function () {
        var accountInfo, totalSolInLamports, stSolSupplyInLamports, stSOLToSOL, SOLToStSOL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    accountInfo = (_a.sent()).accountInfo;
                    totalSolInLamports = accountInfo.exchange_rate.sol_balance.toNumber();
                    stSolSupplyInLamports = accountInfo.exchange_rate.st_sol_supply.toNumber();
                    stSOLToSOL = totalSolInLamports / stSolSupplyInLamports;
                    SOLToStSOL = stSolSupplyInLamports / totalSolInLamports;
                    return [2 /*return*/, {
                            SOLToStSOL: toPrecision(SOLToStSOL, precision),
                            stSOLToSOL: toPrecision(stSOLToSOL, precision),
                            description: 'Updates at the end of an epoch. Rising exchange rate indicates an appreciation in stSOL value',
                        }];
            }
        });
    });
}

var hasAPIError = function (batchError, error) {
    return !!((batchError && Object.keys(batchError).length > 0) || error);
};

var getSolPrice = function () { return __awaiter(void 0, void 0, void 0, function () {
    var resp, _a, batchData, batchError, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(SOL_API_HOST, "/v1/prices?tokens=SOL"), { mode: 'cors' })];
            case 1:
                resp = _c.sent();
                return [4 /*yield*/, resp.json()];
            case 2:
                _a = (_c.sent()), batchData = _a.batchData, batchError = _a.batchError, error = _a.error;
                if (hasAPIError(batchError, error)) {
                    return [2 /*return*/, 0]; // TODO fallback
                }
                return [2 /*return*/, batchData.SOL.priceUsd];
            case 3:
                _c.sent();
                return [2 /*return*/, 0]; // TODO think fallback
            case 4: return [2 /*return*/];
        }
    });
}); };

function getTransactionCost(instruction) {
    return __awaiter(this, void 0, void 0, function () {
        var lamportsPerSignature, solPriceInUsd, costInLamports, costInSol, costInUsd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.connection.getRecentBlockhash()];
                case 1:
                    lamportsPerSignature = (_a.sent()).feeCalculator.lamportsPerSignature;
                    return [4 /*yield*/, getSolPrice()];
                case 2:
                    solPriceInUsd = _a.sent();
                    costInLamports = instruction * lamportsPerSignature;
                    costInSol = lamportsToSol(costInLamports, 6);
                    costInUsd = toPrecision(costInSol * solPriceInUsd, 5);
                    return [2 /*return*/, { costInUsd: costInUsd, costInSol: costInSol, costInLamports: costInLamports }];
            }
        });
    });
}

function getStakingRewardsFee() {
    return {
        fee: '10%',
        description: 'Please note: This fee applies to staking rewards/earnings only, and is NOT taken from your staked amount. It is a fee on earnings only. This fee is split between node operators, the DAO treasury, and Lido for Solana developers',
    };
}

function getTransactionInfo(instruction) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, exchangeRate, transactionCost, stakingRewardsFee;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        this.getExchangeRate(),
                        this.getTransactionCost(instruction),
                        this.getStakingRewardsFee(),
                    ])];
                case 1:
                    _a = _b.sent(), exchangeRate = _a[0], transactionCost = _a[1], stakingRewardsFee = _a[2];
                    return [2 /*return*/, {
                            exchangeRate: {
                                value: instruction === INSTRUCTION.STAKE ? exchangeRate.SOLToStSOL : exchangeRate.stSOLToSOL,
                                description: exchangeRate.description,
                            },
                            transactionCost: transactionCost,
                            stakingRewardsFee: stakingRewardsFee,
                        }];
            }
        });
    });
}

function getTotalStaked(precision) {
    if (precision === void 0) { precision = 2; }
    return __awaiter(this, void 0, void 0, function () {
        var validators, reserveAccount, reserveAccountInfo, reserveAccountRent, reserveAccountBalanceInLamports, validatorsStakeAccountsBalanceInLamports, totalStakedInLamports;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    validators = (_a.sent()).validators;
                    return [4 /*yield*/, this.findProgramAddress('reserve_account')];
                case 2:
                    reserveAccount = _a.sent();
                    return [4 /*yield*/, this.connection.getAccountInfo(reserveAccount)];
                case 3:
                    reserveAccountInfo = _a.sent();
                    if (reserveAccountInfo === null) {
                        return [2 /*return*/, 0];
                    }
                    return [4 /*yield*/, this.connection.getMinimumBalanceForRentExemption(reserveAccountInfo.data.byteLength)];
                case 4:
                    reserveAccountRent = _a.sent();
                    reserveAccountBalanceInLamports = reserveAccountInfo.lamports - reserveAccountRent;
                    validatorsStakeAccountsBalanceInLamports = validators
                        .map(function (validator) { return validator.stake_accounts_balance.toString(); })
                        .reduce(function (acc, current) { return acc + +current; }, 0);
                    totalStakedInLamports = validatorsStakeAccountsBalanceInLamports + reserveAccountBalanceInLamports;
                    return [2 /*return*/, lamportsToSol(totalStakedInLamports, precision)];
            }
        });
    });
}

var countAccounts = function (connection, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, connection.getProgramAccounts(TOKEN_PROGRAM_ID, {
                    filters: filters,
                    // We are not interested in the account data, only in the number of matching
                    // accounts, so request a zero-sized slice of the data, to reduce the amount
                    // of data that needs to be sent.
                    encoding: 'base64',
                    dataSlice: {
                        offset: 0,
                        length: 0,
                    },
                })];
            case 1:
                accounts = _a.sent();
                return [2 /*return*/, accounts.length];
        }
    });
}); };
function getStakersCount() {
    return __awaiter(this, void 0, void 0, function () {
        var stSolMintAddress, filterSize, filterMint, filterEmpty, accountsTotal, accountsEmpty;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stSolMintAddress = this.programAddresses.stSolMintAddress;
                    filterSize = { dataSize: 165 };
                    filterMint = {
                        memcmp: { bytes: stSolMintAddress.toString(), offset: 0 },
                    };
                    filterEmpty = { memcmp: { bytes: '11111111', offset: 64 } };
                    return [4 /*yield*/, countAccounts(this.connection, [filterSize, filterMint])];
                case 1:
                    accountsTotal = _a.sent();
                    return [4 /*yield*/, countAccounts(this.connection, [filterSize, filterMint, filterEmpty])];
                case 2:
                    accountsEmpty = _a.sent();
                    return [2 /*return*/, {
                            value: accountsTotal - accountsEmpty,
                            description: "We do not and cannot indentify individuals; this number is the number of stSOL token accounts with a non-zero balance. ".concat(accountsTotal && accountsEmpty
                                ? "In total there are ".concat(formatWithCommas(accountsTotal), " stSOL token accounts,\n          but ").concat(formatWithCommas(accountsEmpty), " of those are empty.")
                                : ''),
                            // Additional fields
                            accountsTotal: accountsTotal,
                            accountsEmpty: accountsEmpty,
                        }];
            }
        });
    });
}

function getMarketCap(totalStakedInSol) {
    return __awaiter(this, void 0, void 0, function () {
        var totalStaked, price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    totalStaked = totalStakedInSol;
                    if (!!totalStaked) return [3 /*break*/, 2];
                    return [4 /*yield*/, this.getTotalStaked()];
                case 1:
                    totalStaked = _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, getSolPrice()];
                case 3:
                    price = _a.sent();
                    return [2 /*return*/, Math.ceil(price * totalStaked)];
            }
        });
    });
}

var STATIC_DEFAULT_APY = '5.74'; // TODO think
var getStakeApy = function () { return __awaiter(void 0, void 0, void 0, function () {
    var resp, apy;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(SOL_API_HOST, "/v1/apy?since_launch"), { mode: 'cors' })];
            case 1:
                resp = _b.sent();
                return [4 /*yield*/, resp.json()];
            case 2:
                apy = (_b.sent()).data.apy;
                return [2 /*return*/, apy ? apy.toFixed(2) : STATIC_DEFAULT_APY];
            case 3:
                _b.sent();
                return [2 /*return*/, STATIC_DEFAULT_APY];
            case 4: return [2 /*return*/];
        }
    });
}); };

function getLidoStatistics() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, apy, totalStaked, stakers, marketCap, totalRewards;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        getStakeApy(),
                        this.getTotalStaked(),
                        this.getStakersCount(),
                        this.getMarketCap(),
                        this.getTotalRewards(),
                    ])];
                case 1:
                    _a = _b.sent(), apy = _a[0], totalStaked = _a[1], stakers = _a[2], marketCap = _a[3], totalRewards = _a[4];
                    return [2 /*return*/, {
                            apy: apy,
                            totalStaked: {
                                value: totalStaked,
                                formatted: formatWithCommas(totalStaked),
                            },
                            stakers: __assign$c(__assign$c({}, stakers), { formatted: formatWithCommas(stakers.value) }),
                            marketCap: marketCap,
                            totalRewards: {
                                value: totalRewards,
                                formatted: formatWithCommas(totalRewards),
                            },
                        }];
            }
        });
    });
}

function getTotalRewards(precision) {
    if (precision === void 0) { precision = 2; }
    return __awaiter(this, void 0, void 0, function () {
        var metrics, totalRewards;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getAccountInfo()];
                case 1:
                    metrics = (_a.sent()).accountInfo.metrics;
                    totalRewards = metrics.st_sol_appreciation_sol_total.toNumber();
                    return [2 /*return*/, lamportsToSol(totalRewards, precision)];
            }
        });
    });
}

function getStSolAccountsForUser(owner) {
    return __awaiter(this, void 0, void 0, function () {
        var stSolAccounts, stSolMintAddress, value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stSolAccounts = [];
                    stSolMintAddress = this.programAddresses.stSolMintAddress;
                    return [4 /*yield*/, this.connection.getParsedTokenAccountsByOwner(owner, {
                            mint: stSolMintAddress,
                        })];
                case 1:
                    value = (_a.sent()).value;
                    value.forEach(function (v) {
                        var _a, _b, _c, _d;
                        var address = v.pubkey;
                        var balanceInLamports = parseInt((_d = (_c = (_b = (_a = v.account.data.parsed) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.tokenAmount) === null || _c === void 0 ? void 0 : _c.amount) !== null && _d !== void 0 ? _d : '0', 10);
                        stSolAccounts.push({ address: address, balanceInLamports: balanceInLamports });
                    });
                    return [2 /*return*/, stSolAccounts];
            }
        });
    });
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$p(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$b = function() {
    __assign$b = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};

var ArrowBack = /*#__PURE__*/React.forwardRef(function ArrowBack(props, svgRef) {
  return jsx("svg", __assign$b({
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    ref: svgRef
  }, props, {
    children: jsx("path", {
      d: 'M20 12H4m6 6l-6-6 6-6',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 2,
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }, void 0)
  }), void 0);
});
var ArrowBottom = /*#__PURE__*/React.forwardRef(function ArrowBottom(props, svgRef) {
  return jsx("svg", __assign$b({
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    ref: svgRef
  }, props, {
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.707 9.293a1 1 0 00-1.414 0L12 12.586 8.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l4-4a1 1 0 000-1.414z'
    }, void 0)
  }), void 0);
});
var Check = /*#__PURE__*/React.forwardRef(function Check(props, svgRef) {
  return jsx("svg", __assign$b({
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    ref: svgRef
  }, props, {
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.434 8.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0L7.293 12.98a1 1 0 111.414-1.414l2.02 2.02 5.293-5.293a1 1 0 011.414 0z'
    }, void 0)
  }), void 0);
});
var Close = /*#__PURE__*/React.forwardRef(function Close(props, svgRef) {
  return jsx("svg", __assign$b({
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    ref: svgRef
  }, props, {
    children: jsx("path", {
      d: 'M17.707 7.707a1 1 0 00-1.414-1.414L12 10.586 7.707 6.293a1 1 0 00-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 101.414 1.414L12 13.414l4.293 4.293a1 1 0 001.414-1.414L13.414 12l4.293-4.293z'
    }, void 0)
  }), void 0);
});
var Question = /*#__PURE__*/React.forwardRef(function Question(props, svgRef) {
  return jsxs("svg", __assign$b({
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    ref: svgRef
  }, props, {
    children: [jsx("path", {
      d: 'M12.188 9.109a1.455 1.455 0 00-1.618.95.727.727 0 01-1.372-.482 2.91 2.91 0 015.653.97c0 1.112-.826 1.847-1.415 2.24a5.64 5.64 0 01-1.262.63.735.735 0 01-.922-.46.727.727 0 01.46-.92c.322-.113.633-.271.917-.46.502-.335.767-.69.767-1.032a1.454 1.454 0 00-1.208-1.436zM12 15.636a.727.727 0 100-1.454.727.727 0 000 1.454z'
    }, void 0), jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-6.545a6.545 6.545 0 100 13.09 6.545 6.545 0 000-13.09z'
    }, void 0)]
  }), void 0);
});

styled.div.withConfig({
  displayName: "AccordionStyles__AccordionStyle",
  componentId: "sc-11dasyk-0"
})(templateObject_1$E || (templateObject_1$E = __makeTemplateObject$p(["\n  margin: 0 0 ", "px 0;\n  background: ", ";\n  border-radius: ", "px;\n"], ["\n  margin: 0 0 ", "px 0;\n  background: ", ";\n  border-radius: ", "px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.foreground;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.xl;
});
styled.div.withConfig({
  displayName: "AccordionStyles__AccordionSummaryStyle",
  componentId: "sc-11dasyk-1"
})(templateObject_2$t || (templateObject_2$t = __makeTemplateObject$p(["\n  padding: ", "px\n    ", "px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none;\n  min-height: 40px;\n  box-sizing: content-box;\n\n  ", " {\n    padding: ", "px;\n  }\n"], ["\n  padding: ", "px\n    ", "px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none;\n  min-height: 40px;\n  box-sizing: content-box;\n\n  ", " {\n    padding: ", "px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.mediaQueries.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
});
styled.div.withConfig({
  displayName: "AccordionStyles__AccordionTitleStyle",
  componentId: "sc-11dasyk-2"
})(templateObject_3$m || (templateObject_3$m = __makeTemplateObject$p(["\n  color: ", ";\n  flex-grow: 1;\n  font-weight: 800;\n  font-size: ", "px;\n  line-height: 1.6em;\n"], ["\n  color: ", ";\n  flex-grow: 1;\n  font-weight: 800;\n  font-size: ", "px;\n  line-height: 1.6em;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xs;
});
styled(ArrowBottom).withConfig({
  displayName: "AccordionStyles__AccordionArrowStyle",
  componentId: "sc-11dasyk-3"
})(templateObject_4$e || (templateObject_4$e = __makeTemplateObject$p(["\n  flex-shrink: 0;\n  transform: rotate(", "deg);\n  transition: transform ", " ease;\n  margin: -2px;\n  margin-left: ", "px;\n  fill: ", ";\n"], ["\n  flex-shrink: 0;\n  transform: rotate(", "deg);\n  transition: transform ", " ease;\n  margin: -2px;\n  margin-left: ", "px;\n  fill: ", ";\n"])), function (props) {
  return props.$expanded ? 180 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.duration.norm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
});
styled.div.withConfig({
  displayName: "AccordionStyles__AccordionContentStyle",
  componentId: "sc-11dasyk-4"
})(templateObject_5$b || (templateObject_5$b = __makeTemplateObject$p(["\n  color: ", ";\n  padding: ", "px;\n  padding-top: 0;\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n\n  ", " {\n    padding: ", "px;\n    padding-top: 0;\n  }\n\n  p,\n  ul,\n  ol {\n    margin: 0 0 1.6em 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0 0 0 1.5em;\n  }\n"], ["\n  color: ", ";\n  padding: ", "px;\n  padding-top: 0;\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n\n  ", " {\n    padding: ", "px;\n    padding-top: 0;\n  }\n\n  p,\n  ul,\n  ol {\n    margin: 0 0 1.6em 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0 0 0 1.5em;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
}, function (_a) {
  var theme = _a.theme;
  return theme.mediaQueries.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
});
var templateObject_1$E, templateObject_2$t, templateObject_3$m, templateObject_4$e, templateObject_5$b;

process.env.NODE_ENV === 'production';

var raf$1 = {exports: {}};

var performanceNow = {exports: {}};

// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    performanceNow.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    performanceNow.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    performanceNow.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);

var now = performanceNow.exports
  , root = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue$1 = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue$1.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function() {
        var cp = queue$1.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue$1.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue$1.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };

  caf = function(handle) {
    for(var i = 0; i < queue$1.length; i++) {
      if(queue$1[i].handle === handle) {
        queue$1[i].cancelled = true;
      }
    }
  };
}

raf$1.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
};
raf$1.exports.cancel = function() {
  caf.apply(root, arguments);
};
raf$1.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$o(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.div.withConfig({
  displayName: "AddressStyles__AddressStyle",
  componentId: "sc-1qik15u-0"
})(templateObject_1$D || (templateObject_1$D = __makeTemplateObject$o(["\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n"], ["\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n"])));
styled.span.withConfig({
  displayName: "AddressStyles__AddressFullStyle",
  componentId: "sc-1qik15u-1"
})(templateObject_2$s || (templateObject_2$s = __makeTemplateObject$o(["\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  color: transparent;\n"], ["\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  color: transparent;\n"])));
styled.span.withConfig({
  displayName: "AddressStyles__AddressTrimmedStyle",
  componentId: "sc-1qik15u-2"
})(templateObject_3$l || (templateObject_3$l = __makeTemplateObject$o(["\n  user-select: none;\n  pointer-events: none;\n"], ["\n  user-select: none;\n  pointer-events: none;\n"])));
var templateObject_1$D, templateObject_2$s, templateObject_3$l;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$n(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var colors$5 = {
  foreground: css$1(templateObject_1$C || (templateObject_1$C = __makeTemplateObject$n(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.foreground;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }),
  background: css$1(templateObject_2$r || (templateObject_2$r = __makeTemplateObject$n(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }),
  accent: css$1(templateObject_3$k || (templateObject_3$k = __makeTemplateObject$n(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.accent;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentContrast;
  })
};
var variants$2 = {
  flat: css$1(templateObject_4$d || (templateObject_4$d = __makeTemplateObject$n(["\n    box-shadow: none;\n  "], ["\n    box-shadow: none;\n  "]))),
  shadow: css$1(templateObject_5$a || (templateObject_5$a = __makeTemplateObject$n(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.boxShadows.lg + " " + theme.colors.shadowLight;
  })
};
var paddings = css$1(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject$n(["\n  padding: ", "px;\n\n  ", " {\n    padding: ", "px;\n  }\n"], ["\n  padding: ", "px;\n\n  ", " {\n    padding: ", "px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.mediaQueries.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
});
styled.div.withConfig({
  displayName: "BlockStyles__BlockStyle",
  componentId: "sc-x6m4g3-0"
})(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject$n(["\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n  border-radius: ", "px;\n  margin: 0;\n\n  ", "\n\n  ", "\n  ", "\n"], ["\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n  border-radius: ", "px;\n  margin: 0;\n\n  ", "\n\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.xl;
}, function (_a) {
  var $paddingLess = _a.$paddingLess;
  return !$paddingLess && paddings;
}, function (_a) {
  var $variant = _a.$variant;
  return variants$2[$variant];
}, function (_a) {
  var $color = _a.$color;
  return colors$5[$color];
});
var templateObject_1$C, templateObject_2$r, templateObject_3$k, templateObject_4$d, templateObject_5$a, templateObject_6$8, templateObject_7$8;

var BlockVariant;

(function (BlockVariant) {
  BlockVariant[BlockVariant["flat"] = 0] = "flat";
  BlockVariant[BlockVariant["shadow"] = 1] = "shadow";
})(BlockVariant || (BlockVariant = {}));

var BlockColor;

(function (BlockColor) {
  BlockColor[BlockColor["foreground"] = 0] = "foreground";
  BlockColor[BlockColor["background"] = 1] = "background";
  BlockColor[BlockColor["accent"] = 2] = "accent";
})(BlockColor || (BlockColor = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$m(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index$1 = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$4 = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get$1(scale, n, n);
};

var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get$1(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$1(props.theme, 'breakpoints', defaults$4.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get$1(scale, n, !isNumber$1(n) || n > 1 ? n : n * 100 + '%');
};

var config$8 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$8);

var config$7 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$7.bg = config$7.backgroundColor;
var color$1 = system(config$7);

var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$6 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography$1 = system(config$6);

var config$5 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$5);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$4 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$4);

var config$3 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$3.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$3.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$3.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$3.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$3.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$3.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$3.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$3.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$3.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$3.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$3.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$3.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$3.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$3.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$3.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$3.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$3);

var config$2 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$2.bgImage = config$2.backgroundImage;
config$2.bgSize = config$2.backgroundSize;
config$2.bgPosition = config$2.backgroundPosition;
config$2.bgRepeat = config$2.backgroundRepeat;
var background = system(config$2);

var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$1 = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$1.space
  }
};
var position = system(config$1);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber(n)) {
    return get$1(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$1(scale, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space$1 = compose(margin, padding);

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$4({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$4({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get(theme, val))(theme);
        result = _extends$4({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(get$1(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get$1(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

layout.width;
    layout.height;
    layout.minWidth;
    layout.minHeight;
    layout.maxWidth;
    layout.maxHeight;
    layout.size;
    layout.verticalAlign;
    layout.display;
    layout.overflow;
    layout.overflowX;
    layout.overflowY;
color$1.opacity;
typography$1.fontSize;
    typography$1.fontFamily;
    typography$1.fontWeight;
    typography$1.lineHeight;
    typography$1.textAlign;
    typography$1.fontStyle;
    typography$1.letterSpacing;
flexbox.alignItems;
    flexbox.alignContent;
    flexbox.justifyItems;
    flexbox.justifyContent;
    flexbox.flexWrap;
    flexbox.flexDirection;
    flexbox.flex;
    flexbox.flexGrow;
    flexbox.flexShrink;
    flexbox.flexBasis;
    flexbox.justifySelf;
    flexbox.alignSelf;
    flexbox.order;
grid.gridGap;
    grid.gridColumnGap;
    grid.gridRowGap;
    grid.gridColumn;
    grid.gridRow;
    grid.gridAutoFlow;
    grid.gridAutoColumns;
    grid.gridAutoRows;
    grid.gridTemplateColumns;
    grid.gridTemplateRows;
    grid.gridTemplateAreas;
    grid.gridArea;
border.borderWidth;
    border.borderStyle;
    border.borderColor;
    border.borderTop;
    border.borderRight;
    border.borderBottom;
    border.borderLeft;
    border.borderRadius;
background.backgroundImage;
    background.backgroundSize;
    background.backgroundPosition;
    background.backgroundRepeat;
position.zIndex;
    position.top;
    position.right;
    position.bottom;
    position.left;

var all = compose(space$1, typography$1, color$1, layout, flexbox, border, background, position, grid, shadow, buttonStyle, textStyle, colorStyle);
var props = all.propNames;
var createShouldForwardProp = function createShouldForwardProp(props) {
  var regex = new RegExp("^(" + props.join('|') + ")$");
  return memoize$1(function (prop) {
    return index$1(prop) && !regex.test(prop);
  });
};
var shouldForwardProp = createShouldForwardProp(props);

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

function withStyledSystem(Component) {
  return styled(Component).withConfig({
    shouldForwardProp: shouldForwardProp,
    displayName: "withStyledSystem",
    componentId: "sc-16nltcn-0"
  })(compose(space$1, color$1, typography$1, layout, flexbox, grid, background, border, position, shadow));
}

var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "sc-7k2blr-0"
})(templateObject_1$B || (templateObject_1$B = __makeTemplateObject$m([""], [""])));
var Box$1 = withStyledSystem(Box);
var templateObject_1$B;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$a = function() {
    __assign$a = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};

function __rest$7(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$l(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$9 = function() {
    __assign$9 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};

function __rest$6(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$k(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var LoaderSize;

(function (LoaderSize) {
  LoaderSize[LoaderSize["small"] = 18] = "small";
  LoaderSize[LoaderSize["medium"] = 24] = "medium";
  LoaderSize[LoaderSize["large"] = 64] = "large";
})(LoaderSize || (LoaderSize = {}));

var LoaderColor;

(function (LoaderColor) {
  LoaderColor[LoaderColor["primary"] = 0] = "primary";
  LoaderColor[LoaderColor["secondary"] = 1] = "secondary";
  LoaderColor[LoaderColor["foreground"] = 2] = "foreground";
  LoaderColor[LoaderColor["success"] = 3] = "success";
})(LoaderColor || (LoaderColor = {}));

var InlineLoaderColor;

(function (InlineLoaderColor) {
  InlineLoaderColor[InlineLoaderColor["text"] = 0] = "text";
  InlineLoaderColor[InlineLoaderColor["secondary"] = 1] = "secondary";
  InlineLoaderColor[InlineLoaderColor["foreground"] = 2] = "foreground";
})(InlineLoaderColor || (InlineLoaderColor = {}));

var rotation = keyframes(templateObject_1$A || (templateObject_1$A = __makeTemplateObject$k(["\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var LoaderStyle = styled.div.withConfig({
  displayName: "LoaderStyles__LoaderStyle",
  componentId: "sc-m2fc6z-0"
})(templateObject_2$q || (templateObject_2$q = __makeTemplateObject$k(["\n  margin: 0;\n  padding: 0;\n  line-height: 0;\n  width: ", "px;\n  height: ", "px;\n  color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  line-height: 0;\n  width: ", "px;\n  height: ", "px;\n  color: ", ";\n"])), function (props) {
  return props.$size;
}, function (props) {
  return props.$size;
}, function (_a) {
  var theme = _a.theme,
      $color = _a.$color;
  return theme.colors[$color];
});
var LoaderCircleBgStyle = styled.circle.withConfig({
  displayName: "LoaderStyles__LoaderCircleBgStyle",
  componentId: "sc-m2fc6z-1"
})(templateObject_3$j || (templateObject_3$j = __makeTemplateObject$k(["\n  fill: none;\n  stroke: currentColor;\n  stroke-width: ", ";\n  opacity: 0.2;\n"], ["\n  fill: none;\n  stroke: currentColor;\n  stroke-width: ", ";\n  opacity: 0.2;\n"])), function (props) {
  return props.$thickness;
});
var LoaderCircleFgStyle = styled.circle.withConfig({
  displayName: "LoaderStyles__LoaderCircleFgStyle",
  componentId: "sc-m2fc6z-2"
})(templateObject_4$c || (templateObject_4$c = __makeTemplateObject$k(["\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: ", ";\n  stroke-dasharray: ", ";\n  transform: rotate(0deg);\n  transform-origin: 50% 50%;\n  animation: ", " 1.4s linear infinite;\n"], ["\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: ", ";\n  stroke-dasharray: ", ";\n  transform: rotate(0deg);\n  transform-origin: 50% 50%;\n  animation: ", " 1.4s linear infinite;\n"])), function (props) {
  return props.$thickness;
}, function (props) {
  var circumference = 2 * props.r * Math.PI;
  var filledPart = 0.25;
  return circumference * filledPart + " " + circumference * (1 - filledPart);
}, rotation);
var templateObject_1$A, templateObject_2$q, templateObject_3$j, templateObject_4$c;

function Loader(props, ref) {
  var _a = props.size,
      size = _a === void 0 ? 'medium' : _a,
      _b = props.thickness,
      thickness = _b === void 0 ? 3 : _b,
      _c = props.color,
      color = _c === void 0 ? 'primary' : _c,
      rest = __rest$6(props, ["size", "thickness", "color"]);

  var pxSize = LoaderSize[size];
  var center = pxSize / 2;
  var radius = pxSize / 2 - thickness / 2;
  return jsx(LoaderStyle, __assign$9({
    "$size": pxSize,
    "$color": color
  }, rest, {
    ref: ref
  }, {
    children: jsxs("svg", __assign$9({
      width: pxSize,
      height: pxSize,
      viewBox: "0 0 " + pxSize + " " + pxSize
    }, {
      children: [jsx(LoaderCircleBgStyle, {
        "$thickness": thickness,
        cx: center,
        cy: center,
        r: radius
      }, void 0), jsx(LoaderCircleFgStyle, {
        "$thickness": thickness,
        cx: center,
        cy: center,
        r: radius
      }, void 0)]
    }), void 0)
  }), void 0);
}

var Loader$1 = /*#__PURE__*/forwardRef(Loader);

var translation = keyframes(templateObject_1$z || (templateObject_1$z = __makeTemplateObject$k(["\n  100% {\n    background-position: 0 0;\n  }\n"], ["\n  100% {\n    background-position: 0 0;\n  }\n"])));
styled.span.withConfig({
  displayName: "InlineLoaderStyles__InlineLoaderStyle",
  componentId: "sc-zlo4k8-0"
})(templateObject_2$p || (templateObject_2$p = __makeTemplateObject$k(["\n  --loader-color: ", ";\n\n  width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1000px;\n  position: relative;\n  overflow: hidden;\n  user-select: none;\n  opacity: 0.05;\n  animation: ", " 2s infinite;\n  background-size: 300% 100%;\n  background-position: 100% 0;\n  background-image: linear-gradient(\n    90deg,\n    var(--loader-color) 0,\n    var(--loader-color) 33.33%,\n    transparent 44.44%,\n    transparent 55.55%,\n    var(--loader-color) 66.66%,\n    var(--loader-color) 100%\n  );\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: var(--loader-color);\n    opacity: 0.2;\n  }\n"], ["\n  --loader-color: ", ";\n\n  width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1000px;\n  position: relative;\n  overflow: hidden;\n  user-select: none;\n  opacity: 0.05;\n  animation: ", " 2s infinite;\n  background-size: 300% 100%;\n  background-position: 100% 0;\n  background-image: linear-gradient(\n    90deg,\n    var(--loader-color) 0,\n    var(--loader-color) 33.33%,\n    transparent 44.44%,\n    transparent 55.55%,\n    var(--loader-color) 66.66%,\n    var(--loader-color) 100%\n  );\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: var(--loader-color);\n    opacity: 0.2;\n  }\n"])), function (_a) {
  var theme = _a.theme,
      $color = _a.$color;
  return $color ? theme.colors[$color] : 'currentColor';
}, translation);
var templateObject_1$z, templateObject_2$p;

var sizes$3 = {
  xxs: css$1(templateObject_1$y || (templateObject_1$y = __makeTemplateObject$l(["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "], ["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxxs;
  }, function (_a) {
    var theme = _a.theme;
    return theme.borderRadiusesMap.sm;
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '11px' : '11px 16px';
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '0' : '50px';
  }),
  xs: css$1(templateObject_2$o || (templateObject_2$o = __makeTemplateObject$l(["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "], ["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxs;
  }, function (_a) {
    var theme = _a.theme;
    return theme.borderRadiusesMap.sm;
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '10px' : '10px 16px';
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '0' : '60px';
  }),
  sm: css$1(templateObject_3$i || (templateObject_3$i = __makeTemplateObject$l(["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "], ["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xs;
  }, function (_a) {
    var theme = _a.theme;
    return theme.borderRadiusesMap.sm;
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '16px' : '16px 24px';
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '0' : '100px';
  }),
  md: css$1(templateObject_4$b || (templateObject_4$b = __makeTemplateObject$l(["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "], ["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    padding: ", ";\n    min-width: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xs;
  }, function (_a) {
    var theme = _a.theme;
    return theme.borderRadiusesMap.lg;
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '21px' : '21px 44px';
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '0' : '120px';
  }),
  lg: css$1(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject$l(["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    box-shadow: ", ";\n    padding: ", ";\n    min-width: ", ";\n  "], ["\n    line-height: 1em;\n    font-size: ", "px;\n    border-radius: ", "px;\n    box-shadow: ", ";\n    padding: ", ";\n    min-width: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.sm;
  }, function (_a) {
    var theme = _a.theme;
    return theme.borderRadiusesMap.lg;
  }, function (_a) {
    var theme = _a.theme;
    return theme.boxShadows.md + " " + theme.colors.shadowDark;
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '24px' : '24px 64px';
  }, function (_a) {
    var $square = _a.$square;
    return $square ? '0' : '160px';
  })
};

var getMainColor = function getMainColor(props) {
  var colorsMap = {
    primary: props.theme.colors.primary,
    secondary: props.theme.colors.secondary,
    warning: props.theme.colors.warning,
    error: props.theme.colors.error,
    success: props.theme.colors.success
  };
  return colorsMap[props.$color];
};

var getContrastColor = function getContrastColor(props) {
  var colorsMap = {
    primary: props.theme.colors.primaryContrast,
    secondary: props.theme.colors.secondaryContrast,
    warning: props.theme.colors.warningContrast,
    error: props.theme.colors.errorContrast,
    success: props.theme.colors.successContrast
  };
  return colorsMap[props.$color];
};

var getHoverColor = function getHoverColor(props) {
  var colorsMap = {
    primary: props.theme.colors.primaryHover,
    secondary: props.theme.colors.secondaryHover,
    warning: props.theme.colors.warningHover,
    error: props.theme.colors.errorHover,
    success: props.theme.colors.successHover
  };
  return colorsMap[props.$color];
};

var variants$1 = {
  filled: css$1(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject$l(["\n    color: ", ";\n    background-color: ", ";\n    transition: background-color ", " ease;\n\n    :not(:disabled):hover,\n    :focus-visible {\n      background-color: ", ";\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    transition: background-color ", " ease;\n\n    :not(:disabled):hover,\n    :focus-visible {\n      background-color: ", ";\n    }\n  "])), getContrastColor, getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  }, getHoverColor),
  outlined: css$1(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject$l(["\n    color: ", ";\n    transition: background-color ", " ease,\n      color ", " ease;\n\n    :before {\n      display: block;\n      border: 1px solid ", ";\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      background-color: ", ";\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    transition: background-color ", " ease,\n      color ", " ease;\n\n    :before {\n      display: block;\n      border: 1px solid ", ";\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      background-color: ", ";\n      color: ", ";\n    }\n  "])), getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  }, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  }, getMainColor, getHoverColor, getContrastColor),
  text: css$1(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject$l(["\n    color: ", ";\n    background-color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.1;\n      }\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.1;\n      }\n    }\n  "])), getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.colors.foreground;
  }, getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  }),
  ghost: css$1(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject$l(["\n    color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.1;\n      }\n    }\n  "], ["\n    color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.1;\n      }\n    }\n  "])), getMainColor, getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  }),
  translucent: css$1(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject$l(["\n    color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0.1;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.2;\n      }\n    }\n  "], ["\n    color: ", ";\n\n    :before {\n      display: block;\n      background-color: ", ";\n      transition: opacity ", " ease;\n      opacity: 0.1;\n    }\n\n    :not(:disabled):hover,\n    :focus-visible {\n      :before {\n        opacity: 0.2;\n      }\n    }\n  "])), getMainColor, getMainColor, function (_a) {
    var theme = _a.theme;
    return theme.duration.fast;
  })
};
var ButtonStyle = styled.button.withConfig({
  displayName: "ButtonStyles__ButtonStyle",
  componentId: "sc-gzfh1w-0"
})(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject$l(["\n  box-sizing: border-box;\n  margin: 0;\n  border: none;\n  outline: none;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  background: transparent;\n  font-family: inherit;\n  font-weight: 700;\n  width: ", ";\n\n  :before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    display: none;\n  }\n\n  :not(:disabled) {\n    cursor: pointer;\n  }\n\n  :disabled {\n    opacity: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  box-sizing: border-box;\n  margin: 0;\n  border: none;\n  outline: none;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  background: transparent;\n  font-family: inherit;\n  font-weight: 700;\n  width: ", ";\n\n  :before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    display: none;\n  }\n\n  :not(:disabled) {\n    cursor: pointer;\n  }\n\n  :disabled {\n    opacity: ", ";\n  }\n\n  ", "\n  ", "\n"])), function (_a) {
  var $fullwidth = _a.$fullwidth;
  return $fullwidth ? ' 100%' : 'auto';
}, function (_a) {
  var $loading = _a.$loading;
  return $loading ? 1 : 0.5;
}, function (props) {
  return sizes$3[props.$size];
}, function (props) {
  return variants$1[props.$variant];
});
var ripple = keyframes(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject$l(["\n  to {\n    transform: scale(4);\n    opacity: 0;\n  }\n"], ["\n  to {\n    transform: scale(4);\n    opacity: 0;\n  }\n"])));
var ButtonRippleStyle = styled.span.withConfig({
  displayName: "ButtonStyles__ButtonRippleStyle",
  componentId: "sc-gzfh1w-1"
})(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject$l(["\n  position: absolute;\n  border-radius: 50%;\n  transform: scale(0);\n  pointer-events: none;\n  animation: ", " 0.8s linear;\n  background-color: currentColor;\n  opacity: 0.4;\n"], ["\n  position: absolute;\n  border-radius: 50%;\n  transform: scale(0);\n  pointer-events: none;\n  animation: ", " 0.8s linear;\n  background-color: currentColor;\n  opacity: 0.4;\n"])), ripple);
var ButtonContentStyle$1 = styled.span.withConfig({
  displayName: "ButtonStyles__ButtonContentStyle",
  componentId: "sc-gzfh1w-2"
})(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject$l(["\n  position: relative;\n  pointer-events: none;\n  visibility: ", ";\n"], ["\n  position: relative;\n  pointer-events: none;\n  visibility: ", ";\n"])), function (_a) {
  var $hidden = _a.$hidden;
  return $hidden ? 'hidden' : 'visible';
});
var ButtonLoaderStyle = styled(Loader$1).withConfig({
  displayName: "ButtonStyles__ButtonLoaderStyle",
  componentId: "sc-gzfh1w-3"
})(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject$l(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: currentColor;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: currentColor;\n  pointer-events: none;\n"])));
var templateObject_1$y, templateObject_2$o, templateObject_3$i, templateObject_4$b, templateObject_5$9, templateObject_6$7, templateObject_7$7, templateObject_8$6, templateObject_9$3, templateObject_10$3, templateObject_11$2, templateObject_12$2, templateObject_13$2, templateObject_14$2, templateObject_15$2;

var useRipple = function useRipple(_a) {
  var onClick = _a.onClick;

  var _b = useState(null),
      ripple = _b[0],
      setRipple = _b[1];

  var handleClick = useCallback(function (event) {
    var button = event.currentTarget;
    var rect = button.getBoundingClientRect();
    var diameter = Math.max(button.clientWidth, button.clientHeight);
    var radius = diameter / 2;
    var isMouseClick = event.clientX > 0 && event.clientY > 0;
    var x = isMouseClick ? event.clientX - rect.left : button.clientWidth / 2;
    var y = isMouseClick ? event.clientY - rect.top : button.clientHeight / 2;
    var style = {
      width: diameter,
      height: diameter,
      left: x - radius,
      top: y - radius
    };
    setRipple(jsx(ButtonRippleStyle, {
      style: style
    }, event.timeStamp));
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [onClick]);
  return {
    ripple: ripple,
    handleClick: handleClick
  };
};

var loaderSizes = {
  xxs: 'small',
  xs: 'small',
  sm: 'small',
  md: 'medium',
  lg: 'medium'
};

function Button(props, ref) {
  var _a = props.size,
      size = _a === void 0 ? 'md' : _a,
      _b = props.variant,
      variant = _b === void 0 ? 'filled' : _b,
      _c = props.color,
      color = _c === void 0 ? 'primary' : _c,
      _d = props.square,
      square = _d === void 0 ? false : _d,
      _e = props.fullwidth,
      fullwidth = _e === void 0 ? false : _e,
      _f = props.loading,
      loading = _f === void 0 ? false : _f,
      _g = props.active,
      active = _g === void 0 ? false : _g;
      props.onClick;
      var disabled = props.disabled,
      children = props.children,
      rest = __rest$7(props, ["size", "variant", "color", "square", "fullwidth", "loading", "active", "onClick", "disabled", "children"]);

  var _h = useRipple(props),
      handleClick = _h.handleClick,
      ripple = _h.ripple;

  var loaderSize = loaderSizes[size];
  return jsxs(ButtonStyle, __assign$a({
    "$size": size,
    "$variant": variant,
    "$fullwidth": fullwidth,
    "$color": color,
    "$square": square,
    "$loading": loading,
    "$active": active,
    onClick: handleClick,
    disabled: disabled || loading,
    type: 'button',
    ref: ref
  }, rest, {
    children: [jsx(ButtonContentStyle$1, __assign$a({
      "$hidden": loading
    }, {
      children: children
    }), void 0), loading && jsx(ButtonLoaderStyle, {
      size: loaderSize
    }, void 0), !active && ripple]
  }), void 0);
}

var Button$1 = /*#__PURE__*/forwardRef(Button);

var ButtonWrapperStyle = styled.span.withConfig({
  displayName: "ButtonIconStyles__ButtonWrapperStyle",
  componentId: "sc-1nsrifu-0"
})(templateObject_1$x || (templateObject_1$x = __makeTemplateObject$l(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1em;\n  min-width: 1em;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1em;\n  min-width: 1em;\n"])));
var ButtonIconStyle = styled.span.withConfig({
  displayName: "ButtonIconStyles__ButtonIconStyle",
  componentId: "sc-1nsrifu-1"
})(templateObject_2$n || (templateObject_2$n = __makeTemplateObject$l(["\n  margin: ", ";\n  line-height: 0;\n  flex-shrink: 0;\n\n  svg {\n    fill: currentColor;\n  }\n"], ["\n  margin: ", ";\n  line-height: 0;\n  flex-shrink: 0;\n\n  svg {\n    fill: currentColor;\n  }\n"])), function (_a) {
  var $square = _a.$square;
  return $square ? '-12px' : '-12px -6px';
});
var ButtonContentStyle = styled.span.withConfig({
  displayName: "ButtonIconStyles__ButtonContentStyle",
  componentId: "sc-1nsrifu-2"
})(templateObject_3$h || (templateObject_3$h = __makeTemplateObject$l(["\n  margin-left: 10px;\n\n  :empty {\n    display: none;\n  }\n"], ["\n  margin-left: 10px;\n\n  :empty {\n    display: none;\n  }\n"])));
var templateObject_1$x, templateObject_2$n, templateObject_3$h;

function ButtonIcon(props, ref) {
  var icon = props.icon,
      children = props.children,
      rest = __rest$7(props, ["icon", "children"]);

  var hasNoChildren = !children;
  return jsx(Button$1, __assign$a({
    square: hasNoChildren
  }, rest, {
    ref: ref
  }, {
    children: jsxs(ButtonWrapperStyle, {
      children: [jsx(ButtonIconStyle, __assign$a({
        "$square": hasNoChildren
      }, {
        children: icon
      }), void 0), jsx(ButtonContentStyle, {
        children: children
      }, void 0)]
    }, void 0)
  }), void 0);
}

var ButtonIcon$1 = /*#__PURE__*/forwardRef(ButtonIcon);

var ButtonSize;

(function (ButtonSize) {
  ButtonSize[ButtonSize["xxs"] = 0] = "xxs";
  ButtonSize[ButtonSize["xs"] = 1] = "xs";
  ButtonSize[ButtonSize["sm"] = 2] = "sm";
  ButtonSize[ButtonSize["md"] = 3] = "md";
  ButtonSize[ButtonSize["lg"] = 4] = "lg";
})(ButtonSize || (ButtonSize = {}));

var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant[ButtonVariant["filled"] = 0] = "filled";
  ButtonVariant[ButtonVariant["outlined"] = 1] = "outlined";
  ButtonVariant[ButtonVariant["text"] = 2] = "text";
  ButtonVariant[ButtonVariant["ghost"] = 3] = "ghost";
  ButtonVariant[ButtonVariant["translucent"] = 4] = "translucent";
})(ButtonVariant || (ButtonVariant = {}));

var ButtonColor;

(function (ButtonColor) {
  ButtonColor[ButtonColor["primary"] = 0] = "primary";
  ButtonColor[ButtonColor["secondary"] = 1] = "secondary";
  ButtonColor[ButtonColor["warning"] = 2] = "warning";
  ButtonColor[ButtonColor["error"] = 3] = "error";
  ButtonColor[ButtonColor["success"] = 4] = "success";
})(ButtonColor || (ButtonColor = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$j(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.label.withConfig({
  displayName: "CheckboxStyles__CheckboxWrapperStyle",
  componentId: "sc-1wrjkg7-0"
})(templateObject_1$w || (templateObject_1$w = __makeTemplateObject$j(["\n  flex-shrink: 0;\n  display: inline-flex;\n  position: relative;\n  overflow: hidden;\n  line-height: 0;\n  align-items: center;\n"], ["\n  flex-shrink: 0;\n  display: inline-flex;\n  position: relative;\n  overflow: hidden;\n  line-height: 0;\n  align-items: center;\n"])));
var CheckboxIconStyle = styled(Check).withConfig({
  displayName: "CheckboxStyles__CheckboxIconStyle",
  componentId: "sc-1wrjkg7-1"
})(templateObject_2$m || (templateObject_2$m = __makeTemplateObject$j(["\n  height: 24px;\n  width: 24px;\n  border-radius: 4px;\n  transition: box-shadow 0.1s ease, background-color 0.1s ease;\n  fill: ", ";\n"], ["\n  height: 24px;\n  width: 24px;\n  border-radius: 4px;\n  transition: box-shadow 0.1s ease, background-color 0.1s ease;\n  fill: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primaryContrast;
});
styled.input.withConfig({
  displayName: "CheckboxStyles__CheckboxInputStyle",
  componentId: "sc-1wrjkg7-2"
})(templateObject_3$g || (templateObject_3$g = __makeTemplateObject$j(["\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n\n  &:not(:disabled) ~ * {\n    cursor: pointer;\n  }\n\n  label:hover &:not(:disabled):not(:checked) + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  & + ", " {\n    background-color: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n\n    path {\n      opacity: 0;\n    }\n  }\n\n  &:checked + ", " {\n    background-color: ", ";\n    box-shadow: none;\n\n    path {\n      opacity: 1;\n    }\n  }\n\n  &:disabled + ", " {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &:focus-visible + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  &:focus-visible:checked + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"], ["\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n\n  &:not(:disabled) ~ * {\n    cursor: pointer;\n  }\n\n  label:hover &:not(:disabled):not(:checked) + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  & + ", " {\n    background-color: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n\n    path {\n      opacity: 0;\n    }\n  }\n\n  &:checked + ", " {\n    background-color: ", ";\n    box-shadow: none;\n\n    path {\n      opacity: 1;\n    }\n  }\n\n  &:disabled + ", " {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &:focus-visible + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  &:focus-visible:checked + ", " {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"])), CheckboxIconStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderHover;
}, CheckboxIconStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.controlBg;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.border;
}, CheckboxIconStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, CheckboxIconStyle, CheckboxIconStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, CheckboxIconStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderHover;
});
var templateObject_1$w, templateObject_2$m, templateObject_3$g;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$8 = function() {
    __assign$8 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};

function __rest$5(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$i(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var sizes$2 = {
  xxs: css$1(templateObject_1$v || (templateObject_1$v = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxs;
  }),
  xs: css$1(templateObject_2$l || (templateObject_2$l = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xs;
  }),
  sm: css$1(templateObject_3$f || (templateObject_3$f = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.sm;
  }),
  md: css$1(templateObject_4$a || (templateObject_4$a = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.5em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.md;
  }),
  lg: css$1(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.4em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.4em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.lg;
  }),
  xl: css$1(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject$i(["\n    font-size: ", "px;\n    line-height: 1.4em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.4em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xl;
  })
};

var getTextColor = function getTextColor(props) {
  var colors = props.theme.colors,
      color = props.color;
  var colorsMap = {
    "default": colors.text,
    secondary: colors.textSecondary,
    primary: colors.primary,
    warning: colors.warning,
    error: colors.error,
    success: colors.success
  };
  return colorsMap[color];
};

var getTextDecoration = function getTextDecoration(props) {
  var underline = props.underline,
      strikeThrough = props.strikeThrough;

  switch (true) {
    case underline:
      return 'underline';

    case strikeThrough:
      return 'line-through';

    default:
      return 'none';
  }
};

var TextStyle = styled.p.withConfig({
  displayName: "TextStyles__TextStyle",
  componentId: "sc-107cmwr-0"
})(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject$i(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var strong = _a.strong,
      italic = _a.italic,
      size = _a.size;
  return css$1(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject$i(["\n    font-style: ", ";\n    font-weight: ", ";\n    margin: 0;\n    padding: 0;\n    color: ", ";\n    text-decoration: ", ";\n    ", "\n  "], ["\n    font-style: ", ";\n    font-weight: ", ";\n    margin: 0;\n    padding: 0;\n    color: ", ";\n    text-decoration: ", ";\n    ", "\n  "])), italic ? 'italic' : 'normal', strong ? 700 : 400, getTextColor, getTextDecoration, sizes$2[size]);
});
var templateObject_1$v, templateObject_2$l, templateObject_3$f, templateObject_4$a, templateObject_5$8, templateObject_6$6, templateObject_7$6, templateObject_8$5;

function Text(props, ref) {
  var _a = props.size,
      size = _a === void 0 ? 'md' : _a,
      _b = props.color,
      color = _b === void 0 ? 'default' : _b,
      rest = __rest$5(props, ["size", "color"]);

  return jsx(TextStyle, __assign$8({
    size: size,
    color: color,
    ref: ref
  }, rest), void 0);
}

var Text$1 = /*#__PURE__*/forwardRef(Text);

var TextColor;

(function (TextColor) {
  TextColor[TextColor["default"] = 0] = "default";
  TextColor[TextColor["secondary"] = 1] = "secondary";
  TextColor[TextColor["primary"] = 2] = "primary";
  TextColor[TextColor["warning"] = 3] = "warning";
  TextColor[TextColor["error"] = 4] = "error";
  TextColor[TextColor["success"] = 5] = "success";
})(TextColor || (TextColor = {}));

var TextSize;

(function (TextSize) {
  TextSize[TextSize["xxs"] = 0] = "xxs";
  TextSize[TextSize["xs"] = 1] = "xs";
  TextSize[TextSize["sm"] = 2] = "sm";
  TextSize[TextSize["md"] = 3] = "md";
  TextSize[TextSize["lg"] = 4] = "lg";
  TextSize[TextSize["xl"] = 5] = "xl";
})(TextSize || (TextSize = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$h(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var sizes$1 = {
  full: css$1(templateObject_1$u || (templateObject_1$u = __makeTemplateObject$h(["\n    max-width: 1424px;\n  "], ["\n    max-width: 1424px;\n  "]))),
  content: css$1(templateObject_2$k || (templateObject_2$k = __makeTemplateObject$h(["\n    max-width: 960px;\n  "], ["\n    max-width: 960px;\n  "]))),
  tight: css$1(templateObject_3$e || (templateObject_3$e = __makeTemplateObject$h(["\n    max-width: 560px;\n  "], ["\n    max-width: 560px;\n  "])))
};
styled.div.withConfig({
  displayName: "ContainerStyles__ContainerStyle",
  componentId: "sc-s3zvez-0"
})(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject$h(["\n  box-sizing: border-box;\n  margin: 0 auto;\n  min-width: 320px;\n  width: 100%;\n  padding: 0 ", "px;\n\n  ", " {\n    padding: 0 ", "px;\n  }\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  margin: 0 auto;\n  min-width: 320px;\n  width: 100%;\n  padding: 0 ", "px;\n\n  ", " {\n    padding: 0 ", "px;\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.mediaQueries.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var $size = _a.$size;
  return sizes$1[$size];
});
var templateObject_1$u, templateObject_2$k, templateObject_3$e, templateObject_4$9;

var ContainerSize;

(function (ContainerSize) {
  ContainerSize[ContainerSize["full"] = 0] = "full";
  ContainerSize[ContainerSize["content"] = 1] = "content";
  ContainerSize[ContainerSize["tight"] = 2] = "tight";
})(ContainerSize || (ContainerSize = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$g(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$f(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$7 = function() {
    __assign$7 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};

function __rest$4(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$e(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var INITIAL_STYLE = {
  // needs to prevent scrolling to initial state when using the auto focus
  position: 'fixed',
  opacity: 0,
  pointerEvents: 'none'
};
var DEFAULT_PLACEMENT = 'bottomLeft';

var ROOT_ID = 'lido-ui-modal-root';

var ModalRoot = function () {
  try {
    var modalRoot = document.getElementById(ROOT_ID);

    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = ROOT_ID;
      document.body.append(modalRoot);
    }

    return modalRoot;
  } catch (error) {
    return null;
  }
}();

var useBreakpoint = function useBreakpoint(breakpoint) {
  var theme = useTheme();
  var maxWidth = theme.breakpointsMap[breakpoint].width;

  var _a = useState(function () {
    try {
      return window.matchMedia("(max-width: " + maxWidth + ")").matches;
    } catch (error) {
      return false;
    }
  }),
      isBreakpoint = _a[0],
      seIsBreakpoint = _a[1];

  useEffect(function () {
    try {
      var mql_1 = window.matchMedia("(max-width: " + maxWidth + ")");

      var setMobileFromQuery_1 = function setMobileFromQuery_1(_a) {
        var matches = _a.matches;
        seIsBreakpoint(matches);
      };

      mql_1.addEventListener('change', setMobileFromQuery_1);
      setMobileFromQuery_1(mql_1);
      return function () {
        mql_1.removeEventListener('change', setMobileFromQuery_1);
      };
    } catch (error) {
      return;
    }
  }, [maxWidth]);
  return isBreakpoint;
};

var useEscape = function useEscape(callback) {
  var handleKeyDown = useCallback(function (event) {
    if (event.key === 'Escape') {
      callback === null || callback === void 0 ? void 0 : callback();
    }
  }, [callback]);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};

var useInterceptFocus = function useInterceptFocus() {
  var savedElement = useRef(null);
  var restoreFocus = useCallback(function () {
    if (!(savedElement.current instanceof HTMLElement)) return;
    savedElement.current.focus();
  }, []);
  var interceptFocus = useCallback(function (node) {
    savedElement.current = document.activeElement;
    var isFocusInside = node.contains(document.activeElement);
    if (isFocusInside) return;
    node.focus();
  }, []);
  return [interceptFocus, restoreFocus];
};

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            }
        }
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs$1(refs, defaultValue) {
    return useCallbackRef(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
}

var useMergeRefs = function useMergeRefs(refs) {
  return useMergeRefs$1(refs.filter(function (ref) {
    return !!ref;
  }));
};

var useOutsideClick = function useOutsideClick(callback) {
  var ref = useRef(null);
  var handleOutsideClick = useCallback(function (event) {
    var popover = ref.current;
    var target = event.target;
    if (!(target instanceof Element)) return;
    var isOutside = (popover === null || popover === void 0 ? void 0 : popover.contains(target)) === false;
    if (isOutside) callback === null || callback === void 0 ? void 0 : callback();
  }, [callback]);
  useEffect(function () {
    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      return document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);
  return {
    ref: ref
  };
};

var getWindowSize = function getWindowSize() {
  var width = window.innerWidth;
  var height = window.innerHeight;
  return [width, height];
};

var useWindowSize = function useWindowSize() {
  var _a = useState(getWindowSize),
      size = _a[0],
      setSize = _a[1];

  var handleResize = useCallback(function () {
    setSize(getWindowSize());
  }, []);
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  return size;
};

var THEME;

(function (THEME) {
  THEME["light"] = "light";
  THEME["dark"] = "dark";
})(THEME || (THEME = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$6 = function() {
    __assign$6 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};

function __rest$3(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactIs_production_min();
	} else {
	  module.exports = requireReactIs_development();
	}
} (reactIs));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = reactIs.exports;
	var assign = objectAssign;

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.number, propTypes.exports.shape({
  enter: propTypes.exports.number,
  exit: propTypes.exports.number,
  appear: propTypes.exports.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.shape({
  enter: propTypes.exports.string,
  exit: propTypes.exports.string,
  active: propTypes.exports.string
}), propTypes.exports.shape({
  enter: propTypes.exports.string,
  enterDone: propTypes.exports.string,
  enterActive: propTypes.exports.string,
  exit: propTypes.exports.string,
  exitDone: propTypes.exports.string,
  exitActive: propTypes.exports.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.exports.shape({
    current: typeof Element === 'undefined' ? propTypes.exports.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.exports.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.exports.oneOfType([propTypes.exports.func.isRequired, propTypes.exports.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.exports.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.exports.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.exports.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.exports.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.exports.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.exports.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.exports.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.exports.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.exports.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.exports.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.exports.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.exports.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition, _extends$3({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$3({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: propTypes.exports.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: propTypes.exports.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: propTypes.exports.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: propTypes.exports.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: propTypes.exports.func
}) : {};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$3({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: propTypes.exports.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: propTypes.exports.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: propTypes.exports.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: propTypes.exports.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: propTypes.exports.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: propTypes.exports.func
} : {};
TransitionGroup.defaultProps = defaultProps;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = React__default.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in"]);

    var _React$Children$toArr = React__default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/React__default.createElement(TransitionGroup, props, inProp ? React__default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : React__default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(React__default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: propTypes.exports.bool.isRequired,
  children: function children(props, propName) {
    if (React__default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};

var _leaveRenders, _enterRenders;

function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (React__default.isValidElement(oldChildren) && React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  }), React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }

    return {
      current: React__default.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;

      case EXITING:
        component = leaveRenders[mode](data);
        break;

      case ENTERED:
        component = current;
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(React__default.Component);

SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: propTypes.exports.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: propTypes.exports.oneOfType([propTypes.exports.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};

var DEFAULT_DURATION = 150;

function withTransition(Component) {
  function Wrapped(props, externalRef) {
    var _a = props["in"],
        state = _a === void 0 ? false : _a,
        _b = props.timeout,
        timeout = _b === void 0 ? DEFAULT_DURATION : _b,
        _c = props.mountOnEnter,
        mountOnEnter = _c === void 0 ? true : _c,
        _d = props.unmountOnExit,
        unmountOnExit = _d === void 0 ? true : _d,
        _e = props.appear,
        appear = _e === void 0 ? true : _e,
        _f = props.enter,
        enter = _f === void 0 ? true : _f,
        _g = props.exit,
        exit = _g === void 0 ? true : _g,
        addEndListener = props.addEndListener,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered,
        onExit = props.onExit,
        onExiting = props.onExiting,
        onExited = props.onExited,
        rest = __rest$3(props, ["in", "timeout", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"]);

    var transitionProps = {
      "in": state,
      timeout: timeout,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit,
      appear: appear,
      enter: enter,
      exit: exit,
      addEndListener: addEndListener,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited
    };
    var ref = useMergeRefs([externalRef]);
    return jsx(Transition, __assign$6({}, transitionProps, {
      nodeRef: ref
    }, {
      children: function children(status) {
        return jsx(Component, __assign$6({}, rest, {
          duration: timeout,
          transitionStatus: status,
          ref: ref
        }), void 0);
      }
    }), void 0);
  }

  return /*#__PURE__*/forwardRef(Wrapped);
}

var calculatePosition = function calculatePosition(anchorRect, popoverRect, wrapperRect, placement) {
  var position = {};

  switch (placement) {
    case 'top':
    case 'bottom':
      position.left = (anchorRect.left + anchorRect.right) / 2 - popoverRect.width / 2;
      break;

    case 'topLeft':
    case 'bottomLeft':
      position.left = anchorRect.left;
      break;

    case 'topRight':
    case 'bottomRight':
      position.left = anchorRect.right - popoverRect.width;
      break;

    case 'rightTop':
    case 'right':
    case 'rightBottom':
      position.left = anchorRect.right;
      break;

    case 'leftTop':
    case 'left':
    case 'leftBottom':
      position.left = anchorRect.left - popoverRect.width;
      break;
  }

  switch (placement) {
    case 'left':
    case 'right':
      position.top = (anchorRect.top + anchorRect.bottom) / 2 - popoverRect.height / 2;
      break;

    case 'leftTop':
    case 'rightTop':
      position.top = anchorRect.top;
      break;

    case 'leftBottom':
    case 'rightBottom':
      position.top = anchorRect.bottom - popoverRect.height;
      break;

    case 'topLeft':
    case 'top':
    case 'topRight':
      position.top = anchorRect.top - popoverRect.height;
      break;

    case 'bottomLeft':
    case 'bottom':
    case 'bottomRight':
      position.top = anchorRect.bottom;
      break;
  }

  position.top -= wrapperRect.top;
  position.left -= wrapperRect.left;
  return position;
};

var usePopoverPosition = function usePopoverPosition(props) {
  var _a = props.placement,
      placement = _a === void 0 ? DEFAULT_PLACEMENT : _a,
      anchorRef = props.anchorRef;
  var popoverRef = useRef(null);
  var wrapperRef = useRef(null);

  var _b = useState(INITIAL_STYLE),
      popoverStyle = _b[0],
      setPopoverStyle = _b[1];

  var _c = useWindowSize(),
      windowWidth = _c[0],
      windowHeight = _c[1];

  useLayoutEffect(function () {
    if (!anchorRef.current || !popoverRef.current || !wrapperRef.current) return;
    var anchorRect = anchorRef.current.getBoundingClientRect();
    var popoverRect = popoverRef.current.getBoundingClientRect();
    var wrapperRect = wrapperRef.current.getBoundingClientRect();
    var position = calculatePosition(anchorRect, popoverRect, wrapperRect, placement);
    setPopoverStyle(position);
  }, [anchorRef, placement, windowWidth, windowHeight]);

  var style = __assign$7(__assign$7({}, props.style), popoverStyle);

  return {
    popoverRef: popoverRef,
    wrapperRef: wrapperRef,
    style: style
  };
};

var PopoverWrapperStyle = styled.div.withConfig({
  displayName: "PopoverRootStyles__PopoverWrapperStyle",
  componentId: "sc-1jpnpyg-0"
})(templateObject_1$t || (templateObject_1$t = __makeTemplateObject$e(["\n  position: absolute;\n  z-index: 500;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: ", ";\n"], ["\n  position: absolute;\n  z-index: 500;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: ", ";\n"])), function (_a) {
  var $backdrop = _a.$backdrop;
  return $backdrop ? '100%' : '0px';
});
var visibleCSS = css$1(templateObject_2$j || (templateObject_2$j = __makeTemplateObject$e(["\n  opacity: 1;\n\n  &[data-placement] {\n    transform: translate(0, 0);\n  }\n"], ["\n  opacity: 1;\n\n  &[data-placement] {\n    transform: translate(0, 0);\n  }\n"])));
var hiddenCSS = css$1(templateObject_3$d || (templateObject_3$d = __makeTemplateObject$e(["\n  opacity: 0;\n\n  &[data-placement^='top'] {\n    transform: translateY(6px);\n  }\n  &[data-placement^='right'] {\n    transform: translateX(-6px);\n  }\n  &[data-placement^='bottom'] {\n    transform: translateY(-6px);\n  }\n  &[data-placement^='left'] {\n    transform: translateX(6px);\n  }\n"], ["\n  opacity: 0;\n\n  &[data-placement^='top'] {\n    transform: translateY(6px);\n  }\n  &[data-placement^='right'] {\n    transform: translateX(-6px);\n  }\n  &[data-placement^='bottom'] {\n    transform: translateY(-6px);\n  }\n  &[data-placement^='left'] {\n    transform: translateX(6px);\n  }\n"])));

var getTransitionCSS = function getTransitionCSS(_a) {
  var $transition = _a.$transition;
  return ['exiting', 'exited'].includes($transition) ? hiddenCSS : visibleCSS;
};

var PopoverRootStyle = styled.div.withConfig({
  displayName: "PopoverRootStyles__PopoverRootStyle",
  componentId: "sc-1jpnpyg-1"
})(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject$e(["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  transition: opacity ", "ms ease;\n  transition-property: opacity, transform;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  transition: opacity ", "ms ease;\n  transition-property: opacity, transform;\n\n  ", "\n"])), function (_a) {
  var $duration = _a.$duration;
  return $duration;
}, getTransitionCSS);
var templateObject_1$t, templateObject_2$j, templateObject_3$d, templateObject_4$8;

function PopoverRoot(props, externalRef) {
  props.anchorRef;
      var externalWrapperRef = props.wrapperRef,
      _a = props.placement,
      placement = _a === void 0 ? DEFAULT_PLACEMENT : _a,
      _b = props.backdrop,
      backdrop = _b === void 0 ? true : _b,
      transitionStatus = props.transitionStatus,
      duration = props.duration,
      rest = __rest$4(props, ["anchorRef", "wrapperRef", "placement", "backdrop", "transitionStatus", "duration"]);

  var onClose = props.onClose;
  useEscape(onClose);
  var outsidePopoverRef = useOutsideClick(onClose).ref;

  var _c = usePopoverPosition(props),
      positionPopoverRef = _c.popoverRef,
      positionWrapperRef = _c.wrapperRef,
      style = _c.style;

  var popoverRef = useMergeRefs([positionPopoverRef, outsidePopoverRef, externalRef]);
  var wrapperRef = useMergeRefs([positionWrapperRef, externalWrapperRef]);
  if (!ModalRoot) return null;
  return /*#__PURE__*/ReactDOM.createPortal(jsx(PopoverWrapperStyle, __assign$7({
    "$backdrop": backdrop,
    ref: wrapperRef
  }, {
    children: jsx(PopoverRootStyle, __assign$7({}, rest, {
      "$transition": transitionStatus,
      "$duration": duration,
      "data-placement": placement,
      style: style,
      ref: popoverRef
    }), void 0)
  }), void 0), ModalRoot);
}

var PopoverRoot$1 = withTransition( /*#__PURE__*/forwardRef(PopoverRoot));

var getOffset = function getOffset(props) {
  var $offset = props.$offset,
      placement = props.placement,
      theme = props.theme;
  var offset = theme.spaceMap[$offset];
  if (placement.startsWith('top')) return "margin-top: " + -offset + "px";
  if (placement.startsWith('right')) return "margin-left: " + offset + "px";
  if (placement.startsWith('bottom')) return "margin-top: " + offset + "px";
  if (placement.startsWith('left')) return "margin-left: " + -offset + "px";
  return '';
};

var PopoverStyle = styled(PopoverRoot$1).withConfig({
  displayName: "PopoverStyles__PopoverStyle",
  componentId: "sc-1h3f7dt-0"
})(templateObject_1$s || (templateObject_1$s = __makeTemplateObject$e(["\n  background: ", ";\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1.5em;\n  font-weight: 400;\n  border-radius: ", "px;\n  box-shadow: ", ";\n  padding: ", "px;\n  overflow: auto;\n\n  ", "\n"], ["\n  background: ", ";\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1.5em;\n  font-weight: 400;\n  border-radius: ", "px;\n  box-shadow: ", ";\n  padding: ", "px;\n  overflow: auto;\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.foreground;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xs;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.boxShadows.xs + " " + theme.colors.shadowLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, getOffset);
var templateObject_1$s;

function Popover(props, ref) {
  var _a = props.placement,
      placement = _a === void 0 ? DEFAULT_PLACEMENT : _a,
      _b = props.open,
      open = _b === void 0 ? false : _b,
      _c = props.offset,
      offset = _c === void 0 ? 'xs' : _c,
      rest = __rest$4(props, ["placement", "open", "offset"]);

  return jsx(PopoverStyle, __assign$7({
    "$offset": offset,
    placement: placement,
    "in": open
  }, rest, {
    ref: ref
  }), void 0);
}

var Popover$1 = /*#__PURE__*/forwardRef(Popover);

var PopoverOffset;

(function (PopoverOffset) {
  PopoverOffset[PopoverOffset["xs"] = 0] = "xs";
  PopoverOffset[PopoverOffset["sm"] = 1] = "sm";
  PopoverOffset[PopoverOffset["md"] = 2] = "md";
  PopoverOffset[PopoverOffset["lg"] = 3] = "lg";
  PopoverOffset[PopoverOffset["xl"] = 4] = "xl";
})(PopoverOffset || (PopoverOffset = {}));

var PopoverPlacement;

(function (PopoverPlacement) {
  PopoverPlacement[PopoverPlacement["topLeft"] = 0] = "topLeft";
  PopoverPlacement[PopoverPlacement["top"] = 1] = "top";
  PopoverPlacement[PopoverPlacement["topRight"] = 2] = "topRight";
  PopoverPlacement[PopoverPlacement["rightTop"] = 3] = "rightTop";
  PopoverPlacement[PopoverPlacement["right"] = 4] = "right";
  PopoverPlacement[PopoverPlacement["rightBottom"] = 5] = "rightBottom";
  PopoverPlacement[PopoverPlacement["bottomLeft"] = 6] = "bottomLeft";
  PopoverPlacement[PopoverPlacement["bottom"] = 7] = "bottom";
  PopoverPlacement[PopoverPlacement["bottomRight"] = 8] = "bottomRight";
  PopoverPlacement[PopoverPlacement["leftTop"] = 9] = "leftTop";
  PopoverPlacement[PopoverPlacement["left"] = 10] = "left";
  PopoverPlacement[PopoverPlacement["leftBottom"] = 11] = "leftBottom";
})(PopoverPlacement || (PopoverPlacement = {}));

styled(Popover$1).withConfig({
  displayName: "TooltipStyles__TooltipPopoverStyle",
  componentId: "sc-1q5okn3-0"
})(templateObject_1$r || (templateObject_1$r = __makeTemplateObject$f(["\n  padding: 12px;\n  background: ", ";\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1.8em;\n  font-weight: 400;\n  max-width: 256px;\n  border-radius: ", "px;\n  box-shadow: ", ";\n  pointer-events: none;\n"], ["\n  padding: 12px;\n  background: ", ";\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1.8em;\n  font-weight: 400;\n  max-width: 256px;\n  border-radius: ", "px;\n  box-shadow: ", ";\n  pointer-events: none;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accentContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxxs;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.boxShadows.sm + " " + theme.colors.shadowLight;
});
var templateObject_1$r;

styled.div.withConfig({
  displayName: "DataTableStyles__DataTableStyle",
  componentId: "sc-ipz6cg-0"
})(templateObject_1$q || (templateObject_1$q = __makeTemplateObject$g([""], [""])));
styled.div.withConfig({
  displayName: "DataTableStyles__DataTableRowStyle",
  componentId: "sc-ipz6cg-1"
})(templateObject_2$i || (templateObject_2$i = __makeTemplateObject$g(["\n  display: flex;\n  margin: ", "px 0;\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  margin: ", "px 0;\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
});
styled.div.withConfig({
  displayName: "DataTableStyles__DataTableTitleStyle",
  componentId: "sc-ipz6cg-2"
})(templateObject_3$c || (templateObject_3$c = __makeTemplateObject$g(["\n  color: ", ";\n  flex-grow: 1;\n"], ["\n  color: ", ";\n  flex-grow: 1;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
});
styled.div.withConfig({
  displayName: "DataTableStyles__DataTableValueStyle",
  componentId: "sc-ipz6cg-3"
})(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject$g(["\n  color: ", ";\n  text-align: right;\n  margin-left: ", "px;\n  flex-grow: 1;\n"], ["\n  color: ", ";\n  text-align: right;\n  margin-left: ", "px;\n  flex-grow: 1;\n"])), function (_a) {
  var theme = _a.theme,
      $highlight = _a.$highlight;
  return $highlight ? theme.colors.success : theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
});
styled(Question).withConfig({
  displayName: "DataTableStyles__DataTableQuestionStyle",
  componentId: "sc-ipz6cg-4"
})(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject$g(["\n  margin: -6px 0 -5px 0;\n  vertical-align: middle;\n"], ["\n  margin: -6px 0 -5px 0;\n  vertical-align: middle;\n"])));
var templateObject_1$q, templateObject_2$i, templateObject_3$c, templateObject_4$7, templateObject_5$7;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$d(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var getIndents = function getIndents(_a) {
  var $indents = _a.$indents,
      theme = _a.theme;
  return $indents ? theme.spaceMap[$indents] + "px" : '0';
};

var types = {
  horizontal: css$1(templateObject_1$p || (templateObject_1$p = __makeTemplateObject$d(["\n    border-top: 1px solid currentColor;\n    width: 100%;\n    height: 0;\n    margin: ", " 0;\n  "], ["\n    border-top: 1px solid currentColor;\n    width: 100%;\n    height: 0;\n    margin: ", " 0;\n  "])), getIndents),
  vertical: css$1(templateObject_2$h || (templateObject_2$h = __makeTemplateObject$d(["\n    border-left: 1px solid currentColor;\n    align-self: stretch;\n    width: 0;\n    margin: 0 ", ";\n  "], ["\n    border-left: 1px solid currentColor;\n    align-self: stretch;\n    width: 0;\n    margin: 0 ", ";\n  "])), getIndents)
};
styled.div.withConfig({
  displayName: "DividerStyles__DividerStyle",
  componentId: "sc-11rlrd0-0"
})(templateObject_3$b || (templateObject_3$b = __makeTemplateObject$d(["\n  box-sizing: border-box;\n  list-style: none;\n  opacity: 0.1;\n  margin: 0;\n  padding: 0;\n  flex-shrink: 0;\n  flex-grow: 0;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  list-style: none;\n  opacity: 0.1;\n  margin: 0;\n  padding: 0;\n  flex-shrink: 0;\n  flex-grow: 0;\n\n  ", "\n"])), function (props) {
  return types[props.$type];
});
var templateObject_1$p, templateObject_2$h, templateObject_3$b;

var DividerType;

(function (DividerType) {
  DividerType[DividerType["vertical"] = 0] = "vertical";
  DividerType[DividerType["horizontal"] = 1] = "horizontal";
})(DividerType || (DividerType = {}));

var DividerIndent;

(function (DividerIndent) {
  DividerIndent[DividerIndent["xs"] = 0] = "xs";
  DividerIndent[DividerIndent["sm"] = 1] = "sm";
  DividerIndent[DividerIndent["md"] = 2] = "md";
  DividerIndent[DividerIndent["lg"] = 3] = "lg";
  DividerIndent[DividerIndent["xl"] = 4] = "xl";
})(DividerIndent || (DividerIndent = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$c(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var sizes = {
  sm: css$1(templateObject_1$o || (templateObject_1$o = __makeTemplateObject$c(["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xl;
  }),
  md: css$1(templateObject_2$g || (templateObject_2$g = __makeTemplateObject$c(["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxl;
  }),
  lg: css$1(templateObject_3$a || (templateObject_3$a = __makeTemplateObject$c(["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "], ["\n    font-size: ", "px;\n    line-height: 1.3em;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxxl;
  })
};

var getHeadingColor = function getHeadingColor(props) {
  var colorsMap = {
    text: props.theme.colors.text,
    secondary: props.theme.colors.textSecondary
  };
  return colorsMap[props.$color];
};

var commonCSS$1 = css$1(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject$c(["\n  margin: 0;\n  padding: 0;\n  font-weight: 800;\n  color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  font-weight: 800;\n  color: ", ";\n"])), getHeadingColor);
styled.div.withConfig({
  displayName: "HeadingStyles__HeadingStyle",
  componentId: "sc-u5f2uf-0"
})(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject$c(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), commonCSS$1, function (props) {
  return sizes[props.$size];
});
styled.h1.withConfig({
  displayName: "HeadingStyles__H1Style",
  componentId: "sc-u5f2uf-1"
})(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject$c(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), commonCSS$1, sizes.lg);
styled.h2.withConfig({
  displayName: "HeadingStyles__H2Style",
  componentId: "sc-u5f2uf-2"
})(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject$c(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), commonCSS$1, sizes.md);
styled.h3.withConfig({
  displayName: "HeadingStyles__H3Style",
  componentId: "sc-u5f2uf-3"
})(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject$c(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), commonCSS$1, sizes.sm);
var templateObject_1$o, templateObject_2$g, templateObject_3$a, templateObject_4$6, templateObject_5$6, templateObject_6$5, templateObject_7$5, templateObject_8$4;

var HeadingColor;

(function (HeadingColor) {
  HeadingColor[HeadingColor["text"] = 0] = "text";
  HeadingColor[HeadingColor["secondary"] = 1] = "secondary";
})(HeadingColor || (HeadingColor = {}));

var HeadingSize;

(function (HeadingSize) {
  HeadingSize[HeadingSize["sm"] = 0] = "sm";
  HeadingSize[HeadingSize["md"] = 1] = "md";
  HeadingSize[HeadingSize["lg"] = 2] = "lg";
})(HeadingSize || (HeadingSize = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$b(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var colors$4 = {
  background: css$1(templateObject_1$n || (templateObject_1$n = __makeTemplateObject$b(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }),
  accent: css$1(templateObject_2$f || (templateObject_2$f = __makeTemplateObject$b(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.accentDarken;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentContrast;
  })
};
styled.div.withConfig({
  displayName: "IdenticonStyles__IdenticonBadgeStyle",
  componentId: "sc-1ao8zk7-0"
})(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject$b(["\n  border-radius: 1000px;\n  padding: 4px;\n  margin: 0 6px;\n  display: inline-flex;\n  align-items: center;\n\n  ", "\n"], ["\n  border-radius: 1000px;\n  padding: 4px;\n  margin: 0 6px;\n  display: inline-flex;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
  var $color = _a.$color;
  return colors$4[$color];
});
styled.div.withConfig({
  displayName: "IdenticonStyles__IdenticonStyle",
  componentId: "sc-1ao8zk7-1"
})(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject$b(["\n  border-radius: 1000px;\n  overflow: hidden;\n  line-height: 0;\n  display: inline-block;\n"], ["\n  border-radius: 1000px;\n  overflow: hidden;\n  line-height: 0;\n  display: inline-block;\n"])));
styled.div.withConfig({
  displayName: "IdenticonStyles__AddressWrapperStyle",
  componentId: "sc-1ao8zk7-2"
})(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject$b(["\n  padding: 0 6px;\n"], ["\n  padding: 0 6px;\n"])));
var templateObject_1$n, templateObject_2$f, templateObject_3$9, templateObject_4$5, templateObject_5$5;

var lib = {};

var Jazzicon$1 = {};

var clone$1 = {exports: {}};

(function (module) {
	var clone = (function() {

	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    circular.filter;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];

	  var useBuffer = typeof Buffer != 'undefined';

	  if (typeof circular == 'undefined')
	    circular = true;

	  if (typeof depth == 'undefined')
	    depth = Infinity;

	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;

	    if (depth == 0)
	      return parent;

	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }

	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }

	    if (circular) {
	      var index = allParents.indexOf(parent);

	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }

	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }

	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }

	    return child;
	  }

	  return _clone(parent, depth);
	}

	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;

	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};

	// private utility functions

	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}	clone.__objToStr = __objToStr;

	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}	clone.__isDate = __isDate;

	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}	clone.__isArray = __isArray;

	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}	clone.__isRegExp = __isRegExp;

	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}	clone.__getRegExpFlags = __getRegExpFlags;

	return clone;
	})();

	if (module.exports) {
	  module.exports = clone;
	}
} (clone$1));

var conversions$2 = {exports: {}};

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */

var cssKeywords = colorName;

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert$2 = conversions$2.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert$2) {
	if (convert$2.hasOwnProperty(model)) {
		if (!('channels' in convert$2[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert$2[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert$2[model].labels.length !== convert$2[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert$2[model].channels;
		var labels = convert$2[model].labels;
		delete convert$2[model].channels;
		delete convert$2[model].labels;
		Object.defineProperty(convert$2[model], 'channels', {value: channels});
		Object.defineProperty(convert$2[model], 'labels', {value: labels});
	}
}

convert$2.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert$2.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert$2.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert$2.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert$2.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert$2.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert$2.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert$2.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert$2.rgb.lab = function (rgb) {
	var xyz = convert$2.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert$2.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert$2.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert$2.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$2.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert$2.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert$2.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert$2.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert$2.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert$2.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert$2.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};

convert$2.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert$2.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert$2.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert$2.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert$2.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert$2.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert$2.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert$2.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert$2.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert$2.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert$2.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert$2.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert$2.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert$2.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert$2.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert$2.gray.hsl = convert$2.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert$2.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert$2.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert$2.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert$2.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};

var conversions$1 = conversions$2.exports;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions$1);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions$1[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions$1[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions$1[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route$1 = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var conversions = conversions$2.exports;
var route = route$1;

var convert$1 = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert$1[fromModel] = {};

	Object.defineProperty(convert$1[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert$1[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert$1[fromModel][toModel] = wrapRounded(fn);
		convert$1[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert$1;

/* MIT license */

var colorNames = colorName;

var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/,
       hex =  /^#([a-fA-F0-9]{6})$/,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       keyword = /(\D+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}

/* MIT license */

var clone = clone$1.exports;
var convert = colorConvert;
var string = colorString;

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		} else {
			throw new Error('Unable to parse color from string "' + obj + '"');
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		} else {
			throw new Error('Unable to parse color from object ' + JSON.stringify(obj));
		}
	}
};

Color.prototype = {
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		if (this.values.alpha !== 1) {
			return this.values.hwb.concat([this.values.alpha]);
		}
		return this.values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var rgb = this.values.rgb;
		return rgb.concat([this.values.alpha]);
	},
	rgbaArrayNormalized: function () {
		var rgb = this.values.rgb;
		var glRgba = [];
		for (var i = 0; i < 3; i++) {
			glRgba[i] = rgb[i] / 255;
		}
		glRgba.push(this.values.alpha);
		return glRgba;
	},
	hslaArray: function () {
		var hsl = this.values.hsl;
		return hsl.concat([this.values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		this.values.hsl[2] += this.values.hsl[2] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	darken: function (ratio) {
		this.values.hsl[2] -= this.values.hsl[2] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	saturate: function (ratio) {
		this.values.hsl[1] += this.values.hsl[1] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	desaturate: function (ratio) {
		this.values.hsl[1] -= this.values.hsl[1] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	whiten: function (ratio) {
		this.values.hwb[1] += this.values.hwb[1] * ratio;
		this.setValues('hwb', this.values.hwb);
		return this;
	},

	blacken: function (ratio) {
		this.values.hwb[2] += this.values.hwb[2] * ratio;
		this.setValues('hwb', this.values.hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		this.setValues('alpha', this.values.alpha - (this.values.alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		this.setValues('alpha', this.values.alpha + (this.values.alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hue = this.values.hsl[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		this.values.hsl[0] = hue;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		var col = new Color();
		col.values = clone(this.values);
		return col;
	}
};

Color.prototype.getValues = function (space) {
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = this.values[space][i];
	}

	if (this.values.alpha !== 1) {
		vals.a = this.values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};

	var maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};

	var i;
	var alpha = 1;
	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		this.values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			this.values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			this.values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	this.values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? this.values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
		this.values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			this.values[sname] = convert[space][sname](this.values[space]);
		}

		// cap values
		for (i = 0; i < sname.length; i++) {
			capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
			this.values[sname][i] = Math.round(capped);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	if (val === undefined) {
		// color.red()
		return this.values[space][index];
	} else if (val === this.values[space][index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	this.values[space][index] = val;
	this.setValues(space, this.values[space]);

	return this;
};

var color = Color;

/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/

/*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/

var MersenneTwister = function(seed) {
	if (seed == undefined) {
		seed = new Date().getTime();
	}

	/* Period parameters */
	this.N = 624;
	this.M = 397;
	this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	this.LOWER_MASK = 0x7fffffff; /* least significant r bits */

	this.mt = new Array(this.N); /* the array for the state vector */
	this.mti=this.N+1; /* mti==N+1 means mt[N] is not initialized */

	if (seed.constructor == Array) {
		this.init_by_array(seed, seed.length);
	}
	else {
		this.init_seed(seed);
	}
};

/* initializes mt[N] with a seed */
/* origin name init_genrand */
MersenneTwister.prototype.init_seed = function(s) {
	this.mt[0] = s >>> 0;
	for (this.mti=1; this.mti<this.N; this.mti++) {
		var s = this.mt[this.mti-1] ^ (this.mt[this.mti-1] >>> 30);
		this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253)
		+ this.mti;
		/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
		/* In the previous versions, MSBs of the seed affect   */
		/* only MSBs of the array mt[].                        */
		/* 2002/01/09 modified by Makoto Matsumoto             */
		this.mt[this.mti] >>>= 0;
		/* for >32 bit machines */
	}
};

/* initialize by an array with array-length */
/* init_key is the array for initializing keys */
/* key_length is its length */
/* slight change for C++, 2004/2/26 */
MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
	var i, j, k;
	this.init_seed(19650218);
	i=1; j=0;
	k = (this.N>key_length ? this.N : key_length);
	for (; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525)))
		+ init_key[j] + j; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++; j++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
		if (j>=key_length) j=0;
	}
	for (k=this.N-1; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941))
		- i; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
	}

	this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
};

/* generates a random number on [0,0xffffffff]-interval */
/* origin name genrand_int32 */
MersenneTwister.prototype.random_int = function() {
	var y;
	var mag01 = new Array(0x0, this.MATRIX_A);
	/* mag01[x] = x * MATRIX_A  for x=0,1 */

	if (this.mti >= this.N) { /* generate N words at one time */
		var kk;

		if (this.mti == this.N+1)  /* if init_seed() has not been called, */
			this.init_seed(5489);  /* a default initial seed is used */

		for (kk=0;kk<this.N-this.M;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		for (;kk<this.N-1;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+(this.M-this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		y = (this.mt[this.N-1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
		this.mt[this.N-1] = this.mt[this.M-1] ^ (y >>> 1) ^ mag01[y & 0x1];

		this.mti = 0;
	}

	y = this.mt[this.mti++];

	/* Tempering */
	y ^= (y >>> 11);
	y ^= (y << 7) & 0x9d2c5680;
	y ^= (y << 15) & 0xefc60000;
	y ^= (y >>> 18);

	return y >>> 0;
};

/* generates a random number on [0,0x7fffffff]-interval */
/* origin name genrand_int31 */
MersenneTwister.prototype.random_int31 = function() {
	return (this.random_int()>>>1);
};

/* generates a random number on [0,1]-real-interval */
/* origin name genrand_real1 */
MersenneTwister.prototype.random_incl = function() {
	return this.random_int()*(1.0/4294967295.0);
	/* divided by 2^32-1 */
};

/* generates a random number on [0,1)-real-interval */
MersenneTwister.prototype.random = function() {
	return this.random_int()*(1.0/4294967296.0);
	/* divided by 2^32 */
};

/* generates a random number on (0,1)-real-interval */
/* origin name genrand_real3 */
MersenneTwister.prototype.random_excl = function() {
	return (this.random_int() + 0.5)*(1.0/4294967296.0);
	/* divided by 2^32 */
};

/* generates a random number on [0,1) with 53-bit resolution*/
/* origin name genrand_res53 */
MersenneTwister.prototype.random_long = function() {
	var a=this.random_int()>>>5, b=this.random_int()>>>6;
	return (a*67108864.0+b)*(1.0/9007199254740992.0);
};

/* These real versions are due to Isaku Wada, 2002/01/09 added */

var mersenneTwister = MersenneTwister;

var colors$3 = {};

Object.defineProperty(colors$3, "__esModule", {
  value: true
});
colors$3.default = ['#01888c', // teal
'#fc7500', // bright orange
'#034f5d', // dark teal
'#f73f01', // orangered
'#fc1960', // magenta
'#c7144c', // raspberry
'#f3c100', // goldenrod
'#1598f2', // lightning blue
'#2465e1', // sail blue
'#f19e02'];

var Paper$1 = {};

Object.defineProperty(Paper$1, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1 = React__default;

var _react2$1 = _interopRequireDefault$1(_react$1);

var _propTypes$1 = propTypes.exports;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  borderRadius: '50px',
  display: 'inline-block',
  margin: 0,
  overflow: 'hidden',
  padding: 0
};

var Paper = function Paper(_ref) {
  var children = _ref.children,
      color = _ref.color,
      diameter = _ref.diameter,
      styleOverrides = _ref.style;
  return _react2$1.default.createElement(
    'div',
    {
      className: 'paper',
      style: _extends$2({}, styles, {
        backgroundColor: color,
        height: diameter,
        width: diameter
      }, styleOverrides)
    },
    children
  );
};

Paper.propTypes = {
  color: _propTypes2$1.default.string,
  diameter: _propTypes2$1.default.number,
  style: _propTypes2$1.default.object
};

Paper$1.default = Paper;

Object.defineProperty(Jazzicon$1, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = color;

var _color2 = _interopRequireDefault(_color);

var _mersenneTwister = mersenneTwister;

var _mersenneTwister2 = _interopRequireDefault(_mersenneTwister);

var _colors = colors$3;

var _colors2 = _interopRequireDefault(_colors);

var _Paper = Paper$1;

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shapeCount = 4;
var svgns = 'http://www.w3.org/2000/svg';
var wobble = 30;

var Jazzicon = function (_React$PureComponent) {
  _inherits(Jazzicon, _React$PureComponent);

  function Jazzicon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Jazzicon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Jazzicon.__proto__ || Object.getPrototypeOf(Jazzicon)).call.apply(_ref, [this].concat(args))), _this), _this.genColor = function (colors) {
      _this.generator.random();
      var idx = Math.floor(colors.length * _this.generator.random());
      var color = colors.splice(idx, 1)[0];
      return color;
    }, _this.hueShift = function (colors, generator) {
      var amount = generator.random() * 30 - wobble / 2;
      return colors.map(function (hex) {
        var color = (0, _color2.default)(hex);
        color.rotate(amount);
        return color.hexString();
      });
    }, _this.genShape = function (remainingColors, diameter, i, total) {
      var center = diameter / 2;
      var firstRot = _this.generator.random();
      var angle = Math.PI * 2 * firstRot;
      var velocity = diameter / total * _this.generator.random() + i * diameter / total;
      var tx = Math.cos(angle) * velocity;
      var ty = Math.sin(angle) * velocity;
      var translate = 'translate(' + tx + ' ' + ty + ')';

      // Third random is a shape rotation on top of all of that.
      var secondRot = _this.generator.random();
      var rot = firstRot * 360 + secondRot * 180;
      var rotate = 'rotate(' + rot.toFixed(1) + ' ' + center + ' ' + center + ')';
      var transform = translate + ' ' + rotate;
      var fill = _this.genColor(remainingColors);

      return _react2.default.createElement('rect', {
        key: i,
        x: '0',
        y: '0',
        rx: '0',
        ry: '0',
        height: diameter,
        width: diameter,
        transform: transform,
        fill: fill // todo: make prop
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Jazzicon, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          diameter = _props.diameter,
          paperStyles = _props.paperStyles,
          seed = _props.seed,
          svgStyles = _props.svgStyles;


      this.generator = new _mersenneTwister2.default(seed);

      var remainingColors = this.hueShift(_colors2.default.slice(), this.generator);
      var shapesArr = Array(shapeCount).fill();

      return _react2.default.createElement(
        _Paper2.default,
        { color: this.genColor(remainingColors), diameter: diameter, style: paperStyles },
        _react2.default.createElement(
          'svg',
          { xmlns: svgns, x: '0', y: '0', height: diameter, width: diameter, style: svgStyles },
          shapesArr.map(function (s, i) {
            return _this2.genShape(remainingColors, diameter, i, shapeCount - 1);
          })
        )
      );
    }
  }]);

  return Jazzicon;
}(_react2.default.PureComponent);

Jazzicon$1.default = Jazzicon;


Jazzicon.propTypes = {
  diameter: _propTypes2.default.number,
  paperStyles: _propTypes2.default.object,
  seed: _propTypes2.default.number,
  svgStyles: _propTypes2.default.object
};

var jsNumberForAddress$1 = {};

Object.defineProperty(jsNumberForAddress$1, "__esModule", {
  value: true
});
jsNumberForAddress$1.default = jsNumberForAddress;
function jsNumberForAddress(address) {
  var addr = address.slice(2, 10);
  var seed = parseInt(addr, 16);

  return seed;
}

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _Jazzicon = Jazzicon$1;

	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Jazzicon).default;
	  }
	});

	var _jsNumberForAddress = jsNumberForAddress$1;

	Object.defineProperty(exports, 'jsNumberForAddress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_jsNumberForAddress).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
} (lib));

var IdenticonBadgeColor;

(function (IdenticonBadgeColor) {
  IdenticonBadgeColor[IdenticonBadgeColor["background"] = 0] = "background";
  IdenticonBadgeColor[IdenticonBadgeColor["accent"] = 1] = "accent";
})(IdenticonBadgeColor || (IdenticonBadgeColor = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$5 = function() {
    __assign$5 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};

function __rest$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$a(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var colors$2 = {
  "default": css$1(templateObject_1$m || (templateObject_1$m = __makeTemplateObject$a(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }),
  accent: css$1(templateObject_2$e || (templateObject_2$e = __makeTemplateObject$a(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.accentContrastSecondary;
  })
};
var labelEmptyValueCSS = css$1(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject$a(["\n  ", "\n\n  transform: scale(1);\n  opacity: 0.5;\n"], ["\n  ", "\n\n  transform: scale(1);\n  opacity: 0.5;\n"])), function (_a) {
  var $color = _a.$color;
  return colors$2[$color];
});
var labelFilledValueCSS = css$1(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject$a(["\n  ", "\n\n  transform: translateY(-14px) scale(0.75);\n  opacity: 1;\n"], ["\n  ", "\n\n  transform: translateY(-14px) scale(0.75);\n  opacity: 1;\n"])), function (_a) {
  var $color = _a.$color;
  return colors$2[$color];
});
var labelFocusCSS = css$1(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject$a(["\n  color: ", ";\n  opacity: 1;\n"], ["\n  color: ", ";\n  opacity: 1;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
});
var labelErrorCSS = css$1(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject$a(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.error;
});
var InputLabelStyle = styled.span.withConfig({
  displayName: "LabelStyles__InputLabelStyle",
  componentId: "sc-1wukku1-0"
})(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject$a(["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  font-size: 1em;\n  line-height: 1.25em;\n  margin: -0.625em 0 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  color: inherit;\n  transform-origin: 0% 100%;\n  transition: transform ", " ease;\n  transition-property: transform, opacity, color;\n  ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  font-size: 1em;\n  line-height: 1.25em;\n  margin: -0.625em 0 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  color: inherit;\n  transform-origin: 0% 100%;\n  transition: transform ", " ease;\n  transition-property: transform, opacity, color;\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.duration.fast;
}, labelFilledValueCSS);
styled(InputLabelStyle).withConfig({
  displayName: "LabelStyles__TextareaLabelStyle",
  componentId: "sc-1wukku1-1"
})(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject$a(["\n  top: 27px;\n"], ["\n  top: 27px;\n"])));
var templateObject_1$m, templateObject_2$e, templateObject_3$8, templateObject_4$4, templateObject_5$4, templateObject_6$4, templateObject_7$4, templateObject_8$3;

var statesCSS = css$1(templateObject_1$l || (templateObject_1$l = __makeTemplateObject$a(["\n  &:hover {\n    z-index: 1;\n  }\n\n  &:focus-within {\n    z-index: 2;\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  &:hover {\n    z-index: 1;\n  }\n\n  &:focus-within {\n    z-index: 2;\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.borderActive;
}, InputLabelStyle, labelFocusCSS);
var activeCSS = css$1(templateObject_2$d || (templateObject_2$d = __makeTemplateObject$a(["\n  &,\n  &:hover,\n  &:focus-within {\n    z-index: 2;\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  &,\n  &:hover,\n  &:focus-within {\n    z-index: 2;\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.borderActive;
}, InputLabelStyle, labelFocusCSS);
var errorCSS = css$1(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject$a(["\n  &,\n  &:hover,\n  &:focus-within {\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  &,\n  &:hover,\n  &:focus-within {\n    border-color: ", ";\n\n    ", " {\n      ", "\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.error;
}, InputLabelStyle, labelErrorCSS);
var wrapperColors = {
  "default": css$1(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject$a(["\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    ", ";\n  "], ["\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.controlBg;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.border;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
  }, function (_a) {
    var $disabled = _a.$disabled,
        theme = _a.theme;
    return $disabled ? "background: " + theme.colors.background + ";" : "\n          &:hover {\n            border-color: " + theme.colors.borderHover + ";\n          }\n    ";
  }),
  accent: css$1(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject$a(["\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    ", ";\n  "], ["\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.accentControlBg;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentBorder;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentText;
  }, function (_a) {
    var $disabled = _a.$disabled,
        theme = _a.theme;
    return $disabled ? "background: " + theme.colors.controlBg + ";" : "\n          &:hover {\n            border-color: " + theme.colors.accentBorderHover + ";\n          }\n    ";
  })
};
var InputWrapperStyle = styled.label.withConfig({
  displayName: "InputStyles__InputWrapperStyle",
  componentId: "sc-kdtshm-0"
})(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject$a(["\n  position: relative;\n  display: inline-flex;\n  border: 1px solid;\n  border-radius: ", "px;\n  align-items: stretch;\n  box-sizing: border-box;\n  padding: 0 15px;\n  cursor: ", ";\n  transition: border-color ", " ease;\n  width: ", ";\n\n  ", ";\n  ", "\n\n  ", "\n  ", "\n"], ["\n  position: relative;\n  display: inline-flex;\n  border: 1px solid;\n  border-radius: ", "px;\n  align-items: stretch;\n  box-sizing: border-box;\n  padding: 0 15px;\n  cursor: ", ";\n  transition: border-color ", " ease;\n  width: ", ";\n\n  ", ";\n  ", "\n\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var $disabled = _a.$disabled;
  return $disabled ? 'default' : 'text';
}, function (_a) {
  var theme = _a.theme;
  return theme.duration.fast;
}, function (_a) {
  var $fullwidth = _a.$fullwidth;
  return $fullwidth ? '100%' : 'auto';
}, function (_a) {
  var $color = _a.$color;
  return wrapperColors[$color];
}, function (_a) {
  var $disabled = _a.$disabled;
  return $disabled ? '' : statesCSS;
}, function (_a) {
  var $active = _a.$active;
  return $active ? activeCSS : '';
}, function (_a) {
  var $error = _a.$error;
  return $error ? errorCSS : '';
});
var contentVariants = {
  "default": css$1(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject$a(["\n    padding: 17px 0;\n  "], ["\n    padding: 17px 0;\n  "]))),
  small: css$1(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject$a(["\n    padding: 9px 0;\n  "], ["\n    padding: 9px 0;\n  "])))
};
var InputContentStyle = styled.span.withConfig({
  displayName: "InputStyles__InputContentStyle",
  componentId: "sc-kdtshm-1"
})(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject$a(["\n  font-weight: 400;\n  font-size: ", "px;\n  display: flex;\n  flex-grow: 1;\n  position: relative;\n\n  ", ";\n"], ["\n  font-weight: 400;\n  font-size: ", "px;\n  display: flex;\n  flex-grow: 1;\n  position: relative;\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xs;
}, function (_a) {
  var $variant = _a.$variant;
  return contentVariants[$variant];
});
var labeledCSS = css$1(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject$a(["\n  &:not(:focus):placeholder-shown {\n    & + ", " {\n      ", "\n    }\n\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n"], ["\n  &:not(:focus):placeholder-shown {\n    & + ", " {\n      ", "\n    }\n\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n"])), InputLabelStyle, labelEmptyValueCSS);
var inputColors = {
  "default": css$1(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject$a(["\n    color: ", ";\n\n    &:disabled {\n      color: ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0 100px ", " inset !important;\n      color: ", " !important;\n    }\n\n    &:-internal-autofill-selected {\n      color: ", " !important;\n    }\n  "], ["\n    color: ", ";\n\n    &:disabled {\n      color: ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0 100px ", " inset !important;\n      color: ", " !important;\n    }\n\n    &:-internal-autofill-selected {\n      color: ", " !important;\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.textSecondary;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.controlBg;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
  }),
  accent: css$1(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject$a(["\n    color: ", ";\n    opacity: 1;\n\n    &:disabled {\n      color: ", ";\n      opacity: 0.5;\n    }\n\n    &::placeholder {\n      color: ", ";\n      opacity: 0.5;\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0 100px ", "\n        inset !important;\n      color: ", " !important;\n    }\n\n    &:-internal-autofill-selected {\n      color: ", " !important;\n    }\n  "], ["\n    color: ", ";\n    opacity: 1;\n\n    &:disabled {\n      color: ", ";\n      opacity: 0.5;\n    }\n\n    &::placeholder {\n      color: ", ";\n      opacity: 0.5;\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0 100px ", "\n        inset !important;\n      color: ", " !important;\n    }\n\n    &:-internal-autofill-selected {\n      color: ", " !important;\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.accentText;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentText;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentText;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentControlBg;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentContrast;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.accentContrast;
  })
};
var InputStyle = styled.input.withConfig({
  displayName: "InputStyles__InputStyle",
  componentId: "sc-kdtshm-2"
})(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject$a(["\n  width: 100%;\n  font-family: inherit;\n  font-weight: 400;\n  font-size: 1em;\n  line-height: 1.43em;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  outline: none;\n  position: relative;\n  top: ", "px;\n\n  &::placeholder {\n    transition: opacity ", " ease;\n  }\n\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  font-family: inherit;\n  font-weight: 400;\n  font-size: 1em;\n  line-height: 1.43em;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  outline: none;\n  position: relative;\n  top: ", "px;\n\n  &::placeholder {\n    transition: opacity ", " ease;\n  }\n\n  ", "\n  ", "\n"])), function (_a) {
  var $labeled = _a.$labeled;
  return $labeled ? 8 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.duration.fast;
}, function (_a) {
  var $color = _a.$color;
  return inputColors[$color];
}, function (_a) {
  var $labeled = _a.$labeled;
  return $labeled ? labeledCSS : '';
});
styled(InputStyle).attrs({
  as: 'textarea'
}).withConfig({
  displayName: "InputStyles__TextareaStyle",
  componentId: "sc-kdtshm-3"
})(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject$a(["\n  resize: none;\n"], ["\n  resize: none;\n"])));
var messageVariants = {
  error: css$1(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject$a(["\n    background: ", ";\n    color: ", ";\n    box-shadow: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n    box-shadow: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.errorContrast;
  }, function (_a) {
    var theme = _a.theme;
    return theme.boxShadows.sm + " " + theme.colors.shadowLight;
  }),
  success: css$1(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject$a(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.success;
  })
};
var InputMessageStyle = styled.span.withConfig({
  displayName: "InputStyles__InputMessageStyle",
  componentId: "sc-kdtshm-4"
})(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject$a(["\n  margin-top: ", "px;\n  left: ", "px;\n  position: absolute;\n  top: 100%;\n  line-height: 1.6em;\n  font-weight: 400;\n  font-size: ", "px;\n  border-radius: ", "px;\n  padding: 6px 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  box-sizing: border-box;\n  text-overflow: ellipsis;\n  max-width: ", ";\n\n  ", "\n"], ["\n  margin-top: ", "px;\n  left: ", "px;\n  position: absolute;\n  top: 100%;\n  line-height: 1.6em;\n  font-weight: 400;\n  font-size: ", "px;\n  border-radius: ", "px;\n  padding: 6px 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  box-sizing: border-box;\n  text-overflow: ellipsis;\n  max-width: ", ";\n\n  ", "\n"])), function (_a) {
  var $bordered = _a.$bordered;
  return $bordered ? 5 : 6;
}, function (_a) {
  var $bordered = _a.$bordered;
  return $bordered ? -1 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.sm;
}, function (_a) {
  var $bordered = _a.$bordered;
  return $bordered ? 'calc(100% + 2px)' : '100%';
}, function (_a) {
  var $variant = _a.$variant;
  return messageVariants[$variant];
});
var decoratorCSS$1 = css$1(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject$a(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  cursor: inherit;\n  display: flex;\n  align-items: center;\n"], ["\n  flex-grow: 0;\n  flex-shrink: 0;\n  cursor: inherit;\n  display: flex;\n  align-items: center;\n"])));
var InputLeftDecoratorStyle = styled.span.withConfig({
  displayName: "InputStyles__InputLeftDecoratorStyle",
  componentId: "sc-kdtshm-5"
})(templateObject_19 || (templateObject_19 = __makeTemplateObject$a(["\n  ", "\n  padding-right: 16px;\n"], ["\n  ", "\n  padding-right: 16px;\n"])), decoratorCSS$1);
var InputRightDecoratorStyle = styled.span.withConfig({
  displayName: "InputStyles__InputRightDecoratorStyle",
  componentId: "sc-kdtshm-6"
})(templateObject_20 || (templateObject_20 = __makeTemplateObject$a(["\n  ", "\n  padding-left: 16px;\n"], ["\n  ", "\n  padding-left: 16px;\n"])), decoratorCSS$1);
var templateObject_1$l, templateObject_2$d, templateObject_3$7, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16$1, templateObject_17$1, templateObject_18$1, templateObject_19, templateObject_20;

function Input(props, ref) {
  var label = props.label,
      error = props.error,
      success = props.success,
      _a = props.active,
      active = _a === void 0 ? false : _a,
      _b = props.fullwidth,
      fullwidth = _b === void 0 ? false : _b,
      _c = props.placeholder,
      placeholder = _c === void 0 ? ' ' : _c,
      leftDecorator = props.leftDecorator,
      rightDecorator = props.rightDecorator,
      className = props.className,
      style = props.style,
      _d = props.variant,
      variant = _d === void 0 ? 'default' : _d,
      _e = props.color,
      color = _e === void 0 ? 'default' : _e,
      wrapperRef = props.wrapperRef;
      props.children;
      var rest = __rest$2(props, ["label", "error", "success", "active", "fullwidth", "placeholder", "leftDecorator", "rightDecorator", "className", "style", "variant", "color", "wrapperRef", "children"]);

  var id = props.id,
      _f = props.disabled,
      disabled = _f === void 0 ? false : _f;
  var wrapperProps = {
    className: className,
    style: style
  };
  var hasLabel = !!label && variant === 'default';
  var hasError = !!error;
  var hasErrorMessage = hasError && typeof error !== 'boolean';
  var hasSuccess = !!success && !error;
  var hasSuccessMessage = hasSuccess && typeof success !== 'boolean';
  var hasLeftDecorator = !!leftDecorator;
  var hasRightDecorator = !!rightDecorator;
  return jsxs(InputWrapperStyle, __assign$5({
    "$error": hasError,
    "$active": active,
    "$disabled": disabled,
    "$fullwidth": fullwidth,
    "$color": color,
    htmlFor: id,
    ref: wrapperRef
  }, wrapperProps, {
    children: [hasLeftDecorator && jsx(InputLeftDecoratorStyle, {
      children: leftDecorator
    }, void 0), jsxs(InputContentStyle, __assign$5({
      "$variant": variant
    }, {
      children: [jsx(InputStyle, __assign$5({
        "$labeled": hasLabel,
        "$color": color,
        placeholder: placeholder,
        "aria-invalid": hasError,
        type: 'text',
        ref: ref
      }, rest), void 0), hasLabel && jsx(InputLabelStyle, __assign$5({
        "$color": color
      }, {
        children: label
      }), void 0)]
    }), void 0), hasErrorMessage && jsx(InputMessageStyle, __assign$5({
      "$variant": 'error',
      "$bordered": true
    }, {
      children: error
    }), void 0), hasSuccessMessage && jsx(InputMessageStyle, __assign$5({
      "$variant": 'success',
      "$bordered": true
    }, {
      children: success
    }), void 0), hasRightDecorator && jsx(InputRightDecoratorStyle, {
      children: rightDecorator
    }, void 0)]
  }), void 0);
}

var Input$1 = /*#__PURE__*/forwardRef(Input);

styled.span.withConfig({
  displayName: "InputGroupStyles__InputGroupStyle",
  componentId: "sc-j8n6cl-0"
})(templateObject_1$k || (templateObject_1$k = __makeTemplateObject$a(["\n  display: inline-flex;\n  position: relative;\n  width: ", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
  var $fullwidth = _a.$fullwidth;
  return $fullwidth ? '100%' : 'auto';
});
styled.span.withConfig({
  displayName: "InputGroupStyles__InputGroupContentStyle",
  componentId: "sc-j8n6cl-1"
})(templateObject_2$c || (templateObject_2$c = __makeTemplateObject$a(["\n  display: flex;\n  width: 100%;\n\n  & > * {\n    border-radius: 0px;\n    margin: 0 -1px 0 0;\n\n    &:first-child {\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n    }\n\n    &:last-child {\n      margin-right: 0;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n    }\n  }\n"], ["\n  display: flex;\n  width: 100%;\n\n  & > * {\n    border-radius: 0px;\n    margin: 0 -1px 0 0;\n\n    &:first-child {\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n    }\n\n    &:last-child {\n      margin-right: 0;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
});
var templateObject_1$k, templateObject_2$c;

var InputMessageVariant;

(function (InputMessageVariant) {
  InputMessageVariant[InputMessageVariant["error"] = 0] = "error";
  InputMessageVariant[InputMessageVariant["success"] = 1] = "success";
})(InputMessageVariant || (InputMessageVariant = {}));

var InputType;

(function (InputType) {
  InputType[InputType["text"] = 0] = "text";
  InputType[InputType["password"] = 1] = "password";
  InputType[InputType["number"] = 2] = "number";
  InputType[InputType["email"] = 3] = "email";
  InputType[InputType["search"] = 4] = "search";
  InputType[InputType["tel"] = 5] = "tel";
  InputType[InputType["url"] = 6] = "url";
})(InputType || (InputType = {}));

var InputVariant;

(function (InputVariant) {
  InputVariant[InputVariant["small"] = 0] = "small";
  InputVariant[InputVariant["default"] = 1] = "default";
})(InputVariant || (InputVariant = {}));

var InputColor;

(function (InputColor) {
  InputColor[InputColor["default"] = 0] = "default";
  InputColor[InputColor["accent"] = 1] = "accent";
})(InputColor || (InputColor = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$9(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.div.withConfig({
  displayName: "LidoLogoStyles",
  componentId: "sc-fifpqw-0"
})(templateObject_1$j || (templateObject_1$j = __makeTemplateObject$9(["\n  color: ", ";\n  line-height: 0;\n"], ["\n  color: ", ";\n  line-height: 0;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
});
var templateObject_1$j;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$4 = function() {
    __assign$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};

function __makeTemplateObject$8(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var LinkStyle = styled.a.withConfig({
  displayName: "LinkStyles__LinkStyle",
  componentId: "sc-msugut-0"
})(templateObject_2$b || (templateObject_2$b = __makeTemplateObject$8(["\n  text-decoration: none;\n  color: ", ";\n\n  :hover {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  text-decoration: none;\n  color: ", ";\n\n  :hover {\n    color: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primaryHover;
}, function (props) {
  return props.fadeVisited && css$1(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$8(["\n      :visited {\n        color: ", ";\n      }\n    "], ["\n      :visited {\n        color: ", ";\n      }\n    "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryVisited;
  });
});
var templateObject_1$i, templateObject_2$b;

function Link(props, ref) {
  return jsx(LinkStyle, __assign$4({
    target: '_blank',
    rel: 'nofollow noopener',
    ref: ref
  }, props), void 0);
}

var Link$1 = /*#__PURE__*/forwardRef(Link);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$7(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.div.withConfig({
  displayName: "ModalStyles__ModalStyle",
  componentId: "sc-xqinpq-0"
})(templateObject_2$a || (templateObject_2$a = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      fontSizesMap = _b.fontSizesMap,
      borderRadiusesMap = _b.borderRadiusesMap,
      colors = _b.colors,
      boxShadows = _b.boxShadows,
      $center = _a.$center;
  return css$1(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$7(["\n    width: 432px;\n    max-width: 100%;\n    font-weight: 400;\n    font-size: ", "px;\n    line-height: 1.5em;\n    text-align: ", ";\n    border-radius: ", "px;\n    box-shadow: ", " ", ";\n  "], ["\n    width: 432px;\n    max-width: 100%;\n    font-weight: 400;\n    font-size: ", "px;\n    line-height: 1.5em;\n    text-align: ", ";\n    border-radius: ", "px;\n    box-shadow: ", " ", ";\n  "])), fontSizesMap.xs, $center ? 'center' : 'left', borderRadiusesMap.xl, boxShadows.xxl, colors.shadowDark);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalBaseStyle",
  componentId: "sc-xqinpq-1"
})(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var colors = _a.theme.colors;
  return css$1(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject$7(["\n    color: ", ";\n    background: ", ";\n    border-radius: inherit;\n    position: relative;\n    z-index: 1;\n  "], ["\n    color: ", ";\n    background: ", ";\n    border-radius: inherit;\n    position: relative;\n    z-index: 1;\n  "])), colors.text, colors.foreground);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalHeaderStyle",
  componentId: "sc-xqinpq-2"
})(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      spaceMap = _b.spaceMap,
      fontSizesMap = _b.fontSizesMap,
      mediaQueries = _b.mediaQueries,
      $short = _a.$short;
  return css$1(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject$7(["\n    display: flex;\n    align-items: flex-start;\n    min-height: 32px;\n    margin-bottom: ", "px;\n    padding: ", "px ", "px;\n    font-size: ", "px;\n    line-height: 1.5em;\n\n    ", " {\n      padding: ", "px;\n    }\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    min-height: 32px;\n    margin-bottom: ", "px;\n    padding: ", "px ", "px;\n    font-size: ", "px;\n    line-height: 1.5em;\n\n    ", " {\n      padding: ", "px;\n    }\n  "])), $short ? -spaceMap.md : 0, spaceMap.xl, spaceMap.xxl, fontSizesMap.md, mediaQueries.md, spaceMap.lg);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalTitleStyle",
  componentId: "sc-xqinpq-3"
})(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      fontSizesMap = _b.fontSizesMap,
      spaceMap = _b.spaceMap,
      mediaQueries = _b.mediaQueries,
      $center = _a.$center,
      $withBackButton = _a.$withBackButton,
      $withCloseButton = _a.$withCloseButton,
      $withTitleIcon = _a.$withTitleIcon;
  return css$1(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject$7(["\n    font-size: ", "px;\n    line-height: 1.5em;\n    font-weight: 700;\n    margin-left: ", "px;\n    margin-right: ", "px;\n    padding-top: ", "px;\n    padding-left: 0;\n    padding-right: ", "px;\n    flex-grow: 1;\n    align-self: center;\n\n    ", " {\n      padding-right: ", "px;\n    }\n  "], ["\n    font-size: ", "px;\n    line-height: 1.5em;\n    font-weight: 700;\n    margin-left: ", "px;\n    margin-right: ", "px;\n    padding-top: ", "px;\n    padding-left: 0;\n    padding-right: ", "px;\n    flex-grow: 1;\n    align-self: center;\n\n    ", " {\n      padding-right: ", "px;\n    }\n  "])), fontSizesMap.sm, $center && !$withBackButton ? spaceMap.xxl : '0', $center && !$withCloseButton ? spaceMap.xxl : '0', $withTitleIcon ? spaceMap.sm : '0', spaceMap.sm, mediaQueries.md, spaceMap.xs);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalTitleIconStyle",
  componentId: "sc-xqinpq-4"
})(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var spaceMap = _a.theme.spaceMap,
      $center = _a.$center;
  return css$1(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject$7(["\n    display: ", ";\n    justify-content: ", ";\n    line-height: 0.7;\n    margin-bottom: ", "px;\n  "], ["\n    display: ", ";\n    justify-content: ", ";\n    line-height: 0.7;\n    margin-bottom: ", "px;\n  "])), $center ? 'flex' : 'block', $center ? 'center' : 'flex-start', spaceMap.md);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalTitleTextStyle",
  componentId: "sc-xqinpq-5"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject$7(["\n  margin: ", "px 0;\n"], ["\n  margin: ", "px 0;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xs;
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalSubtitleStyle",
  componentId: "sc-xqinpq-6"
})(templateObject_13 || (templateObject_13 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      colors = _b.colors,
      fontSizesMap = _b.fontSizesMap,
      spaceMap = _b.spaceMap,
      mediaQueries = _b.mediaQueries;
  return css$1(templateObject_12 || (templateObject_12 = __makeTemplateObject$7(["\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 400;\n    line-height: 24px;\n    margin-top: -", "px;\n    padding: 0 ", "px ", "px;\n\n    ", " {\n      padding-left: ", "px;\n      padding-right: ", "px;\n    }\n  "], ["\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 400;\n    line-height: 24px;\n    margin-top: -", "px;\n    padding: 0 ", "px ", "px;\n\n    ", " {\n      padding-left: ", "px;\n      padding-right: ", "px;\n    }\n  "])), colors.textSecondary, fontSizesMap.xs, spaceMap.xl, spaceMap.xxl, spaceMap.sm, mediaQueries.md, spaceMap.xl, spaceMap.xl);
});
styled.div.withConfig({
  displayName: "ModalStyles__ModalContentStyle",
  componentId: "sc-xqinpq-7"
})(templateObject_15 || (templateObject_15 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      spaceMap = _b.spaceMap,
      mediaQueries = _b.mediaQueries;
  return css$1(templateObject_14 || (templateObject_14 = __makeTemplateObject$7(["\n    padding: 0 ", "px ", "px;\n\n    ", " {\n      padding: 0 ", "px ", "px;\n    }\n  "], ["\n    padding: 0 ", "px ", "px;\n\n    ", " {\n      padding: 0 ", "px ", "px;\n    }\n  "])), spaceMap.xxl, spaceMap.xxl, mediaQueries.md, spaceMap.lg, spaceMap.lg);
});
styled(ButtonIcon$1).attrs({
  icon: jsx(Close, {}, void 0),
  color: 'secondary',
  variant: 'ghost',
  size: 'xs'
}).withConfig({
  displayName: "ModalStyles__ModalCloseStyle",
  componentId: "sc-xqinpq-8"
})(templateObject_16 || (templateObject_16 = __makeTemplateObject$7(["\n  margin: 0 -10px 0 0;\n  color: ", ";\n  flex-shrink: 0;\n  border-radius: 50%;\n"], ["\n  margin: 0 -10px 0 0;\n  color: ", ";\n  flex-shrink: 0;\n  border-radius: 50%;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
});
styled(ButtonIcon$1).attrs({
  icon: jsx(ArrowBack, {}, void 0),
  color: 'secondary',
  variant: 'ghost',
  size: 'xs'
}).withConfig({
  displayName: "ModalStyles__ModalBackStyle",
  componentId: "sc-xqinpq-9"
})(templateObject_18 || (templateObject_18 = __makeTemplateObject$7(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.theme,
      colors = _b.colors,
      spaceMap = _b.spaceMap;
  return css$1(templateObject_17 || (templateObject_17 = __makeTemplateObject$7(["\n    color: ", ";\n    flex-shrink: 0;\n    margin: 0 ", "px 0 -6px;\n    border-radius: 50%;\n    background: transparent !important;\n  "], ["\n    color: ", ";\n    flex-shrink: 0;\n    margin: 0 ", "px 0 -6px;\n    border-radius: 50%;\n    background: transparent !important;\n  "])), colors.textSecondary, spaceMap.sm);
});
var templateObject_1$h, templateObject_2$a, templateObject_3$6, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;

var getOpacity = function getOpacity(_a) {
  var $transition = _a.$transition;
  return ['exiting', 'exited'].includes($transition) ? 0 : 1;
};

styled.div.withConfig({
  displayName: "ModalOverlayStyles__ModalPortalStyle",
  componentId: "sc-8htcwt-0"
})(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$7(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 300;\n  background: ", ";\n  cursor: ", ";\n  transition: opacity ", "ms ease;\n  opacity: ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 300;\n  background: ", ";\n  cursor: ", ";\n  transition: opacity ", "ms ease;\n  opacity: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.overlay;
}, function (_a) {
  var $closable = _a.$closable;
  return $closable ? 'pointer' : 'default';
}, function (_a) {
  var $duration = _a.$duration;
  return $duration;
}, getOpacity);
styled.div.withConfig({
  displayName: "ModalOverlayStyles__ModalOverflowStyle",
  componentId: "sc-8htcwt-1"
})(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject$7(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  overflow: auto;\n  overflow-x: hidden;\n  display: flex;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  overflow: auto;\n  overflow-x: hidden;\n  display: flex;\n"])));

var getTransform = function getTransform(_a) {
  var $transition = _a.$transition;
  return ['exiting', 'exited'].includes($transition) ? 'translateY(6px)' : 'translateY(0)';
};

styled.div.withConfig({
  displayName: "ModalOverlayStyles__ModalContentStyle",
  componentId: "sc-8htcwt-2"
})(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject$7(["\n  box-sizing: border-box;\n  max-width: 100%;\n  padding: ", "px;\n  outline: none;\n  margin: auto;\n  cursor: default;\n  transition: transform ", "ms ease-out;\n  transform: ", ";\n  pointer-events: none;\n\n  & > * {\n    pointer-events: auto;\n  }\n"], ["\n  box-sizing: border-box;\n  max-width: 100%;\n  padding: ", "px;\n  outline: none;\n  margin: auto;\n  cursor: default;\n  transition: transform ", "ms ease-out;\n  transform: ", ";\n  pointer-events: none;\n\n  & > * {\n    pointer-events: auto;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var $duration = _a.$duration;
  return $duration;
}, getTransform);
var templateObject_1$g, templateObject_2$9, templateObject_3$5;

styled.div.withConfig({
  displayName: "ModalExtraStyles__ModalExtraStyle",
  componentId: "sc-qzx03h-0"
})(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$7(["\n  margin-top: ", "px;\n  color: ", ";\n  background: ", ";\n  padding: ", "px;\n  padding-top: ", "px;\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n\n  ", " {\n    padding: ", "px;\n    padding-top: ", "px;\n  }\n"], ["\n  margin-top: ", "px;\n  color: ", ";\n  background: ", ";\n  padding: ", "px;\n  padding-top: ", "px;\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n\n  ", " {\n    padding: ", "px;\n    padding-top: ", "px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return -theme.borderRadiusesMap.xl;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accentContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.xl + theme.spaceMap.xxl;
}, function (_a) {
  var theme = _a.theme;
  return theme.mediaQueries.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.xl + theme.spaceMap.lg;
});
var templateObject_1$f;

styled(Button$1).withConfig({
  displayName: "ModalButtonStyles__ModalButtonStyle",
  componentId: "sc-atbxcr-0"
})(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$7(["\n  border: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n\n  :not(:disabled):hover,\n  :focus-visible {\n    background-color: rgba(0, 163, 255, 0.1);\n    color: ", ";\n  }\n"], ["\n  border: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n\n  :not(:disabled):hover,\n  :focus-visible {\n    background-color: rgba(0, 163, 255, 0.1);\n    color: ", ";\n  }\n"])), function (_a) {
  var active = _a.active,
      theme = _a.theme;
  return active ? "1px solid " + theme.colors.primary : "1px solid " + theme.colors.background;
}, function (_a) {
  var active = _a.active,
      theme = _a.theme;
  return active ? 'rgba(0, 163, 255, 0.1);' : theme.colors.background;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
});
styled.span.withConfig({
  displayName: "ModalButtonStyles__ModalButtonContentStyle",
  componentId: "sc-atbxcr-1"
})(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject$7(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"])));
var templateObject_1$e, templateObject_2$8;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$6(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var PaginationItemVariant;

(function (PaginationItemVariant) {
  PaginationItemVariant["default"] = "default";
  PaginationItemVariant["active"] = "active";
})(PaginationItemVariant || (PaginationItemVariant = {}));

var _a;
var variantColors = (_a = {}, _a[PaginationItemVariant.active] = css$1(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$6(["\n    border-color: ", ";\n    color: ", ";\n\n    :not(:disabled):hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    color: ", ";\n\n    :not(:disabled):hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  "])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primaryVisited;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primaryVisited;
}), _a[PaginationItemVariant["default"]] = css$1(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject$6(["\n    border-color: ", ";\n    color: ", ";\n\n    :not(:disabled):hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    color: ", ";\n\n    :not(:disabled):hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  "])), function (_a) {
  var theme = _a.theme;
  return theme.colors.border;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}), _a);
styled.button.withConfig({
  displayName: "PaginationItemStyles__PaginationItemStyle",
  componentId: "sc-1ffe10h-0"
})(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject$6(["\n  width: 32px;\n  height: 32px;\n  background-color: ", ";\n  border: 1px solid;\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 0;\n\n  ", "\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n    cursor: unset;\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n  background-color: ", ";\n  border: 1px solid;\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 0;\n\n  ", "\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n    cursor: unset;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.foreground;
}, function (_a) {
  var $variant = _a.$variant;
  return variantColors[$variant];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.border;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
});
var templateObject_1$d, templateObject_2$7, templateObject_3$4;

styled(Box$1).withConfig({
  displayName: "Pagination__PaginationBlock",
  componentId: "sc-1tusvn0-0"
})(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$6(["\n  display: flex;\n  gap: 8px;\n"], ["\n  display: flex;\n  gap: 8px;\n"])));
var templateObject_1$c;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$3 = function() {
    __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$5(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var Context = /*#__PURE__*/createContext({});
var PopupMenuProvider = function PopupMenuProvider(props) {
  var variant = props.variant,
      rest = __rest$1(props, ["variant"]);

  return jsx(Context.Provider, __assign$3({
    value: {
      variant: variant
    }
  }, rest), void 0);
};

var PopupMenuItemStyle = styled.button.withConfig({
  displayName: "PopupMenuItemStyles__PopupMenuItemStyle",
  componentId: "sc-j0keqv-0"
})(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$5(["\n  text-align: left;\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  background: transparent;\n  border-radius: 0;\n  color: ", ";\n  border: none;\n  box-shadow: none;\n  outline: none;\n  cursor: pointer;\n  padding: 0 15px;\n  margin: 0;\n  position: relative;\n\n  &:disabled {\n    cursor: default;\n    color: ", ";\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    opacity: ", ";\n    background: ", ";\n    transition: opacity ", " ease;\n  }\n\n  &:focus:not(:disabled):before {\n    opacity: 0.04;\n  }\n"], ["\n  text-align: left;\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  background: transparent;\n  border-radius: 0;\n  color: ", ";\n  border: none;\n  box-shadow: none;\n  outline: none;\n  cursor: pointer;\n  padding: 0 15px;\n  margin: 0;\n  position: relative;\n\n  &:disabled {\n    cursor: default;\n    color: ", ";\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    opacity: ", ";\n    background: ", ";\n    transition: opacity ", " ease;\n  }\n\n  &:focus:not(:disabled):before {\n    opacity: 0.04;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
}, function (_a) {
  var $active = _a.$active;
  return $active ? 0.04 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.popupMenuItemBgActiveHover;
}, function (_a) {
  var theme = _a.theme;
  return theme.duration.fast;
});
var variants = {
  small: css$1(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject$5(["\n    padding: 12px 0;\n    font-size: ", "px;\n    line-height: 1.35em;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-weight: 800;\n  "], ["\n    padding: 12px 0;\n    font-size: ", "px;\n    line-height: 1.35em;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-weight: 800;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xxs;
  }),
  "default": css$1(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject$5(["\n    padding: 18px 0;\n    font-size: ", "px;\n    line-height: 1.4em;\n    font-weight: 400;\n  "], ["\n    padding: 18px 0;\n    font-size: ", "px;\n    line-height: 1.4em;\n    font-weight: 400;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizesMap.xs;
  })
};
styled.span.withConfig({
  displayName: "PopupMenuItemStyles__PopupMenuItemContentStyle",
  componentId: "sc-j0keqv-1"
})(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject$5(["\n  position: relative;\n  padding: 18px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"], ["\n  position: relative;\n  padding: 18px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"])), function (_a) {
  var $variant = _a.$variant;
  return variants[$variant];
});
var decoratorCSS = css$1(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject$5(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  cursor: default;\n  display: flex;\n  align-items: center;\n"], ["\n  flex-grow: 0;\n  flex-shrink: 0;\n  cursor: default;\n  display: flex;\n  align-items: center;\n"])));
styled.span.withConfig({
  displayName: "PopupMenuItemStyles__PopupMenuItemLeftDecoratorStyle",
  componentId: "sc-j0keqv-2"
})(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject$5(["\n  ", "\n  padding-right: 16px;\n"], ["\n  ", "\n  padding-right: 16px;\n"])), decoratorCSS);
styled.span.withConfig({
  displayName: "PopupMenuItemStyles__PopupMenuItemRightDecoratorStyle",
  componentId: "sc-j0keqv-3"
})(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject$5(["\n  ", "\n  padding-left: 16px;\n"], ["\n  ", "\n  padding-left: 16px;\n"])), decoratorCSS);
var templateObject_1$b, templateObject_2$6, templateObject_3$3, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var PopupMenuStyle = styled(Popover$1).withConfig({
  displayName: "PopupMenuStyles__PopupMenuStyle",
  componentId: "sc-tdldis-0"
})(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$5(["\n  outline: none;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  border-radius: ", "px;\n  overflow: auto;\n  overflow-x: hidden;\n  box-shadow: ", ";\n  padding: 0;\n\n  ", ":first-child {\n    border-top-left-radius: ", "px;\n    border-top-right-radius: ", "px;\n  }\n\n  ", ":last-child {\n    border-bottom-left-radius: ", "px;\n    border-bottom-right-radius: ", "px;\n  }\n"], ["\n  outline: none;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  border-radius: ", "px;\n  overflow: auto;\n  overflow-x: hidden;\n  box-shadow: ", ";\n  padding: 0;\n\n  ", ":first-child {\n    border-top-left-radius: ", "px;\n    border-top-right-radius: ", "px;\n  }\n\n  ", ":last-child {\n    border-bottom-left-radius: ", "px;\n    border-bottom-right-radius: ", "px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.boxShadows.xs + " " + theme.colors.shadowLight;
}, PopupMenuItemStyle, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg - 1;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg - 1;
}, PopupMenuItemStyle, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg - 1;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.lg - 1;
});
var templateObject_1$a;

var FOCUSABLE_ELEMENTS = ['a[href]', 'button:not([disabled]):not([aria-hidden])', '[tabindex]:not([tabindex^="-"])'];

var usePopupFocus = function usePopupFocus(props) {
  var onMouseMove = props.onMouseMove,
      onKeyDown = props.onKeyDown;
  var ref = useRef(null);
  var getFocusableNodes = useCallback(function () {
    var _a, _b;

    var nodes = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(FOCUSABLE_ELEMENTS.join(','))) !== null && _b !== void 0 ? _b : [];
    return Array.from(nodes).filter(function (node) {
      return node && node instanceof HTMLElement && node.offsetParent !== null;
    });
  }, []);
  var handleFocusTo = useCallback(function (event, offset) {
    if (offset === void 0) {
      offset = 1;
    }

    var focusableNodes = getFocusableNodes();
    if (focusableNodes.length === 0) return;
    var currentElement = document.activeElement;
    var focusedItemIndex = currentElement instanceof HTMLElement && focusableNodes.indexOf(currentElement);
    var activeItemIndex = focusableNodes.findIndex(function (node) {
      return node.getAttribute('aria-selected') === 'true';
    });
    var currentIndex = focusedItemIndex === -1 ? activeItemIndex : focusedItemIndex;
    var nextIndex = currentIndex + offset;
    if (nextIndex < 0) nextIndex = focusableNodes.length - 1;
    if (nextIndex >= focusableNodes.length) nextIndex = 0;
    focusableNodes[nextIndex].focus();
    event.preventDefault();
  }, [getFocusableNodes]);
  var handleMouseMove = useCallback(function (event) {
    onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(event);
    var target = event.target;
    if (!(target instanceof HTMLElement)) return;
    var focusableNodes = getFocusableNodes();
    var overed = target.closest(FOCUSABLE_ELEMENTS.join(','));
    if (!(overed instanceof HTMLElement)) return;
    var isNotFocusable = !focusableNodes.includes(overed);
    var isActive = overed === document.activeElement;
    if (isActive || isNotFocusable) return;
    overed.focus();
  }, [getFocusableNodes, onMouseMove]);
  var handleKeyDown = useCallback(function (event) {
    var _a;

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    var code = (_a = event.code) !== null && _a !== void 0 ? _a : event.key;
    if (code === 'Tab') event.preventDefault();
    if (code === 'ArrowDown') handleFocusTo(event, +1);
    if (code === 'ArrowUp') handleFocusTo(event, -1);
  }, [handleFocusTo, onKeyDown]);

  var _a = useInterceptFocus(),
      interceptFocus = _a[0],
      restoreFocus = _a[1];

  var handleEnter = useCallback(function () {
    if (ref.current) interceptFocus(ref.current);
  }, [interceptFocus]);
  var handleExit = useCallback(function () {
    restoreFocus();
  }, [restoreFocus]);
  return {
    ref: ref,
    handleMouseMove: handleMouseMove,
    handleKeyDown: handleKeyDown,
    handleEnter: handleEnter,
    handleExit: handleExit
  };
};

function PopupMenu(props, externalRef) {
  var variant = props.variant,
      children = props.children;
      props.onKeyDown;
      props.onMouseMove;
      var rest = __rest$1(props, ["variant", "children", "onKeyDown", "onMouseMove"]);

  var _a = usePopupFocus(props),
      controlRef = _a.ref,
      handleMouseMove = _a.handleMouseMove,
      handleKeyDown = _a.handleKeyDown,
      handleEnter = _a.handleEnter,
      handleExit = _a.handleExit;

  var popupRef = useMergeRefs([controlRef, externalRef]);
  return jsx(PopupMenuStyle, __assign$3({
    onMouseMove: handleMouseMove,
    onKeyDown: handleKeyDown,
    onEnter: handleEnter,
    onExit: handleExit,
    tabIndex: -1,
    role: 'listbox'
  }, rest, {
    ref: popupRef
  }, {
    children: jsx(PopupMenuProvider, __assign$3({
      variant: variant
    }, {
      children: children
    }), void 0)
  }), void 0);
}

var PopupMenu$1 = /*#__PURE__*/forwardRef(PopupMenu);

var PopupMenuVariant;

(function (PopupMenuVariant) {
  PopupMenuVariant[PopupMenuVariant["small"] = 0] = "small";
  PopupMenuVariant[PopupMenuVariant["default"] = 1] = "default";
})(PopupMenuVariant || (PopupMenuVariant = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject$4(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var smallCSS = css$1(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$4(["\n  input {\n    font-size: ", "px;\n    line-height: 1.7em;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-weight: 800;\n  }\n"], ["\n  input {\n    font-size: ", "px;\n    line-height: 1.7em;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-weight: 800;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
});
var SelectWrapperStyle = styled(Input$1).withConfig({
  displayName: "SelectStyles__SelectWrapperStyle",
  componentId: "sc-1dvslu4-0"
})(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject$4(["\n  &,\n  input {\n    user-select: none;\n    cursor: ", ";\n\n    &::selection {\n      background: transparent;\n    }\n  }\n\n  input {\n    appearance: none;\n    overflow: hidden;\n  }\n\n  ", "\n"], ["\n  &,\n  input {\n    user-select: none;\n    cursor: ", ";\n\n    &::selection {\n      background: transparent;\n    }\n  }\n\n  input {\n    appearance: none;\n    overflow: hidden;\n  }\n\n  ", "\n"])), function (_a) {
  var disabled = _a.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_a) {
  var variant = _a.variant;
  return variant === 'small' ? smallCSS : '';
});
var templateObject_1$9, templateObject_2$5;

var commonCSS = css$1(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$4(["\n  transform: rotate(", "deg);\n  transition: transform ", " ease;\n  opacity: ", ";\n"], ["\n  transform: rotate(", "deg);\n  transition: transform ", " ease;\n  opacity: ", ";\n"])), function (_a) {
  var $opened = _a.$opened;
  return $opened ? 180 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.duration.norm;
}, function (_a) {
  var $disabled = _a.$disabled;
  return $disabled ? 0.5 : 1;
});
var SelectArrowBigStyle = styled(ArrowBottom).withConfig({
  displayName: "SelectArrowStyles__SelectArrowBigStyle",
  componentId: "sc-5nwf17-0"
})(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$4(["\n  ", "\n  fill: ", ";\n"], ["\n  ", "\n  fill: ", ";\n"])), commonCSS, function (_a) {
  var theme = _a.theme;
  return theme.colors.textSecondary;
});
var SelectArrowSmallStyle = styled.div.withConfig({
  displayName: "SelectArrowStyles__SelectArrowSmallStyle",
  componentId: "sc-5nwf17-1"
})(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject$4(["\n  ", "\n  color: ", ";\n\n  border: 3px solid currentColor;\n  border-bottom-width: 0px;\n  border-left-color: transparent;\n  border-right-color: transparent;\n"], ["\n  ", "\n  color: ", ";\n\n  border: 3px solid currentColor;\n  border-bottom-width: 0px;\n  border-left-color: transparent;\n  border-right-color: transparent;\n"])), commonCSS, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
});
var templateObject_1$8, templateObject_2$4, templateObject_3$2;

var SelectArrow$1 = function SelectArrow(props) {
  var arrow = props.arrow,
      _a = props.disabled,
      disabled = _a === void 0 ? false : _a,
      opened = props.opened;
  var commonProps = {
    $opened: opened,
    $disabled: disabled
  };
  if (arrow === 'default') return jsx(SelectArrowBigStyle, __assign$2({}, commonProps), void 0);
  if (arrow === 'small') return jsx(SelectArrowSmallStyle, __assign$2({}, commonProps), void 0);
  return null;
};

var useSelect = function useSelect(props) {
  var _a, _b;

  var disabled = props.disabled,
      onClick = props.onClick,
      onChange = props.onChange,
      onKeyDown = props.onKeyDown,
      children = props.children;

  var _c = useState(false),
      opened = _c[0],
      setOpened = _c[1];

  var handleOpen = useCallback(function () {
    if (disabled) return;
    setOpened(true);
  }, [disabled]);
  var handleClick = useCallback(function (event) {
    handleOpen();
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [handleOpen, onClick]);
  var handleClose = useCallback(function () {
    setOpened(false);
  }, []);
  var handleChange = useCallback(function (value) {
    handleClose();
    setLocalValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  }, [handleClose, onChange]);
  var handleKeyDown = useCallback(function (event) {
    if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
      event.preventDefault();
      handleOpen();
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  }, [handleOpen, onKeyDown]);
  var outerValue = (_b = (_a = props.value) !== null && _a !== void 0 ? _a : props.defaultValue) !== null && _b !== void 0 ? _b : null;

  var _d = useState(outerValue),
      localValue = _d[0],
      setLocalValue = _d[1];

  useEffect(function () {
    setLocalValue(outerValue);
  }, [outerValue]);

  var _e = useMemo(function () {
    var values = new Map();
    var options = Children.map(children, function (child) {
      if (!reactIs.exports.isElement(child)) return child;
      var value = child.props.value;
      var title = String(child.props.children);

      if (values.get(value) === undefined) {
        values.set(value, title);
      }

      return /*#__PURE__*/cloneElement(child, {
        active: value === localValue,
        onChange: handleChange
      });
    });
    return {
      values: values,
      options: options
    };
  }, [localValue, children, handleChange]),
      values = _e.values,
      options = _e.options;

  var selectedTitle = localValue != null ? values.get(localValue) : null;
  var defaultTitle = String(localValue !== null && localValue !== void 0 ? localValue : '');
  var title = selectedTitle !== null && selectedTitle !== void 0 ? selectedTitle : defaultTitle;
  return {
    handleClick: handleClick,
    handleClose: handleClose,
    handleKeyDown: handleKeyDown,
    opened: opened,
    title: title,
    options: options
  };
};

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var useSelectWidth = function useSelectWidth(opened, anchorRef) {
  var _a = useState(),
      width = _a[0],
      setWidth = _a[1];

  var updateWidth = useCallback(function () {
    if (!anchorRef.current) return;
    var rect = anchorRef.current.getBoundingClientRect();
    setWidth(rect.width);
  }, [anchorRef]);
  useEffect(function () {
    if (!opened || !anchorRef.current) return;
    var observer = new index(updateWidth);
    observer.observe(anchorRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [opened, anchorRef, updateWidth]);
  return width;
};

function Select(props, ref) {
  var externalWrapperRef = props.wrapperRef,
      externalAnchorRef = props.anchorRef,
      _a = props.arrow,
      arrow = _a === void 0 ? 'default' : _a,
      variant = props.variant;
      props.value;
      props.defaultValue;
      props.children;
      props.onChange;
      var rest = __rest(props, ["wrapperRef", "anchorRef", "arrow", "variant", "value", "defaultValue", "children", "onChange"]);

  var disabled = props.disabled;
  var localAnchorRef = useRef(null);
  var wrapperRef = useMergeRefs([localAnchorRef, externalWrapperRef]);
  var anchorRef = externalAnchorRef || localAnchorRef;

  var _b = useSelect(props),
      opened = _b.opened,
      options = _b.options,
      title = _b.title,
      handleClick = _b.handleClick,
      handleClose = _b.handleClose,
      handleKeyDown = _b.handleKeyDown;

  var width = useSelectWidth(opened, anchorRef);
  return jsxs(Fragment, {
    children: [jsx(SelectWrapperStyle, __assign$2({
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      active: opened,
      value: title,
      rightDecorator: jsx(SelectArrow$1, {
        arrow: arrow,
        disabled: disabled,
        opened: opened
      }, void 0),
      wrapperRef: wrapperRef,
      variant: variant
    }, rest, {
      ref: ref,
      readOnly: true
    }), void 0), jsx(PopupMenu$1, __assign$2({
      open: opened,
      variant: variant,
      anchorRef: anchorRef,
      style: {
        minWidth: width
      },
      onClose: handleClose
    }, {
      children: options
    }), void 0)]
  }, void 0);
}

var Select$1 = /*#__PURE__*/forwardRef(Select);

styled(Select$1).withConfig({
  displayName: "SelectIconStyles__SelectIconStyle",
  componentId: "sc-1fxwo6w-0"
})(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$4(["\n  input {\n    width: 0;\n  }\n"], ["\n  input {\n    width: 0;\n  }\n"])));
styled.span.withConfig({
  displayName: "SelectIconStyles__SelectIconDecoratorStyle",
  componentId: "sc-1fxwo6w-1"
})(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$4(["\n  margin-right: -24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  align-self: stretch;\n  justify-self: stretch;\n"], ["\n  margin-right: -24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  align-self: stretch;\n  justify-self: stretch;\n"])));
var templateObject_1$7, templateObject_2$3;

var SelectArrow;

(function (SelectArrow) {
  SelectArrow[SelectArrow["small"] = 0] = "small";
  SelectArrow[SelectArrow["default"] = 1] = "default";
})(SelectArrow || (SelectArrow = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$3(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.div.withConfig({
  displayName: "ServicePageStyles__ServicePageStyle",
  componentId: "sc-rcnxso-0"
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$3(["\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  text-align: center;\n"], ["\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  text-align: center;\n"])));
styled.div.withConfig({
  displayName: "ServicePageStyles__ServicePageInsideStyle",
  componentId: "sc-rcnxso-1"
})(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$3(["\n  box-sizing: border-box;\n  margin: 0 auto;\n  min-width: 320px;\n  width: 100%;\n  padding: 0 32px;\n  max-width: 560px;\n"], ["\n  box-sizing: border-box;\n  margin: 0 auto;\n  min-width: 320px;\n  width: 100%;\n  padding: 0 32px;\n  max-width: 560px;\n"])));
var templateObject_1$6, templateObject_2$2;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$2(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled.div.withConfig({
  displayName: "StackStyles__StackStyle",
  componentId: "sc-mebb3t-0"
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$2(["\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  margin: ", "px;\n"], ["\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  margin: ", "px;\n"])), function (_a) {
  var $align = _a.$align;
  return $align;
}, function (_a) {
  var $justify = _a.$justify;
  return $justify;
}, function (_a) {
  var $direction = _a.$direction;
  return $direction;
}, function (_a) {
  var $wrap = _a.$wrap;
  return $wrap;
}, function (_a) {
  var $spacing = _a.$spacing,
      theme = _a.theme;
  return $spacing ? -theme.spaceMap[$spacing] / 2 : 0;
});
var templateObject_1$5;

styled.div.withConfig({
  displayName: "StackItemStyles__StackItemStyle",
  componentId: "sc-1u3ij4k-0"
})(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$2(["\n  box-sizing: border-box;\n  margin: 0;\n  padding: ", "px;\n\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n"], ["\n  box-sizing: border-box;\n  margin: 0;\n  padding: ", "px;\n\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n"])), function (_a) {
  var $spacing = _a.$spacing,
      theme = _a.theme;
  return $spacing ? theme.spaceMap[$spacing] / 2 : 0;
}, function (_a) {
  var $grow = _a.$grow;
  return $grow;
}, function (_a) {
  var $shrink = _a.$shrink;
  return $shrink;
}, function (_a) {
  var $basis = _a.$basis;
  return $basis;
});
var templateObject_1$4;

var StackAlign;

(function (StackAlign) {
  StackAlign[StackAlign["center"] = 0] = "center";
  StackAlign[StackAlign["stretch"] = 1] = "stretch";
  StackAlign[StackAlign["flex-start"] = 2] = "flex-start";
  StackAlign[StackAlign["flex-end"] = 3] = "flex-end";
  StackAlign[StackAlign["baseline"] = 4] = "baseline";
})(StackAlign || (StackAlign = {}));

var StackJustify;

(function (StackJustify) {
  StackJustify[StackJustify["center"] = 0] = "center";
  StackJustify[StackJustify["start"] = 1] = "start";
  StackJustify[StackJustify["end"] = 2] = "end";
  StackJustify[StackJustify["stretch"] = 3] = "stretch";
  StackJustify[StackJustify["flex-start"] = 4] = "flex-start";
  StackJustify[StackJustify["flex-end"] = 5] = "flex-end";
  StackJustify[StackJustify["space-around"] = 6] = "space-around";
  StackJustify[StackJustify["space-between"] = 7] = "space-between";
  StackJustify[StackJustify["space-evenly"] = 8] = "space-evenly";
})(StackJustify || (StackJustify = {}));

var StackDirection;

(function (StackDirection) {
  StackDirection[StackDirection["row"] = 0] = "row";
  StackDirection[StackDirection["row-reverse"] = 1] = "row-reverse";
  StackDirection[StackDirection["column"] = 2] = "column";
  StackDirection[StackDirection["column-reverse"] = 3] = "column-reverse";
})(StackDirection || (StackDirection = {}));

var StackWrap;

(function (StackWrap) {
  StackWrap[StackWrap["nowrap"] = 0] = "nowrap";
  StackWrap[StackWrap["wrap"] = 1] = "wrap";
  StackWrap[StackWrap["wrap-reverse"] = 2] = "wrap-reverse";
})(StackWrap || (StackWrap = {}));

var StackSpacing;

(function (StackSpacing) {
  StackSpacing[StackSpacing["xs"] = 0] = "xs";
  StackSpacing[StackSpacing["sm"] = 1] = "sm";
  StackSpacing[StackSpacing["md"] = 2] = "md";
  StackSpacing[StackSpacing["lg"] = 3] = "lg";
  StackSpacing[StackSpacing["xl"] = 4] = "xl";
  StackSpacing[StackSpacing["xxl"] = 5] = "xxl";
})(StackSpacing || (StackSpacing = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var getMainColorTd = function getMainColorTd(props) {
  var colorsMap = {
    primary: props.theme.colors.primary,
    secondary: props.theme.colors.textSecondary,
    warning: props.theme.colors.warning,
    error: props.theme.colors.error,
    success: props.theme.colors.success,
    "default": props.theme.colors.text
  };
  return colorsMap[props.$textColor];
};

var getAlign = {
  left: css$1(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$1(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "]))),
  center: css$1(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$1(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "]))),
  right: css$1(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$1(["\n    text-align: right;\n  "], ["\n    text-align: right;\n  "])))
};
styled.table.withConfig({
  displayName: "styles__TableStyle",
  componentId: "sc-tkvtpu-0"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject$1(["\n  border-spacing: 0;\n"], ["\n  border-spacing: 0;\n"])));
styled.tbody.withConfig({
  displayName: "styles__TbodyStyle",
  componentId: "sc-tkvtpu-1"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject$1(["\n  & > tr::before,\n  & > tr::after {\n    content: '';\n    display: table-cell;\n    width: 32px;\n  }\n"], ["\n  & > tr::before,\n  & > tr::after {\n    content: '';\n    display: table-cell;\n    width: 32px;\n  }\n"])));
styled.thead.withConfig({
  displayName: "styles__TheadStyle",
  componentId: "sc-tkvtpu-2"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject$1(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n\n  & > tr::before,\n  & > tr::after {\n    content: '';\n    display: table-cell;\n    width: 32px;\n\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n\n  & > tr::before,\n  & > tr::after {\n    content: '';\n    display: table-cell;\n    width: 32px;\n\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
});
styled.tfoot.withConfig({
  displayName: "styles__TfootStyle",
  componentId: "sc-tkvtpu-3"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject$1([""], [""])));
styled.tr.withConfig({
  displayName: "styles__TrStyle",
  componentId: "sc-tkvtpu-4"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject$1(["\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n"], ["\n  font-weight: 400;\n  font-size: ", "px;\n  line-height: 1.6em;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xxs;
});
styled.td.withConfig({
  displayName: "styles__TdStyle",
  componentId: "sc-tkvtpu-5"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject$1(["\n  border-bottom: 1px solid ", ";\n  padding: 18px;\n\n  color: ", ";\n\n  ", "\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  border-bottom: 1px solid ", ";\n  padding: 18px;\n\n  color: ", ";\n\n  ", "\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, getMainColorTd, function (props) {
  return getAlign[props.$align];
});
styled.th.withConfig({
  displayName: "styles__ThStyle",
  componentId: "sc-tkvtpu-6"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject$1(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n\n  padding: 7px 18px;\n\n  font-weight: 700;\n  color: ", ";\n\n  ", "\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n\n  padding: 7px 18px;\n\n  font-weight: 700;\n  color: ", ";\n\n  ", "\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.borderLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text;
}, function (props) {
  return getAlign[props.$align];
});
var templateObject_1$3, templateObject_2$1, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var TableAlign;

(function (TableAlign) {
  TableAlign[TableAlign["left"] = 0] = "left";
  TableAlign[TableAlign["center"] = 1] = "center";
  TableAlign[TableAlign["right"] = 2] = "right";
})(TableAlign || (TableAlign = {}));

var TableTextColor;

(function (TableTextColor) {
  TableTextColor[TableTextColor["primary"] = 0] = "primary";
  TableTextColor[TableTextColor["secondary"] = 1] = "secondary";
  TableTextColor[TableTextColor["warning"] = 2] = "warning";
  TableTextColor[TableTextColor["error"] = 3] = "error";
  TableTextColor[TableTextColor["success"] = 4] = "success";
  TableTextColor[TableTextColor["default"] = 5] = "default";
})(TableTextColor || (TableTextColor = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

var colors = {
  primary: '#00a3ff',
  primaryHover: '#009bf2',
  primaryContrast: '#fff',
  primaryVisited: '#4bbeff',
  accent: '#27272e',
  accentContrast: '#fff',
  accentContrastSecondary: 'rgba(255, 255, 255, 0.6)',
  accentDarken: 'rgba(0, 0, 0, .2)',
  accentControlBg: 'rgba(0, 0, 0, .1)',
  accentBorder: 'rgba(255, 255, 255, 0.2)',
  accentBorderHover: 'rgba(255, 255, 255, 0.3)',
  error: '#e14d4d',
  errorHover: '#d44c4d',
  errorContrast: '#fff',
  warning: '#ffac2f',
  warningHover: '#f0a431',
  warningContrast: '#fff',
  success: '#53BA95',
  successHover: '#5dae5e',
  successContrast: '#fff'
};
var colors$1 = {
  colors: colors
};

var sm = {
  width: '359px',
  height: '639px'
};
var md = {
  width: '479px',
  height: '799px'
};
var lg = {
  width: '767px',
  height: '1023px'
};
var xl = {
  width: '1023px',
  height: '1365px'
};
var mediaQueries = {
  sm: "@media screen and (max-width: " + sm.width + ")",
  md: "@media screen and (max-width: " + md.width + ")",
  lg: "@media screen and (max-width: " + lg.width + ")",
  xl: "@media screen and (max-width: " + xl.width + ")"
};
var breakpoints = [sm.width, md.width, lg.width, xl.width];
var breakpointsMap = {
  sm: sm,
  md: md,
  lg: lg,
  xl: xl
};
var breakpoints$1 = {
  breakpoints: breakpoints,
  breakpointsMap: breakpointsMap,
  mediaQueries: mediaQueries
};

var space = [4, 8, 16, 24, 32];
var spaceMap = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32
};
var spacing = {
  space: space,
  spaceMap: spaceMap
};

var duration = {
  fast: '100ms',
  med: '150ms',
  norm: '200ms'
};
var ease = {
  inSine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
  outSine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
  inOutSine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
  inQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  outQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  inOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  inCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
  outCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  inOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  inQuart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
  outQuart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  inOutQuart: 'cubic-bezier(0.77, 0, 0.175, 1)',
  inQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  outQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  inOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)',
  inExpo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
  outExpo: 'cubic-bezier(0.19, 1, 0.22, 1)',
  inOutExpo: 'cubic-bezier(1, 0, 0, 1)',
  inCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
  outCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  inOutCirc: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
  inBack: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
  outBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  inOutBack: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};
var transitions = {
  duration: duration,
  ease: ease
};

var fontSizes = [10, 12, 14, 16, 18, 20, 26, 32, 40, 50];
var fontSizesMap = {
  xxxs: 10,
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 18,
  lg: 20,
  xl: 26,
  xxl: 32,
  xxxl: 40,
  xxxxl: 50
};
var typography = {
  fontSizes: fontSizes,
  fontSizesMap: fontSizesMap
};

var borderRadiuses = [4, 6, 8, 10, 12];
var borderRadiusesMap = {
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 20
};
var borders = {
  borderRadiuses: borderRadiuses,
  borderRadiusesMap: borderRadiusesMap
};

var boxShadows = {
  xs: '0px 4px 8px 0px',
  sm: '0px 4px 12px 0px',
  md: '0px 4px 16px 0px',
  lg: '0px 8px 24px 0px',
  xl: '0px 8px 32px 0px',
  xxl: '0px 8px 44px 0px'
};
var shadows = {
  boxShadows: boxShadows
};

var themeBase = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, spacing), breakpoints$1), colors$1), transitions), typography), borders), shadows);

var themeLight = __assign$1(__assign$1({}, themeBase), {
  colors: __assign$1(__assign$1({}, themeBase.colors), {
    secondary: '#273852',
    secondaryHover: '#212f45',
    secondaryContrast: '#fff',
    background: '#f2f4f6',
    backgroundDarken: '#dae0e5',
    foreground: '#fff',
    overlay: 'rgba(0, 0, 0, 0.5)',
    shadowLight: 'rgba(39, 56, 82, 0.08)',
    shadowDark: 'rgba(0, 0, 0, .25)',
    text: '#273852',
    textSecondary: '#7a8aa0',
    accentText: '#273852',
    border: 'rgba(0, 10, 61, 0.12)',
    borderActive: 'rgba(0, 10, 61, 0.48)',
    borderHover: 'rgba(0, 10, 61, 0.24)',
    borderLight: '#dfe5eb',
    accentBorder: 'rgba(0, 10, 61, 0.12)',
    accentBorderHover: 'rgba(0, 10, 61, 0.24)',
    controlBg: '#fff',
    accentControlBg: 'rgba(239, 242, 246, 0.56)',
    popupMenuItemBgActiveHover: '#000a3d'
  })
});
__assign$1(__assign$1({}, themeBase), {
  colors: __assign$1(__assign$1({}, themeBase.colors), {
    secondary: 'rgba(255, 255, 255, .8)',
    secondaryHover: '#fff',
    secondaryContrast: '#273852',
    background: '#1c1c21',
    backgroundDarken: '#131317',
    foreground: '#34343d',
    overlay: 'rgba(0, 0, 0, 0.5)',
    shadowLight: 'rgba(0, 0, 0, .25)',
    shadowDark: 'rgba(0, 0, 0, .5)',
    text: '#fff',
    textSecondary: 'rgba(255, 255, 255, .8)',
    accentText: '#fff',
    border: 'rgba(255, 255, 255, 0.12)',
    borderActive: 'rgba(255, 255, 255, 0.48)',
    borderHover: 'rgba(255, 255, 255, 0.24)',
    borderLight: '#484855',
    accentBorder: 'rgba(255, 255, 255, 0.12)',
    accentBorderHover: 'rgba(255, 255, 255, 0.24)',
    controlBg: '#2f2f37',
    accentControlBg: 'rgba(39, 39, 46, 0.56)',
    popupMenuItemBgActiveHover: '#fff'
  })
});

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function cx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return isValidElement(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = useRef();
    var animationStep = useRef(0
    /* Enter */
    );
    useLayoutEffect(function () {
      onEnter();
    }, []);
    useEffect(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
    }

    function onEntered() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
          node.className = baseClassName.current;
        }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return React__default.createElement(React__default.Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = useRef(arg);
  useEffect(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 0
    /* ADD */
    :
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 1
    /* REMOVE */
    :
      return isToastIdValid(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = useReducer(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = useReducer(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = useRef(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  useEffect(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  useEffect(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  useEffect(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    dispatch({
      type: 1
      /* REMOVE */
      ,
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = options.updateId == null;
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging

    if (toastProps.draggableDirection === "y"
    /* Y */
    && toastProps.draggablePercent === 80
    /* DRAGGABLE_PERCENT */
    ) {
        toastProps.draggablePercent *= 1.5;
      }

    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if (isValidElement(content) && !isStr(content.type)) {
      toastContent = cloneElement(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) delete collection[staleId];
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 0
      /* ADD */
      ,
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    var queueLen = queue.length;
    toastCount = isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    } else {
      forceUpdate();
    }
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = useState(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = useState(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = useRef(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  useEffect(function () {
    if (isFn(props.onOpen)) props.onOpen(isValidElement(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose(isValidElement(syncProps.children) && syncProps.children.props);
    };
  }, []);
  useEffect(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  useEffect(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.start = drag.x;
          drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
        } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    if (drag.canDrag) {
      e.preventDefault();
      var toast = toastRef.current;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.delta = drag.x - drag.start;
        } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return createElement("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, createElement("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends$1({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = cx("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : cx(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return createElement("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _cx;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn;
  var defaultClassName = cx("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : cx(defaultClassName, className);
  var isProgressControlled = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if (isValidElement(closeButton)) return cloneElement(closeButton, props);
  }

  return createElement(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, createElement("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), createElement("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : cx("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && createElement(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = cx("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : cx(defaultClassName, parseClassName(className));
  }

  return createElement("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = toastList.length === 0 ? _extends$1({}, style, {
      pointerEvents: 'none'
    }) : _extends$1({}, style);
    return createElement("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return createElement(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      render(createElement(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends$1({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var createToastByType = function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
};

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.dark = /*#__PURE__*/createToastByType(TYPE.DARK);
toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends$1({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

styled(ToastContainer).attrs({
  draggable: false
}).withConfig({
  displayName: "ToastContainer",
  componentId: "sc-1lkd3zq-0"
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  /* Animations */\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    to {\n      transform: scaleX(0);\n    }\n  }\n\n  @keyframes Toastify__bounceInRight {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInLeft {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(-3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutLeft {\n    20% {\n      opacity: 1;\n      transform: translate3d(20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(-2000px, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInUp {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__bounceOutUp {\n    20% {\n      transform: translate3d(0, -10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, 20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, -2000px, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInDown {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, -3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, 25px, 0);\n    }\n    75% {\n      transform: translate3d(0, -10px, 0);\n    }\n    90% {\n      transform: translate3d(0, 5px, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n\n  @keyframes Toastify__slideInRight {\n    0% {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInLeft {\n    0% {\n      transform: translate3d(-110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInUp {\n    0% {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInDown {\n    0% {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideOutRight {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutLeft {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(-110%, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutDown {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutUp {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -500px, 0);\n    }\n  }\n\n  @keyframes Toastify__flipIn {\n    0% {\n      transform: perspective(400px) rotateX(90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n    40% {\n      transform: perspective(400px) rotateX(-20deg);\n      animation-timing-function: ease-in;\n    }\n    60% {\n      transform: perspective(400px) rotateX(10deg);\n      opacity: 1;\n    }\n    80% {\n      transform: perspective(400px) rotateX(-5deg);\n    }\n    to {\n      transform: perspective(400px);\n    }\n  }\n\n  @keyframes Toastify__flipOut {\n    0% {\n      transform: perspective(400px);\n    }\n    30% {\n      transform: perspective(400px) rotateX(-20deg);\n      opacity: 1;\n    }\n    to {\n      transform: perspective(400px) rotateX(90deg);\n      opacity: 0;\n    }\n  }\n  /* /Animations */\n\n  & {\n    width: auto;\n    max-width: calc(100vw - ", "px);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    @media screen and (max-width: 480px) {\n      max-width: calc(100vw - ", "px);\n    }\n\n    &.Toastify__toast-container {\n      z-index: 9999;\n      transform: translateZ(9999px);\n      position: fixed;\n      padding: 4px;\n      box-sizing: border-box;\n      color: #fff;\n\n      /* Positions */\n      &--top-left {\n        top: ", "px;\n        left: ", "px;\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          left: ", "px;\n        }\n      }\n      &--top-center {\n        top: ", "px;\n        left: 50%;\n        transform: translateX(-50%);\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          left: 45%;\n          transform: translateX(-40%);\n        }\n      }\n      &--top-right {\n        top: ", "px;\n        right: ", "px;\n        left: auto;\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          right: ", "px;\n          transform: none;\n        }\n      }\n      &--bottom-left {\n        bottom: ", "px;\n        left: ", "px;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          left: ", "px;\n        }\n      }\n      &--bottom-center {\n        bottom: ", "px;\n        transform: translateX(-50%);\n        left: 50%;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          left: 45%;\n          transform: translateX(-40%);\n        }\n      }\n      &--bottom-right {\n        bottom: ", "px;\n        right: ", "px;\n        left: auto;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          right: ", "px;\n          transform: none;\n        }\n      }\n      /* /Positions */\n    }\n  }\n\n  .Toastify {\n    &__toast {\n      position: relative;\n      box-sizing: border-box;\n      display: flex;\n      justify-content: space-between;\n      overflow: hidden;\n      direction: ltr;\n      max-width: 360px;\n      max-height: 800px;\n      min-height: 0;\n\n      border-radius: ", "px;\n      box-shadow: ", ";\n      margin: ", "px 0;\n      padding: ", "px\n        ", "px;\n      background-color: ", ";\n      color: ", ";\n      font-size: ", "px;\n      line-height: 1.3em;\n      font-family: inherit;\n      cursor: default;\n\n      &-body {\n        margin: auto 0;\n        flex: 1 1 auto;\n        padding: 6px;\n      }\n\n      a,\n      a:hover {\n        color: currentColor;\n        text-decoration: underline;\n      }\n    }\n\n    &--animate {\n      animation-fill-mode: both;\n      animation-duration: 0.7s;\n    }\n\n    &__progress-bar {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 3px;\n      z-index: 9999;\n      opacity: 0.7;\n      background: rgba(255, 255, 255, 0.25);\n      transform-origin: left;\n\n      &--animated {\n        animation: Toastify__trackProgress linear 1 forwards;\n      }\n\n      &--controlled {\n        transition: transform 0.2s;\n      }\n\n      &--rtl {\n        right: 0;\n        left: auto;\n        transform-origin: right;\n      }\n    }\n\n    &__toast--rtl {\n      direction: rtl;\n    }\n\n    /* Variants */\n    //&__toast--dark {\n    //  background: #121212;\n    //  color: #fff;\n    //}\n    //&__toast--default {\n    //  background: #fff;\n    //  color: #aaa;\n    //}\n    &__toast--info {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--error {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--warning {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--success {\n      background-color: ", ";\n      color: ", ";\n    }\n    /* /Variants */\n\n    /* For animations */\n    &__flip-enter {\n      animation-name: Toastify__flipIn;\n    }\n\n    &__flip-exit {\n      animation-name: Toastify__flipOut;\n    }\n\n    &__bounce-enter--bottom-left,\n    &__bounce-enter--top-left {\n      animation-name: Toastify__bounceInLeft;\n    }\n\n    &__bounce-enter--bottom-right,\n    &__bounce-enter--top-right {\n      animation-name: Toastify__bounceInRight;\n    }\n\n    &__bounce-enter--top-center {\n      animation-name: Toastify__bounceInDown;\n    }\n\n    &__bounce-enter--bottom-center {\n      animation-name: Toastify__bounceInUp;\n    }\n\n    &__bounce-exit--bottom-left,\n    &__bounce-exit--top-left {\n      animation-name: Toastify__bounceOutLeft;\n    }\n\n    &__bounce-exit--bottom-right,\n    &__bounce-exit--top-right {\n      animation-name: Toastify__bounceOutRight;\n    }\n\n    &__bounce-exit--top-center {\n      animation-name: Toastify__bounceOutUp;\n    }\n\n    &__bounce-exit--bottom-center {\n      animation-name: Toastify__bounceOutDown;\n    }\n    /* /For animations */\n  }\n"], ["\n  /* Animations */\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    to {\n      transform: scaleX(0);\n    }\n  }\n\n  @keyframes Toastify__bounceInRight {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInLeft {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(-3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutLeft {\n    20% {\n      opacity: 1;\n      transform: translate3d(20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(-2000px, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInUp {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__bounceOutUp {\n    20% {\n      transform: translate3d(0, -10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, 20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, -2000px, 0);\n    }\n  }\n\n  @keyframes Toastify__bounceInDown {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, -3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, 25px, 0);\n    }\n    75% {\n      transform: translate3d(0, -10px, 0);\n    }\n    90% {\n      transform: translate3d(0, 5px, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n\n  @keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n\n  @keyframes Toastify__slideInRight {\n    0% {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInLeft {\n    0% {\n      transform: translate3d(-110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInUp {\n    0% {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideInDown {\n    0% {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translateZ(0);\n    }\n  }\n\n  @keyframes Toastify__slideOutRight {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutLeft {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(-110%, 0, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutDown {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0);\n    }\n  }\n\n  @keyframes Toastify__slideOutUp {\n    0% {\n      transform: translateZ(0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -500px, 0);\n    }\n  }\n\n  @keyframes Toastify__flipIn {\n    0% {\n      transform: perspective(400px) rotateX(90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n    40% {\n      transform: perspective(400px) rotateX(-20deg);\n      animation-timing-function: ease-in;\n    }\n    60% {\n      transform: perspective(400px) rotateX(10deg);\n      opacity: 1;\n    }\n    80% {\n      transform: perspective(400px) rotateX(-5deg);\n    }\n    to {\n      transform: perspective(400px);\n    }\n  }\n\n  @keyframes Toastify__flipOut {\n    0% {\n      transform: perspective(400px);\n    }\n    30% {\n      transform: perspective(400px) rotateX(-20deg);\n      opacity: 1;\n    }\n    to {\n      transform: perspective(400px) rotateX(90deg);\n      opacity: 0;\n    }\n  }\n  /* /Animations */\n\n  & {\n    width: auto;\n    max-width: calc(100vw - ", "px);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    @media screen and (max-width: 480px) {\n      max-width: calc(100vw - ", "px);\n    }\n\n    &.Toastify__toast-container {\n      z-index: 9999;\n      transform: translateZ(9999px);\n      position: fixed;\n      padding: 4px;\n      box-sizing: border-box;\n      color: #fff;\n\n      /* Positions */\n      &--top-left {\n        top: ", "px;\n        left: ", "px;\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          left: ", "px;\n        }\n      }\n      &--top-center {\n        top: ", "px;\n        left: 50%;\n        transform: translateX(-50%);\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          left: 45%;\n          transform: translateX(-40%);\n        }\n      }\n      &--top-right {\n        top: ", "px;\n        right: ", "px;\n        left: auto;\n\n        @media screen and (max-width: 480px) {\n          top: ", "px;\n          right: ", "px;\n          transform: none;\n        }\n      }\n      &--bottom-left {\n        bottom: ", "px;\n        left: ", "px;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          left: ", "px;\n        }\n      }\n      &--bottom-center {\n        bottom: ", "px;\n        transform: translateX(-50%);\n        left: 50%;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          left: 45%;\n          transform: translateX(-40%);\n        }\n      }\n      &--bottom-right {\n        bottom: ", "px;\n        right: ", "px;\n        left: auto;\n\n        @media screen and (max-width: 480px) {\n          bottom: ", "px;\n          right: ", "px;\n          transform: none;\n        }\n      }\n      /* /Positions */\n    }\n  }\n\n  .Toastify {\n    &__toast {\n      position: relative;\n      box-sizing: border-box;\n      display: flex;\n      justify-content: space-between;\n      overflow: hidden;\n      direction: ltr;\n      max-width: 360px;\n      max-height: 800px;\n      min-height: 0;\n\n      border-radius: ", "px;\n      box-shadow: ", ";\n      margin: ", "px 0;\n      padding: ", "px\n        ", "px;\n      background-color: ", ";\n      color: ", ";\n      font-size: ", "px;\n      line-height: 1.3em;\n      font-family: inherit;\n      cursor: default;\n\n      &-body {\n        margin: auto 0;\n        flex: 1 1 auto;\n        padding: 6px;\n      }\n\n      a,\n      a:hover {\n        color: currentColor;\n        text-decoration: underline;\n      }\n    }\n\n    &--animate {\n      animation-fill-mode: both;\n      animation-duration: 0.7s;\n    }\n\n    &__progress-bar {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 3px;\n      z-index: 9999;\n      opacity: 0.7;\n      background: rgba(255, 255, 255, 0.25);\n      transform-origin: left;\n\n      &--animated {\n        animation: Toastify__trackProgress linear 1 forwards;\n      }\n\n      &--controlled {\n        transition: transform 0.2s;\n      }\n\n      &--rtl {\n        right: 0;\n        left: auto;\n        transform-origin: right;\n      }\n    }\n\n    &__toast--rtl {\n      direction: rtl;\n    }\n\n    /* Variants */\n    //&__toast--dark {\n    //  background: #121212;\n    //  color: #fff;\n    //}\n    //&__toast--default {\n    //  background: #fff;\n    //  color: #aaa;\n    //}\n    &__toast--info {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--error {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--warning {\n      background-color: ", ";\n      color: ", ";\n    }\n    &__toast--success {\n      background-color: ", ";\n      color: ", ";\n    }\n    /* /Variants */\n\n    /* For animations */\n    &__flip-enter {\n      animation-name: Toastify__flipIn;\n    }\n\n    &__flip-exit {\n      animation-name: Toastify__flipOut;\n    }\n\n    &__bounce-enter--bottom-left,\n    &__bounce-enter--top-left {\n      animation-name: Toastify__bounceInLeft;\n    }\n\n    &__bounce-enter--bottom-right,\n    &__bounce-enter--top-right {\n      animation-name: Toastify__bounceInRight;\n    }\n\n    &__bounce-enter--top-center {\n      animation-name: Toastify__bounceInDown;\n    }\n\n    &__bounce-enter--bottom-center {\n      animation-name: Toastify__bounceInUp;\n    }\n\n    &__bounce-exit--bottom-left,\n    &__bounce-exit--top-left {\n      animation-name: Toastify__bounceOutLeft;\n    }\n\n    &__bounce-exit--bottom-right,\n    &__bounce-exit--top-right {\n      animation-name: Toastify__bounceOutRight;\n    }\n\n    &__bounce-exit--top-center {\n      animation-name: Toastify__bounceOutUp;\n    }\n\n    &__bounce-exit--bottom-center {\n      animation-name: Toastify__bounceOutDown;\n    }\n    /* /For animations */\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return 2 * theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return 2 * theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadiusesMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.boxShadows.xs + " " + theme.colors.shadowLight;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.xs;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accentContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizesMap.xs;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accentContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.error;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.errorContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.warning;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.warningContrast;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.success;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.successContrast;
});
var templateObject_1$2;

var TOASTS_DEFAULT_OPTIONS = {
  position: toast.POSITION.BOTTOM_LEFT,
  closeButton: false,
  hideProgressBar: false,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: false,
  autoClose: 6000,
  delay: 0
};
__assign(__assign({}, TOASTS_DEFAULT_OPTIONS), {
  closeOnClick: true
});
__assign({}, TOASTS_DEFAULT_OPTIONS);
__assign(__assign({}, TOASTS_DEFAULT_OPTIONS), {
  closeOnClick: true
});
__assign(__assign({}, TOASTS_DEFAULT_OPTIONS), {
  autoClose: false
});

styled.div.withConfig({
  displayName: "ToastPendingStyles__ToastPendingStyle",
  componentId: "sc-133vpey-0"
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
styled.div.withConfig({
  displayName: "ToastPendingStyles__ToastPendingTextStyle",
  componentId: "sc-133vpey-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
styled(Loader$1).withConfig({
  displayName: "ToastPendingStyles__ToastPendingLoaderStyle",
  componentId: "sc-133vpey-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: ", "px;\n  margin-right: ", "px;\n  svg {\n    color: ", ";\n  }\n"], ["\n  margin: ", "px;\n  margin-right: ", "px;\n  svg {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return -theme.spaceMap.xs;
}, function (_a) {
  var theme = _a.theme;
  return theme.spaceMap.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.accentContrast;
});
var templateObject_1$1, templateObject_2, templateObject_3;

toast.POSITION;

var getDefiApy = function () { return 272.14; }; // TODO change it with api call

var LIDO_ON_SOLANA = 'https://solana.lido.fi';
var getStakeLink = function (referrer) { return "".concat(LIDO_ON_SOLANA, "/?referrer=").concat(referrer); };
var getDefiLink = function (referrer) { return "".concat(LIDO_ON_SOLANA, "/defi?referrer=").concat(referrer); };

var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLidoLogoinline = function SvgLidoLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 20,
    viewBox: "0 0 158 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.8 31.52V8.48h7.456c1.131 0 2.048.043 2.752.128 1.803.213 3.355.848 4.656 1.904 1.312 1.056 2.309 2.41 2.992 4.064.683 1.643 1.024 3.45 1.024 5.424 0 1.973-.341 3.787-1.024 5.44-.683 1.643-1.68 2.992-2.992 4.048-1.301 1.056-2.853 1.69-4.656 1.904-.704.085-1.621.128-2.752.128H101.8Zm7.456-4.096c1.131 0 1.963-.053 2.496-.16a4.256 4.256 0 0 0 2.4-1.36c.651-.725 1.131-1.6 1.44-2.624.32-1.035.48-2.128.48-3.28 0-1.184-.165-2.293-.496-3.328-.32-1.035-.805-1.904-1.456-2.608a4.193 4.193 0 0 0-2.368-1.328c-.533-.107-1.365-.16-2.496-.16h-3.04v14.848h3.04ZM84.152 31.52H79.8V8.48h4.352v23.04ZM62.272 31.52H48V8.48h4.352v18.976h9.92v4.064ZM146.828 32c-2.272 0-4.251-.496-5.936-1.488-1.685-1.003-2.981-2.41-3.888-4.224-.896-1.813-1.344-3.91-1.344-6.288 0-2.379.448-4.475 1.344-6.288.907-1.813 2.203-3.216 3.888-4.208C142.577 8.501 144.556 8 146.828 8s4.251.501 5.936 1.504c1.685.992 2.976 2.395 3.872 4.208.907 1.813 1.36 3.91 1.36 6.288 0 2.379-.453 4.475-1.36 6.288-.896 1.813-2.187 3.221-3.872 4.224-1.685.992-3.664 1.488-5.936 1.488Zm.128-4.096c1.408 0 2.592-.325 3.552-.976.96-.65 1.68-1.568 2.16-2.752.48-1.184.72-2.576.72-4.176 0-2.475-.565-4.41-1.696-5.808-1.131-1.397-2.795-2.096-4.992-2.096-1.408 0-2.592.325-3.552.976-.96.65-1.68 1.568-2.16 2.752-.48 1.184-.72 2.576-.72 4.176 0 2.475.565 4.41 1.696 5.808 1.131 1.397 2.795 2.096 4.992 2.096Z",
    fill: "#273852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.013 0 9.9 15.495-9.9 5.77-9.899-5.77L14.014 0ZM7.144 14.762l6.87-10.751 6.868 10.752-6.87 4.003-6.868-4.003Z",
    fill: "#273852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 24.67 2.515 17.978l-.313.491A13.995 13.995 0 0 0 4.1 35.9c5.467 5.467 14.331 5.467 19.798 0a13.995 13.995 0 0 0 1.9-17.432l-.314-.49-11.486 6.693Z",
    fill: "#273852"
  })));
};

var Background = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%221580%22%20height%3D%22226%22%20fill%3D%22none%22%3E%3Cg%20clip-path%3D%22url%28%23Y%29%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h1580v226H0z%22%2F%3E%3Cpath%20d%3D%22M1580%200H0V226H1580V0Z%22%20fill%3D%22url%28%23A%29%22%2F%3E%3Cpath%20d%3D%22M1553.83%20226H1580V0h-193.76c124.16%2084.178%20100.25%20126.059%2086.17%20150.734-6.27%2010.971-10.59%2018.54.91%2024.913%2014.28%207.911%2048%2027.407%2080.51%2050.353z%22%20fill%3D%22url%28%23B%29%22%2F%3E%3Cpath%20opacity%3D%22.19%22%20fill-rule%3D%22evenodd%22%20d%3D%22M981.624%200c3.867%201.077%206.472%203.695%208.157%2012.177%201.343%206.763%2011.309%207.254%2031.719%208.258%2028.52%201.403%2077.42%203.81%20151.69%2025.723%20127.42%2037.599%20144.18%2083.244%20155.83%20131.552%204.32%2017.899-9.84%2033.178-28.34%2048.29h-215.03c-5.23-9.948-14.78-17.507-23.69-23.874-6.2-4.419-12.73-8.324-19.25-12.23l-9.38-5.69c-36.872-23.089-74.882-44.207-115.385-60.239-17.693-6.988-35.81-12.852-54.242-17.555l-.004-.001c-11.207-2.838-24.602-6.23-35.917-2.281-12.264%204.26-15.278%2017.255-11.297%2028.62%204.703%2013.287%2014.778%2024.478%2024.566%2034.175%2026.074%2025.833%2059.558%2042.359%2094.452%2052.967A133.86%20133.86%200%200%201%20952.995%20226H0V0h597.743c8.406%209.724%2017.953%2018.407%2028.439%2025.861a111.6%20111.6%200%200%200%2033.261%2016.811%2067.8%2067.8%200%200%200%2016.772%202.714l.68.018c4.641.128%2011.707.323%2014.218-3.879a23.32%2023.32%200%200%200%203.307-11.691%2023.33%2023.33%200%200%200-3.022-11.768c-4.334-7.02-12.001-11.181-19.452-14.184-3.648-1.409-7.338-2.703-11.064-3.881h180.829c4.8%203.101%208.505%206.55%2010.82%2010.012%205.914%208.84%2043.852.643%2074.846-6.053L946.175%200h35.449zm-50.522%2022.205c7.732-1.595%2015.563-3.209%2023.295-1.783%202.472.381%204.811%201.371%206.805%202.881s3.58%203.494%204.616%205.771a15.07%2015.07%200%200%201%201.315%207.272c-.172%202.496-.962%204.909-2.3%207.023-5.687%209.031-18.659%2012.881-28.761%2013.192-8.353.198-21.07-4.221-20.622-14.357.354-3.848%202.065-7.445%204.826-10.148-2.501-2.625-2.434-7.548%202.051-8.207%202.904-.432%205.832-1.036%208.775-1.643zm286.628%2060.038c3.97%203.387%206.5%208.162%207.06%2013.348.11%204.215-1.95%207.677-4.04%2011.177l-.99%201.686a90.92%2090.92%200%200%201-12.57%2014.92l-.04.042c-4.76%204.821-9.55%209.68-10.62%2016.631-1.55%2011.01%207.22%2019.614%2016.08%2024.729l2.43%201.343c4.3%202.345%208.74%204.768%2011.72%208.718%202.71%203.984%203.93%208.797%203.44%2013.589-1.44%2019.369-26.83%2022.429-41.84%2022.857-23.47.596-46.78-5.684-68.82-12.919-15.51-5.113-30.35-11.114-45.71-17.352l-2.86-1.158c-14.47-5.847-29.29-11.834-40.34-23.343-22.12-23.017-65.44-72.331-30.5-102.155%2014.95-12.749%2036.39-14.807%2055.27-14.568%2020.66.289%2041.15%203.673%2061.43%207.205l10.77%201.815c3.68.017%207.33.577%2010.85%201.66.34.025.67.087.99.185%2015.97%204.829%2031.68%2010.514%2047.04%2017.031%202.91%201.2%205.94%202.244%208.97%203.292%208%202.76%2016.08%205.548%2022.28%2011.268zm72.66%2049.185c1.02%205.84.77%2011.83-.72%2017.567l-.09-.051c-1.4%204.772-4.1%209.064-7.78%2012.401-3.69%203.338-8.23%205.591-13.12%206.51-18.49%204.206-46.14-4.167-52.42-23.977-7.16-22.291%2016.93-38.742%2036.62-38.569%208.7.121%2020.83%202.729%2028.91%208.84a4.91%204.91%200%200%201%203.32.782c.97.649%201.68%201.628%201.99%202.756l1.09%203.583a18.59%2018.59%200%200%201%202.01%205.735c.25%201.46.31%202.946.19%204.423zm18.74%2023.249a5.36%205.36%200%200%201%202.84%202.29l-.09-.051c.34.583.56%201.227.65%201.895a5.19%205.19%200%200%201-.12%202.001%205.26%205.26%200%200%201-.89%201.799c-.41.535-.92.984-1.5%201.32-2.78%201.674-6.06%202.314-9.26%201.805-1.24-.128-2.5-.203-3.76-.226a5.13%205.13%200%200%201-1.9%201.795%205.09%205.09%200%200%201-2.53.627c-.89-.014-1.75-.257-2.52-.706-.76-.448-1.39-1.087-1.83-1.853-2.58-5.357.69-10.202%205.11-13.259%201.81-1.315%203.94-2.124%206.17-2.346%202.97.072%205.81%201.21%208.01%203.208.63.468%201.18%201.044%201.62%201.701zm-10.65%2020.638c9.99%205.504%209.36%2021.232%202.48%2028.748-7.42%208.148-19.28%208.33-28.31%202.7a44.23%2044.23%200%200%201-10.18-10.098l-1.38-1.622c-3.09-3.581-6.46-7.505-7.5-12.099-.21-.791-.21-1.622-.01-2.414.21-.792.61-1.519%201.18-2.11.19-1.09.78-2.068%201.65-2.743.88-.675%201.98-.997%203.08-.903%204.65.204%209.27-.118%2013.89-.439%203.14-.218%206.28-.436%209.41-.488%201.06-.02%202.16-.084%203.27-.149%204.25-.248%208.74-.51%2012.42%201.617zM809.598%2063.097c-6.774-6.067-14.234-14.065-15.677-23.433l.022.013c-1.445-9.517%204.801-16.039%2012.586-20.522%209.497-5.503%2019.826-7.69%2030.427-4.109a67.3%2067.3%200%200%201%2013.655%206.732%20239.53%20239.53%200%200%201%205.127%203.344%205.11%205.11%200%200%201%201.959.186c3.695%201.078%207.622%201.305%2011.546%201.531%205.632.325%2011.258.649%2016.179%203.49%207.311%204.221%2012.695%2013.574%2016.835%2020.765l.663%201.15c4.225%207.312%208.746%2017.689%201.698%2024.782-6.279%206.265-18.113%207.329-26.846%208.114l-1.388.126a88.97%2088.97%200%200%201-35.678-4.201c-11.483-3.812-22.068-9.926-31.108-17.968zm-98.762-36.91l-1.8.201.022.013c-3.948.496-5.474-3.101-4.67-6.181-3.616-3.562-7.001-7.351-10.135-11.344-2.417-3.078-1.248-8.989%203.578-8.654%203.703.239%207.314%201.248%2010.604%202.962.931.477%201.838%201.006%202.744%201.533%202.663%201.551%205.313%203.095%208.515%203.313.771.064%201.52.293%202.194.673s1.259.901%201.714%201.528a5.37%205.37%200%200%201%20.918%202.104c.151.759.136%201.542-.043%202.295a68.46%2068.46%200%200%201%2021.56%201.581%2021.35%2021.35%200%200%201%2013.812%209.835c2.607%204.487%204.353%2010.516.315%2014.799-6.726%207.25-21.51%202.731-28.989-.938a99.94%2099.94%200%200%201-20.339-13.721z%22%20fill%3D%22url%28%23C%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.3%22%20d%3D%22M944.831%2075.557c11.225%201.017%2035.389-40.018%2034.309-41.675s-21.34-18.433-38.979-4.402c-2.792%202.227-4.466%2016.38-3.413%2028.417.239%203.334.816%206.636%201.723%209.854%201.36%204.447%203.408%207.549%206.36%207.806z%22%20fill%3D%22url%28%23D%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.3%22%20d%3D%22M891.351%2019.954c22.615-26.485-8.999-17.864-17.539-4.043s9.418%2013.559%2017.539%204.043z%22%20fill%3D%22url%28%23E%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.3%22%20d%3D%22M961.824%2015.792c-4.192%202.121-8.934%202.908-13.587%202.255-5.22-1.325-5.388-10.815-1.631-18.048h26.92c1.328%202.77%201.464%205.563.603%207.216-1.963%202.556-4.477%204.638-7.355%206.09a46.44%2046.44%200%200%201-4.95%202.487z%22%20fill%3D%22url%28%23F%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.3%22%20d%3D%22M903.781%2013.466c11.386-7.956%2014.43%2010.812%207.563%2012.783s-11.652-9.946-7.563-12.782z%22%20fill%3D%22url%28%23G%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.15%22%20d%3D%22M1569.06%20143.37c4.19-.356%203.77%207.639%201.47%206.757s-2.97-6.618-1.47-6.757z%22%20fill%3D%22url%28%23H%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.15%22%20d%3D%22M1569.9%20154.449c10.23-1.975%206.62%2011.856%201.33%2011.102-5.3-.753-5-10.382-1.33-11.102z%22%20fill%3D%22url%28%23I%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.15%22%20d%3D%22M1516.12%20154.367c10.21-1.987%206.62%2011.856%201.31%2011.125-5.3-.731-5.02-10.431-1.31-11.125z%22%20fill%3D%22url%28%23J%29%22%2F%3E%3Cpath%20d%3D%22M1287.97%20168.057c-.04.278-.05.558-.04.839l-.23-.988.25.067a18.96%2018.96%200%200%200%20.15-2.609c-.04.074-.16.832-.28%201.525l-.15.913.01.034-.06.203-.05-.229c-2.89-.642-.09%207.592%202.69%2015.812%202.8%208.244%205.59%2016.475%202.64%2015.728.85-1.748-1.7-9.165-4.45-17.17-4.11-11.987-8.68-25.294-3-22.864l.09-.006%201.6%206.367-1.26-6.176c1.08.478%202.31%201.102%203.46%201.732%208.76%204.834%2019.38%208.064%2031.23%2011.667%206.78%202.06%2013.95%204.242%2021.41%206.915l-2.47.302-2.2.277c-4.45.544-19.82-3.873-37.66-8.999l-11.68-3.34z%22%20fill%3D%22url%28%23K%29%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M1580%20183.147V226h-164.21c-4-3.072-8.61-6.951-14.02-11.841-17.35-15.548-37.69-27.4-59.77-34.834a228.85%20228.85%200%200%200%2039.85-7.495s-15.64-24.565-26.55-35.498c-7.89-7.917-39.51-22.835-57.45-31.302-6.83-3.224-11.68-5.513-12.48-6.123-1.4-1.057-1.81%202.997-2.27%207.555-.51%204.994-1.09%2010.593-3.07%2010.743-2.72.261%202.63%2027.21%205.82%2042.194l-.33-.192c-3.82-15.228-10.66-42.919-10.63-45.587.02-1.651.94-2.599%202.14-3.846%201.5-1.548%203.44-3.556%204.67-7.937.79-2.816%203.42-9.453%206.53-16.897-7.44-1.994-41.15-11.27-41.22-14.94-.05-4.162%208.46-18.741%208.46-18.741-4.9-.459-9.73-1.483-14.39-3.052-6.52-2.909-20.59-12.693-35.38-22.983-14.04-9.765-28.74-19.986-38.26-25.222h2.4c15.77%2010.192%2035.06%2022.391%2037.31%2021.707%201.63-.479%2010.82-9.936%2020.75-20.161L1229.41%200h3.78c-10.26%209.081-20.04%2019.312-18.49%2024.177%203.13%209.813%2022.99%2019.713%2028.02%2021.435s88.27%2012.013%2097.75%2012.994l-5.81-3.731c-26.73-17.172-48.49-31.146-45.13-37.286%201.93-3.563-2.57-9.693-11.73-17.588h135.61c3.32%202.853%206.43%205.484%209.1%207.455%204.39%203.252%208.1%207.434%2011.7%2011.492%204.56%205.137%208.94%2010.074%2014.3%2012.675%204.48%202.172%2011.13%205.792%2017.39%209.201%207.16%203.896%2013.81%207.516%2016.13%208.382%204.35%201.624%207.86%2012.628%207.86%2012.628s1.77%2012.836%208.78%2019.421c3.5%203.293%203.5%203.293%202.7%203.31s-2.4.054-2.1%203.417c.26%202.811%202.55%205.343%205.36%208.434%203.9%204.307%208.79%209.7%2010.52%2018.447%201.46%207.195-6.39%2018.901-13.84%2030.02l-1.14%201.702c-.54.926-1.14%201.795-1.74%202.651l-.55.809c-6.73%2010.264-11.77%2019.253-7.08%2022.491%204.29%203.024%2010.66%202.144%2019.43.931%2015.33-2.12%2038.01-5.255%2069.77%209.679zm-207.06-3.649a2.57%202.57%200%200%201%201.18%201.538%202.56%202.56%200%200%201-.26%201.933c-.34.585-.9%201.013-1.55%201.189a12.97%2012.97%200%200%201-5.92-.286c-.33-.082-.64-.228-.91-.432a2.72%202.72%200%200%201-.68-.752c-.32-.581-.4-1.264-.23-1.904.09-.325.24-.63.45-.897a2.51%202.51%200%200%201%20.75-.659c.57-.33%201.25-.424%201.89-.264l1.68.318c.48.048.96.05%201.44.007l.21-.056c.66-.16%201.35-.065%201.95.265zM1353.06%2039.15l5.36%203.095a66.21%2066.21%200%200%201%2011.26%208.628c4.26%203.453%207.6%207.899%209.74%2012.948a2.52%202.52%200%200%201%20.03%201.158%202.45%202.45%200%200%201-.48%201.054c-.24.31-.54.561-.89.734s-.74.263-1.13.263c-12.63-1.033-23.61-8.727-33.65-15.792l-2.63-1.889c-4.64-3.375-9.41-6.838-15.21-7.707a79.79%2079.79%200%200%201-9.87-1.268c-3.31-1.174-6.34-3.004-8.91-5.382-1.17-.955-2.29-1.969-3.41-2.984-1.7-1.535-3.4-3.072-5.26-4.411-.77-.565-1.67-1.046-2.58-1.532-2.28-1.223-4.63-2.477-5.19-5.167a2.61%202.61%200%200%201%20.01-1.387c.12-.453.38-.862.72-1.181.35-.319.78-.537%201.24-.629a2.55%202.55%200%200%201%201.38.109%2027.5%2027.5%200%200%200%202.44-1.252l.09-.155c-.03-.174-.07-.349-.12-.526-.03-.118-.06-.236-.08-.357-.02-.026-.04-.047-.07-.063s-.06-.025-.09-.027l-.66-.384c-.71-.433-1.32-1.021-1.77-1.721s-.73-1.493-.83-2.319a7.13%207.13%200%200%201%20.35-3.575%207.18%207.18%200%200%201%202.06-2.949%2012.13%2012.13%200%200%201%206.3-2.269c2.21-.215%204.43-.292%206.66-.23%202.39-.031%204.78-.14%207.16-.248l2.73-.12c3.04-.254%206.09-.194%209.11.18a20.72%2020.72%200%200%201%206.93%202.787c4.64%202.691%208.43%206.631%2010.95%2011.37a10.24%2010.24%200%200%201%201.09%206.54c-.17.907-.44%201.781-.72%202.655-.27.874-.55%201.749-.72%202.655-.31%201.444-.14%202.951.48%204.291.81%201.515%201.94%202.834%203.32%203.866%201.55%201.167%203.17%202.233%204.86%203.191zm46.23%2011.146c.2.59.18%201.235-.05%201.812a2.6%202.6%200%200%201-1.22%201.32%202.57%202.57%200%200%201-1.79.195l-.28-.166-.26.443c-.17.654-.59%201.216-1.17%201.561a2.56%202.56%200%200%201-1.93.281%2014.29%2014.29%200%200%201-5.13-2.248%2014.37%2014.37%200%200%201-3.88-4.044c-.17-.319-.28-.672-.31-1.035s.02-.729.14-1.072c-.03-.446-.02-.894.04-1.338.1-.506.3-.986.59-1.412s.67-.788%201.1-1.064a3.96%203.96%200%200%201%201.64-.267%203.99%203.99%200%200%201%201.61.428l.46.161c.66.231%201.34.465%201.93.808%201.69.857%203.3%201.827%204.91%202.798l2.44%201.447a2.52%202.52%200%200%201%201.16%201.394zm-3.84%2023.721a18.04%2018.04%200%200%201%206.11%203.266%205.56%205.56%200%200%201%201.82%203.078%205.57%205.57%200%200%201-.42%203.549%202.53%202.53%200%200%201-1.22%201.143c-.53.232-1.12.281-1.67.139-5.48-1.447-10.37-4.433-15.2-7.381l-4.21-2.526a2.59%202.59%200%200%201-.9-.941c-.21-.385-.32-.819-.31-1.258%200-.44.12-.871.34-1.252a2.54%202.54%200%200%201%20.91-.923c.16-.373.4-.709.69-.985.3-.276.65-.487%201.04-.618%201.62-.642%203.42-.708%205.09-.187a11.51%2011.51%200%200%201%203.69%202.421c.61.608%201.31%201.121%202.07%201.522l.66.384%201.51.571zm-15.64%208.333c.18-.645.59-1.196%201.17-1.536l.09-.098c.33-.587.89-1.016%201.55-1.192a2.56%202.56%200%200%201%201.94.255c2.45%201.139%204.56%202.906%206.11%205.122.24.441.35.943.3%201.444a2.55%202.55%200%200%201-.54%201.372%202.54%202.54%200%200%201-1.18.857c-.47.165-.97.191-1.45.074a13.83%2013.83%200%200%201-2.46-.858l-1.96-.954a8.88%208.88%200%200%201-3.33-2.572c-.33-.583-.41-1.27-.24-1.914zm45.06-5.788a2.62%202.62%200%200%201%20.13%201.612l-.09-.051c-.07.474-.26.924-.55%201.308a2.55%202.55%200%200%201-1.78.741%209.37%209.37%200%200%201-1.7-.239l-.72-.238c-.39.072-.79.171-1.17.296l-.55.277c-.57.319-1.24.406-1.88.242a2.52%202.52%200%200%201-.91-.432%202.44%202.44%200%200%201-.68-.752%202.77%202.77%200%200%201-.25-1.917%202.56%202.56%200%200%201%201.17-1.511%202.32%202.32%200%200%201%20.31-1.207%202.56%202.56%200%200%201%201.54-1.18%202.55%202.55%200%200%201%201.92.253l1.57.908c.89.065%201.75.312%202.54.725l.57.332a1.85%201.85%200%200%201%20.53.833zm-29.84%20118.024c-2.24-1.641-4.03-3.822-5.2-6.339a2.49%202.49%200%200%201-.37-.945%202.66%202.66%200%200%201%20.02-1.014%202.62%202.62%200%200%201%20.42-.924%202.59%202.59%200%200%201%20.75-.688%2011.2%2011.2%200%200%201%201.12-.414c.16-.483.47-.902.88-1.195a2.37%202.37%200%200%201%201.42-.432c9.52-.024%2025.6%201.285%2026.76%2013.5a2.59%202.59%200%200%201-.53%201.561c-.35.448-.83.769-1.37.914a28.31%2028.31%200%200%201-16.47-.324l-.5-.148c-.52-.149-1.04-.298-1.51-.568l-2.92-.061c-.36-.004-.72-.085-1.05-.239s-.63-.377-.86-.654a2.51%202.51%200%200%201-.52-.951%202.46%202.46%200%200%201-.07-1.079zm-9.17-16.629a2.59%202.59%200%200%201-1.19-1.546l-.04-.026c-.13-.328-.18-.679-.16-1.029a2.71%202.71%200%200%201%20.26-1.008%202.61%202.61%200%200%201%20.65-.818%202.57%202.57%200%200%201%20.91-.493c1.22-.157%202.3-.447%203.38-.737a2.33%202.33%200%200%201%201.25-.784%2014.69%2014.69%200%200%201%202.65-.391l.8-.239%203.16-.898c1.97-.533%203.99-.861%206.03-.979a8.36%208.36%200%200%201%205.22%201.184%202.5%202.5%200%200%201%20.89.783c.23.327.38.704.44%201.1s.03.799-.1%201.179-.34.725-.62%201.007a12.1%2012.1%200%200%201-8.85%202.277c-1.55-.128-2.94-.223-4.41-.277l-1.55-.035a69.17%2069.17%200%200%201-6.79%201.987c-.65.173-1.34.08-1.93-.257zm-74.23-68.393l-16.82-8.096v-.092c-7.97-4.66%205.6-45.048%2020.92-43.086%2015.31%201.962%2029.15%204.844%2037.65%208.951a463.29%20463.29%200%200%201%2042.02%2030.17c3.01-.072%206.02.132%208.99.608%203.5.647%206.86%201.915%209.91%203.746%202.31%201.087%204.33%202.709%205.89%204.73.91.448%201.78.952%202.62%201.509.37.229.69.552.9.938a2.54%202.54%200%200%201%20.33%201.262%202.53%202.53%200%200%201-.34%201.259c-.22.383-.54.703-.92.928-.98.723-2.1%201.233-3.28%201.499l.36.388c1.25%201.725-.57%203.598-2.2%203.81-.65.064-1.32.092-1.97.099%203.32%204.255%205.43%209.331%206.1%2014.689%201.19%2018.403-14.5%2029.63-32.94%2036.647%200%200-27.51-29.024-31.25-35.379-2.6-4.411-28-16.227-45.97-24.581zm-21.65-28.368c-8.53-.879-38.53-4.352-40.03-12.508v-.092c-1.29-7.032%205.17-13.668%208.68-16.517%206.43.795%2014.03%201.522%2022.15%202.297l19.9%201.991-10.7%2024.828z%22%20fill%3D%22url%28%23K%29%22%2F%3E%3Cpath%20opacity%3D%22.54%22%20d%3D%22M1029.95%200c42.57%2027.082%2078.37%2066.305%2092.51%20105.582%2012.05%2033.394-2.34%2061.81-12.17%2081.204-5.82%2011.498-10.04%2019.825-6.18%2024.137%204.66%205.218-.29%2010.028-7.31%2015.077h-33.57c.19-.736.35-1.444.51-2.129.93-4.126%201.67-7.397%208.84-10.715%208.33-3.858%206.85-12.926%205.23-22.775-1.25-7.631-2.57-15.73.53-22.241%203.27-6.874%203.78-7.813%205.08-10.218%201.52-2.814%204.12-7.634%2013.5-26.306%2017.39-34.635-61.02-80.406-61.02-80.406S1007.83%2014.816%201001.77%200h28.18z%22%20fill%3D%22url%28%23L%29%22%2F%3E%3Cg%20opacity%3D%22.54%22%3E%3Cpath%20d%3D%22M852.459%20226h-4.419c3.285-17.494%207.424-40.509%207.629-46.442.116-3.367-.073-5.759-.239-7.845-.321-4.05-.55-6.944%201.73-13.561.735-2.132%201-2.901.732-3.22-.995-1.181-9.315%203.805-28.287-31.352-9.783-18.13-24.248-26.7-37.981-30.485%208.396.472%2016.272%201.203%2021.339%202.331%209.655%202.15%2020.322%2013.049%2029.719%2022.649%206.163%206.296%2011.779%2012.034%2016.204%2014.378%205.754%203.048%205.346%205.438%204.607%209.773-.697%204.08-1.687%209.884%201.892%2019.582%204.667%2012.648-5.107%2043.336-12.926%2064.192z%22%20fill%3D%22url%28%23M%29%22%2F%3E%3Cpath%20d%3D%22M753.01%2092.263s18.523-4.706%2038.614.832c-18.098-1.017-38.614-.832-38.614-.832z%22%20fill%3D%22url%28%23M%29%22%2F%3E%3C%2Fg%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.6%22%20d%3D%22M1580%20183.231v28.573c-3.48-3.043-6.17-5.949-4.57-8.121%204.7-6.352-13.02-13.247-13.02-13.247s-29.61-5.547-25.83-8.712c2.02-1.689-5.8-2.278-14.65-2.945-7.74-.583-16.27-1.226-19.7-2.715-2.75-1.189-4.61.807-6.44%202.764-3.08%203.295-6.05%206.477-12.95-5.864-7.85-14.036-1.73-16.112%205.94-18.712%203.08-1.043%206.4-2.171%209.17-4.19-6.72%2010.264-11.76%2019.253-7.16%2022.589%204.29%202.985%2010.64%202.098%2019.36.877%2015.34-2.145%2038.03-5.319%2069.85%209.703z%22%20fill%3D%22url%28%23N%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.6%22%20d%3D%22M1413.49%200h-22.37c.5.89.92%201.863%201.25%202.931%203.2%2010.38%2014.4%2016.575%2020.29%2019.836%202.7%201.492%204.29%202.37%203.49%202.754-.91.439%202.45%201.548%207.42%203.185%208.85%202.921%2022.8%207.52%2026.62%2012.986%201.64%202.334%204.33%204.497%207.22%206.825%207.67%206.177%2016.79%2013.516%2011.52%2028.294-5.24%2014.68%201.04%2019.055%206.12%2022.597%201.96%201.368%203.74%202.611%204.62%204.275%201.27%202.429%206.31%205.031%2011.14%207.529%207.05%203.644%2013.66%207.066%207.55%209.405-6.59%202.517-6.98-1.269-7.67-1.324-.39-.032-.87%201.13-2.63%205.3-2.43%205.769%202.43%2010.343%206.7%2014.36%202.89%202.714%205.5%205.174%205.41%207.576l.79-1.176c7.55-11.277%2015.59-23.287%2014.19-30.546-1.71-8.864-6.65-14.297-10.58-18.611-2.77-3.043-5.03-5.529-5.29-8.27-.32-3.285%201.23-3.322%202.02-3.34.8-.019.83-.02-2.65-3.4-6.91-6.705-8.76-19.408-8.76-19.408s-3.56-10.915-7.85-12.628c-2.25-.895-8.69-4.381-15.69-8.172l-17.84-9.411c-5.35-2.61-9.73-7.539-14.28-12.667-3.61-4.06-7.32-8.244-11.72-11.5-2.64-1.957-5.73-4.567-9.02-7.398z%22%20fill%3D%22url%28%23O%29%22%2F%3E%3Cpath%20d%3D%22M1461.3%2016.326c-3.43%208.331-18.23-.395-14.32-3.953%203.92-3.558%2015.57.957%2014.32%203.953z%22%20fill%3D%22url%28%23P%29%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M1553.14%200l12.9%2018.264.82%201.174.25.358c.04-.133-.3-1.782-.78-4.171l-.16-.82c-.78-4.189-1.97-10.185-3.12-14.804H1580v107.892l-.72.975-.92%201.262-1.88-10.007.36%2012.01c-7.03%209.026-13.08%2015.506-13.08%2015.506a17.59%2017.59%200%200%200-.49-6.46%2028.68%2028.68%200%200%200-.56-2.057%2039.69%2039.69%200%200%200-3.7-8.325c-1.4-3.353-1.94-7.001-1.58-10.616l-.26.963c-1.64%203.462-3.61%206.755-5.89%209.833-.01.084-.04.166-.06.247l-3.98-9.167.58%2013.632c-1.89%202.431-3.94%204.847-6.01%207.207l-2.56-7.413.68%209.503c-9.3%2010.402-18.58%2019.037-18.58%2019.037s.09-.322.05-.967l.09-1.718c.21-3.967.63-11.965%201.51-21.444l9.2-5.323%202.17-1.242c-1.45.408-4.37.991-7.55%201.626l-3.51.707%201.3-14.174.08-.865%2018.39-9.319-17.36.856.73-5.686.05-.406%2015.9-.055-15.32-3.285.2-.766c1.78-11.676%209.81-21.386%2017.92-28.427a28.55%2028.55%200%200%201%201.57-1.326l.79-.663a142.28%20142.28%200%200%201-16.46%207.105c-2.15.763-4.34%201.361-6.57%201.788a64.63%2064.63%200%200%201-6.47.915l.69-12.445-6.34%2012.865c-2.23.118-4.5.197-6.77.196l2.86-8.023-6.32%207.865c-13.96-.398-27.87-1.928-41.58-4.577a204.47%20204.47%200%200%201%2022.7-12.9l9.27%206.719-6.98-7.853a196.41%20196.41%200%200%201%207.4-3.312l13.26%209.113-10.5-10.226c2.43-.964%204.91-1.915%207.45-2.797l21.52%207.515-9.27-11.118a73.96%2073.96%200%200%201%204.68-.994c13.1-2.447%2026.19-2.066%2036.66%204.208l-4.86-3.128-7.42-4.821c-6.25-4.138-13.62-9.131-19.2-13.301l8.98-6.462-16.18.534a9.51%209.51%200%200%201-1.14-1.285c-.73-1.042-2.03-3.192-3.62-6.264l11.36%202.275%205.82-.001L1522.36%200h24.49l-.51%207.585L1549.32%200h3.82zm12.29%2056.598s-7.08%2019.683-7.35%2033.351c1.78-11.255%204.23-22.392%207.35-33.351z%22%20fill%3D%22url%28%23Q%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.55%22%20d%3D%22M1580%2034.638v27.94c-1.7-.054-3.42.058-5.12.339-1.26.168-2.51.408-3.74.719-1.25.306-2.47.713-3.66%201.216%200%200-1.85%203.344-5.64%2022.052-2.08%2010.636-1.92%2021.589.46%2032.161a39.61%2039.61%200%200%200-3.75-8.233c-1.4-3.353-1.94-7.001-1.58-10.616l-.26.963c-1.64%203.462-3.61%206.755-5.89%209.833l2.84-8.401a125.62%20125.62%200%200%200%204.92-28.863l-2.96-.794c-6.6-1.802-13.09-3.991-19.43-6.555-1.83-1.259%206.08-10.022%209.42-13.601l1.04-1.099.36-.354c-5.34%202.712-10.84%205.085-16.47%207.105-2.14.763-4.34%201.361-6.57%201.788l4.79-17.86-8.46-11.321c13.1-2.447%2026.18-2.066%2036.65%204.209l-4.85-3.128-7.42-4.821%201.88.503a34.19%2034.19%200%200%200%2010.23.253c4.54-.556%208.23-1.977%208.76-3.928.36-2.093.59-4.207.69-6.329a76.25%2076.25%200%200%200%20.07-2.258c.01-.626.02-1.064.06-1.202.04.354.27%202.163.69%204.633%201.08%206.749%203.64%2018.052%207.94%2018.012a6.51%206.51%200%200%200%203.12-.99c.48-.296.96-.617%201.42-.969a15.87%2015.87%200%200%200%20.46-.404z%22%20fill%3D%22url%28%23R%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.35%22%20d%3D%22M1556.74%20101.08c3.18-15.034%208.71-41.778%209.25-48.357l.69-9.294c-7.3%202.633-14.41%205.751-21.3%209.332h0c-.33.15-.64.33-.96.511-8.1%207.041-16.16%2016.85-17.91%2028.427l-.21.766%2015.33%203.285-15.9.055-.79%206.091%2017.36-.856-18.38%209.319-1.39%2015.039c4.35-.795%209.06-1.678%2011.06-2.332-2.06%201.063-6.99%203.976-11.37%206.564l-1.6%2023.162c-.01.633-.04.967-.04.967s9.27-8.634%2018.57-19.036l-.68-9.503%202.57%207.413c2.06-2.36%204.11-4.776%206-7.207l-.58-13.633%203.98%209.168c.03-.081.05-.164.06-.247%202.39-3.001%204.48-6.228%206.24-9.635h0z%22%20fill%3D%22url%28%23S%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.35%22%20d%3D%22M1564.3%2040.276l-36.76%206.038-66.94%2010.921c13.71%202.648%2027.62%204.179%2041.58%204.577l5.69-7.981-2.87%208.023c2.28.001%204.55-.079%206.78-.196l6.34-12.865-.69%2012.445a64.63%2064.63%200%200%200%206.47-.915%2044.38%2044.38%200%200%200%206.56-1.788%20141.68%20141.68%200%200%200%2016.47-7.105h0l-.79.663.42-.285%2017.74-11.532z%22%20fill%3D%22url%28%23T%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.28%22%20d%3D%22M1564.99%2037.682l-13.22-5.315-7.42-4.821c-6.25-4.137-13.61-9.156-19.2-13.301l8.98-6.462-16.18.534a9.51%209.51%200%200%201-1.14-1.285c-.66-.997-1.96-3.172-3.62-6.264l11.36%202.275%205.82-.001L1522.44%200h8.87l33.68%2037.682z%22%20fill%3D%22url%28%23U%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.35%22%20d%3D%22M1564.1%20126.881l9.14-80.871a113.03%20113.03%200%200%201%20.78%2034.443c-2.71%2016.14-9.92%2046.428-9.92%2046.428z%22%20fill%3D%22url%28%23V%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.35%22%20d%3D%22M1520.87%20142.965a474.71%20474.71%200%200%200%2026.47-48.321c7.42-16.405%2013.72-33.295%2018.85-50.552-13.07%2042.355-45.32%2098.873-45.32%2098.873z%22%20fill%3D%22url%28%23W%29%22%2F%3E%3Cpath%20d%3D%22M718.315%20226H0V0h592.53c56.071%2065.293%2099.304%20141.931%20125.785%20226z%22%20fill%3D%22url%28%23X%29%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CradialGradient%20id%3D%22A%22%20cx%3D%220%22%20cy%3D%220%22%20r%3D%221%22%20gradientTransform%3D%22translate%2822.0001%20392%29%20rotate%28-18.4718%29%20scale%281475.52%201188.92%29%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%230e48d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%2346e7c4%22%2F%3E%3C%2FradialGradient%3E%3ClinearGradient%20id%3D%22B%22%20x1%3D%221487%22%20y1%3D%22107.5%22%20x2%3D%221580%22%20y2%3D%220%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23ffdea4%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fabb52%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22C%22%20x1%3D%22-.1%22%20y1%3D%2259.148%22%20x2%3D%221066.63%22%20y2%3D%2259.148%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23e8efff%22%2F%3E%3Cstop%20offset%3D%22.21%22%20stop-color%3D%22%23f3f6ff%22%2F%3E%3Cstop%20offset%3D%22.54%22%20stop-color%3D%22%23fcfdff%22%2F%3E%3Cstop%20offset%3D%22.99%22%20stop-color%3D%22%23fff%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22D%22%20x1%3D%22930.586%22%20y1%3D%2280.759%22%20x2%3D%22928.887%22%20y2%3D%22-10.879%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22E%22%20x1%3D%22742.478%22%20y1%3D%22-48.071%22%20x2%3D%221014.86%22%20y2%3D%22-129.748%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22F%22%20x1%3D%22906.217%22%20y1%3D%2260.272%22%20x2%3D%22951.647%22%20y2%3D%22-63.234%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22G%22%20x1%3D%22865.321%22%20y1%3D%2245.231%22%20x2%3D%22910.769%22%20y2%3D%22-78.257%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22H%22%20x1%3D%221547.92%22%20y1%3D%22155.69%22%20x2%3D%221566.61%22%20y2%3D%22103.917%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22I%22%20x1%3D%221543.11%22%20y1%3D%22186.063%22%20x2%3D%221577.45%22%20y2%3D%2290.888%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22J%22%20x1%3D%221489.13%22%20y1%3D%22185.814%22%20x2%3D%221523.5%22%20y2%3D%2290.654%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23f9ca7b%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22K%22%20x1%3D%22994.237%22%20y1%3D%22243.939%22%20x2%3D%221184.18%22%20y2%3D%22-237.519%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22L%22%20x1%3D%22695.785%22%20y1%3D%22339.263%22%20x2%3D%221049.41%22%20y2%3D%2224.228%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22M%22%20x1%3D%22866.028%22%20y1%3D%22180.572%22%20x2%3D%22738.772%22%20y2%3D%22148.655%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22N%22%20x1%3D%221640.71%22%20y1%3D%22251.794%22%20x2%3D%221480.13%22%20y2%3D%22159.087%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22O%22%20x1%3D%221523.37%22%20y1%3D%22108.185%22%20x2%3D%221283.13%22%20y2%3D%22-30.517%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22P%22%20x1%3D%221422.44%22%20y1%3D%22-19.111%22%20x2%3D%221502.6%22%20y2%3D%2267.194%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23fff%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22Q%22%20x1%3D%221464.38%22%20y1%3D%22158.33%22%20x2%3D%221592.77%22%20y2%3D%22-15.586%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22R%22%20x1%3D%221511.07%22%20y1%3D%22116.088%22%20x2%3D%221590.14%22%20y2%3D%228.942%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22S%22%20x1%3D%221492.2%22%20y1%3D%22155.777%22%20x2%3D%221567.68%22%20y2%3D%2253.546%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22T%22%20x1%3D%221479.17%22%20y1%3D%2293.851%22%20x2%3D%221531.64%22%20y2%3D%2222.735%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22U%22%20x1%3D%221512.95%22%20y1%3D%2213.835%22%20x2%3D%221532.61%22%20y2%3D%22-12.826%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22V%22%20x1%3D%221537.47%22%20y1%3D%22128.722%22%20x2%3D%221586.68%22%20y2%3D%2262.08%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22W%22%20x1%3D%221496.34%22%20y1%3D%22157.336%22%20x2%3D%221570.74%22%20y2%3D%2256.538%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20stop-color%3D%22%23004e05%22%2F%3E%3Cstop%20offset%3D%22.45%22%20stop-color%3D%22%234e7e06%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23acb807%22%2F%3E%3C%2FlinearGradient%3E%3CradialGradient%20id%3D%22X%22%20cx%3D%220%22%20cy%3D%220%22%20r%3D%221%22%20gradientTransform%3D%22translate%28103%20420%29%20rotate%28-90%29%20scale%28645%29%22%20xlink%3Ahref%3D%22%23Z%22%3E%3Cstop%20offset%3D%22.181%22%20stop-color%3D%22%2382f4f6%22%2F%3E%3Cstop%20offset%3D%22.933%22%20stop-color%3D%22%2382f4f6%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3CclipPath%20id%3D%22Y%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h1580v226H0z%22%2F%3E%3C%2FclipPath%3E%3ClinearGradient%20id%3D%22Z%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var BackgroundVertical = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%22335%22%20height%3D%22492%22%20fill%3D%22none%22%3E%3Cg%20clip-path%3D%22url%28%23H%29%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h335v492H0z%22%2F%3E%3Cpath%20d%3D%22M335%200H0v492h335V0z%22%20fill%3D%22url%28%23A%29%22%2F%3E%3Cpath%20d%3D%22M335.002%20492h-95.804c27.026-22.059%2058.633-57.41%2095.804-112.239V492z%22%20fill%3D%22url%28%23B%29%22%2F%3E%3Cg%20fill-rule%3D%22evenodd%22%3E%3Cpath%20opacity%3D%22.19%22%20d%3D%22M36.04%200H0v252.946c22.4%2027.426%2045.048%2048.407%2071.58%2042.007%2071.605-17.271%20139.265-42.117%20194.998-230.995C273.345%2041.03%20278.856%2019.733%20283.36%200h-20.842c-.296%204.228-1.075%208.412-2.325%2012.47a6.79%206.79%200%200%201-.275%201.461c-7.158%2023.68-15.585%2046.958-25.245%2069.732-1.778%204.31-3.326%208.796-4.879%2013.298l-.001.003c-4.092%2011.859-8.224%2023.835-16.702%2033.026-5.02%205.882-12.098%209.625-19.786%2010.463-6.248.167-11.38-2.894-16.568-5.988l-2.499-1.474c-8.019-5.4-15.433-11.648-22.115-18.634l-.062-.061c-7.147-7.051-14.349-14.157-24.653-15.74-16.32-2.287-29.073%2010.704-36.655%2023.837L88.762%20126c-3.476%206.375-7.067%2012.96-12.923%2017.373a30.33%2030.33%200%200%201-20.143%205.092c-28.711-2.131-33.245-39.768-33.88-62.021C21.071%2057.135%2027.562%2027.996%2036.04%200zm78.105%20236.621a61.46%2061.46%200%200%200%2026.04%201.07c2.189.18%204.391.084%206.556-.285%202.976-.521%205.848-1.525%208.5-2.972l5.312-1.617a7.24%207.24%200%200%200%204.085-2.961c.963-1.445%201.374-3.188%201.16-4.911%209.057-11.973%2012.923-29.965%2013.102-42.862.257-29.18-24.129-64.883-57.17-54.281-29.364%209.311-41.776%2050.295-35.541%2077.708a39.99%2039.99%200%200%200%209.649%2019.441c4.947%205.467%2011.309%209.46%2018.383%2011.539l-.076.131zm-11.818%2033.055c1.593-.96%202.796-2.452%203.395-4.212.974-.646%201.828-1.457%202.522-2.397a18.31%2018.31%200%200%200%204.755-11.875c-.329-3.301-1.529-6.456-3.477-9.142-4.532-6.556-11.714-11.403-19.654-7.582a7.57%207.57%200%200%200-2.748%202.724%207.58%207.58%200%200%200-1.046%203.725c-.02%201.311.3%202.605.929%203.756s1.546%202.118%202.661%202.809a65.91%2065.91%200%200%201-.335%205.584c-.754%204.744.194%209.602%202.675%2013.714.499.867%201.164%201.626%201.958%202.235s1.7%201.054%202.666%201.311%201.974.32%202.965.186a7.57%207.57%200%200%200%202.809-.968l-.076.132zm-69.809-16.317c11.141%2010.197%2034.454%2011.137%2042.613-3.675%203.153-5.462%202.765-12.117%202.397-18.409l-.22-4.848c-.078-4.649-.401-9.296-.724-13.947-.476-6.848-.952-13.706-.65-20.595.139-1.634-.339-3.26-1.339-4.558s-2.451-2.176-4.065-2.458a7.08%207.08%200%200%200-3.128-1.739%207.09%207.09%200%200%200-3.579.011c-6.809%201.536-12.625%206.542-17.934%2011.111l-.013.012-2.391%202.042c-5.775%204.182-10.831%209.276-14.968%2015.083-8.345%2013.392-8.075%2030.97%204.003%2041.97z%22%20fill%3D%22url%28%23C%29%22%2F%3E%3Cpath%20d%3D%22M277.668%20492H0l.001-68.435c4.553-5.924%2010.303-12.756%2017.553-20.78a254.4%20254.4%200%200%200%2051.633-88.597%20339.43%20339.43%200%200%200%2011.111%2059.075s36.412-23.188%2052.617-39.352c11.736-11.707%2033.849-58.566%2046.399-85.162l9.077-18.507c1.566-2.062-4.442-2.676-11.199-3.366h-.001c-7.402-.756-15.701-1.603-15.924-4.546-.386-4.032-40.333%203.897-62.543%208.627l.284-.493c22.572-5.659%2063.619-15.797%2067.573-15.747%202.447.026%203.853%201.386%205.702%203.175%202.294%202.22%205.271%205.099%2011.764%206.909%204.175%201.185%2014.013%205.07%2025.047%209.69%202.955-11.032%2016.705-61.006%2022.146-61.104%206.17-.071%2027.781%2012.537%2027.781%2012.537a94.41%2094.41%200%200%201%204.524-21.332c4.312-9.657%2018.815-30.511%2034.068-52.444l.003-.004C312.09%2091.331%20327.24%2069.548%20335%2055.435v3.57c-15.107%2023.372-33.189%2051.963-32.176%2055.295.71%202.418%2014.727%2016.038%2029.883%2030.765l.002.003%202.291%202.226v5.605c-13.46-15.209-28.625-29.71-35.837-27.406-14.545%204.647-29.22%2034.082-31.773%2041.538s-17.807%20130.845-19.261%20144.889l5.531-8.604c25.455-39.629%2046.168-71.877%2055.269-66.909%205.281%202.863%2014.368-3.798%2026.071-17.382v201.018c-4.228%204.92-8.129%209.536-11.051%2013.481-4.82%206.509-11.019%2012.009-17.034%2017.346l-.002.001c-7.613%206.755-14.932%2013.249-18.786%2021.196-2.549%205.254-6.441%2012.526-10.459%2019.933zM66.652%20361.795a3.79%203.79%200%200%200%202.279-1.748%203.98%203.98%200%200%200%20.394-2.881l-.083-.311a11.38%2011.38%200%200%201%20.01-2.139l.472-2.485a3.79%203.79%200%200%200-.392-2.809c-.249-.432-.581-.811-.977-1.114a3.79%203.79%200%200%200-1.329-.655c-.949-.257-1.962-.135-2.823.34-.435.256-.814.597-1.115%201.002s-.519.865-.64%201.355c-.817%202.852-.962%205.855-.425%208.773.262.966.896%201.79%201.763%202.291s1.898.637%202.866.381zm173.749%207.864c7.484-3.169%2014.074-8.127%2019.193-14.439a98.41%2098.41%200%200%200%2012.789-16.692l4.587-7.945c1.419-2.501%202.999-4.908%204.729-7.205a17.51%2017.51%200%200%201%205.73-4.922%2010.05%2010.05%200%200%201%206.361-.705c1.342.25%202.636.659%203.931%201.067l.004.002c1.296.409%202.592.818%203.936%201.068%203.322.549%206.732-.023%209.693-1.626a42.5%2042.5%200%200%200%2016.854-16.227c1.988-3.143%203.388-6.621%204.132-10.265a65.47%2065.47%200%200%200%20.267-13.503l-.178-4.049-.368-10.624a79.53%2079.53%200%200%200-.342-9.871%2018.01%2018.01%200%200%200-3.362-9.34%2010.59%2010.59%200%200%200-4.371-3.042%2010.58%2010.58%200%200%200-5.3-.527%208.15%208.15%200%200%200-3.437%201.237%208.16%208.16%200%200%200-2.551%202.615l-.569.985c-.003.046-.017.091-.04.13a.28.28%200%200%201-.049.064c-.013.013-.028.025-.044.036-.178.037-.354.082-.529.126h-.001l-.001.001c-.262.067-.521.133-.777.168l-.23-.132a40.17%2040.17%200%200%201-1.855-3.611c.241-.655.297-1.364.161-2.049s-.458-1.318-.932-1.832a3.79%203.79%200%200%200-1.751-1.076c-.671-.191-1.382-.193-2.055-.005-3.988.831-5.846%204.302-7.66%207.688v.002c-.721%201.345-1.434%202.677-2.27%203.824-1.985%202.753-4.263%205.273-6.538%207.79-1.505%201.664-3.008%203.327-4.424%205.054a38.5%2038.5%200%200%200-7.977%2013.21%20118.82%20118.82%200%200%200-1.88%2014.629c-1.288%208.606-6.421%2015.671-11.424%2022.557l-2.8%203.9c-10.472%2014.878-21.876%2031.143-23.408%2049.869a3.78%203.78%200%200%200%20.39%201.673c.256.52.628.975%201.087%201.329s.994.598%201.563.713%201.156.098%201.716-.05zm17.361%2029.372c.855.354%201.811.384%202.686.083s1.61-.912%202.066-1.717l2.138-3.603.008-.012c1.439-2.393%202.876-4.781%204.147-7.285.508-.88.855-1.881%201.197-2.867l.239-.681a5.88%205.88%200%200%200%20.634-2.379c.041-.829-.094-1.657-.397-2.43-.409-.646-.946-1.202-1.577-1.634a5.67%205.67%200%200%200-2.093-.88%2010.96%2010.96%200%200%200-1.984-.051%203.82%203.82%200%200%200-1.589-.211%203.8%203.8%200%200%200-1.534.465c-2.357%201.502-4.395%203.454-5.995%205.745a21.24%2021.24%200%200%200-3.333%207.605c-.244.972-.094%202.001.417%202.862a3.79%203.79%200%200%200%202.314%201.735l.656.379-.246.427c-.227.888-.124%201.827.289%202.645a3.79%203.79%200%200%200%201.957%201.804zm-41.878%206.141c1.773-.375%203.376-1.32%204.561-2.692%202.185-2.681%203.829-5.76%204.842-9.067l.847-2.225.568-.985a12.86%2012.86%200%200%201%202.257-3.075c1.534-1.572%202.752-3.425%203.588-5.457a11.37%2011.37%200%200%200-.276-7.557c-.195-.569-.508-1.091-.917-1.531a4.28%204.28%200%200%200-1.461-1.024c-.332-.561-.803-1.026-1.367-1.352s-1.204-.5-1.856-.507-1.294.155-1.865.469a3.79%203.79%200%200%200-1.396%201.324c-1.205%202.087-2.472%204.163-3.744%206.246-4.37%207.158-8.796%2014.407-10.941%2022.526-.212.825-.139%201.697.205%202.476a3.79%203.79%200%200%200%201.694%201.816%208.3%208.3%200%200%200%205.261.615zm-.672-33.203a3.79%203.79%200%200%200-5.115-1.377c-1.649%201.314-2.956%203.007-3.812%204.934l-1.414%202.904c-.536%201.173-.962%202.392-1.272%203.644-.173.714-.135%201.463.11%202.157a3.79%203.79%200%200%200%201.27%201.747c.584.462%201.291.742%202.033.805a3.8%203.8%200%200%200%202.141-.453c3.284-2.297%205.903-5.42%207.591-9.055a3.79%203.79%200%200%200%20.379-2.877c-.26-.971-.896-1.799-1.766-2.302l-.145-.127zm3.913%2065.249a3.79%203.79%200%200%200%202.389-.196c.476-.138.904-.406%201.236-.775l.492-.854c.613-1.165.978-2.444%201.075-3.757l1.346-2.331c.493-.863.628-1.886.375-2.847-.262-.96-.89-1.778-1.749-2.279-.542-.317-1.161-.477-1.789-.464a3.79%203.79%200%200%200-2.24-1.731c-.961-.229-1.973-.097-2.842.373-.435.256-.814.597-1.115%201.001a3.8%203.8%200%200%200-.64%201.356c-.242.942-.114%201.94.359%202.79l.41.806c.186.57.332%201.152.439%201.742l-.352%201.065c-.195.824-.313%201.664-.355%202.51.006.992.4%201.942%201.098%202.647.57.426%201.235.706%201.938.813l-.075.131zM55.963%20385.084c-3.732%201.736-6.964%204.387-9.396%207.707a3.81%203.81%200%200%200-1.599.111c-.519.151-1%20.411-1.41.763s-.741.787-.969%201.277a3.79%203.79%200%200%200-.355%201.563l-.09%204.326c-.401.694-.622%201.467-.842%202.234v.002l-.219.74c-2.576%207.91-2.743%2016.407-.48%2024.411a3.79%203.79%200%200%200%203.669%202.819c18.106-1.716%2020.046-25.546%2020.01-39.662.019-.752-.206-1.49-.64-2.103a3.49%203.49%200%200%200-1.771-1.303c-.161-.53-.365-1.086-.613-1.667a3.78%203.78%200%200%200-1.02-1.105%203.79%203.79%200%200%200-1.37-.621c-.493-.114-1.005-.127-1.503-.04s-.975.274-1.401.548zm17.545-7.643a3.79%203.79%200%200%200-2.673%204.629%20102.76%20102.76%200%200%200%202.946%2010.062l-.052%202.289a141.37%20141.37%200%200%201-.41%206.548%2017.93%2017.93%200%200%200%203.374%2013.111%203.8%203.8%200%200%200%203.242%201.074%203.79%203.79%200%200%200%202.79-1.969c1.415-2.319%202.032-5.038%201.755-7.741a44.08%2044.08%200%200%200-1.451-8.936c-.405-1.595-.867-3.139-1.332-4.69l-.354-1.186a21.65%2021.65%200%200%200-.58-3.924c-.176-.727-.584-1.377-1.163-1.853-.43-1.605-.86-3.21-1.092-5.008a3.79%203.79%200%200%200-.731-1.359c-.334-.399-.747-.724-1.213-.956a3.79%203.79%200%200%200-1.493-.392%203.78%203.78%200%200%200-1.526.236l-.038.065zm111.087-133.195c-2.087%203.615-6.546%2013.203-12.001%2024.932-12.383%2026.626-29.897%2064.285-36.436%2068.137-9.419%205.549-52.441%2046.327-52.441%2046.327%2010.402%2027.323%2027.042%2050.587%2054.322%2048.828%207.942-.996%2015.466-4.124%2021.773-9.053a33.93%2033.93%200%200%200%20.147%202.93c.314%202.413%203.09%205.111%205.647%203.26l.576-.543c.393%201.761%201.15%203.42%202.221%204.872a3.79%203.79%200%200%200%201.376%201.356c.568.326%201.211.499%201.866.503s1.299-.163%201.871-.483a3.8%203.8%200%200%200%201.39-1.342%2035.48%2035.48%200%200%200%202.236-3.874c2.997-2.315%205.4-5.308%207.012-8.734a44.19%2044.19%200%200%200%205.553-14.697c.706-4.401%201.007-8.857.901-13.313a688.58%20688.58%200%200%200%2044.721-62.296c6.089-12.593%2010.361-33.108%2013.269-55.811s-56.958-42.821-63.866-31.007l-.137.008zm48.591-66.496c-12.089%202.212-17.239%2046.69-18.541%2059.333l36.803%2015.864%202.952-29.503v-.001-.002l3.405-32.834c-4.222-5.196-14.059-14.771-24.482-12.866l-.137.009z%22%20fill%3D%22url%28%23D%29%22%2F%3E%3C%2Fg%3E%3Cpath%20d%3D%22M84.646%20234.035c.416-.008.831.014%201.243.067l-4.933%2017.253-.019.065-.001.002c-7.598%2026.436-14.145%2049.215-13.338%2055.81.125.861.255%201.961.41%203.268l.447%203.662c3.962-11.054%207.196-21.689%2010.249-31.73l.001-.002.001-.002v-.002c5.34-17.564%2010.128-33.309%2017.294-46.299.934-1.694%201.859-3.523%202.567-5.128l-9.154%201.87%209.438-2.363-.009-.136c3.601-8.419-16.123-1.65-33.891%204.448-11.866%204.073-22.86%207.846-25.451%206.596-1.108%204.372%2011.093.234%2023.313-3.911h.002c12.185-4.133%2024.388-8.272%2023.437-3.988l-.34.07c.047.015.155.037.306.065l-.006.021.05-.013%201.353.227c1.027.167%202.151.35%202.261.413a27.47%2027.47%200%200%201-3.867-.224l.099-.376-1.464.337z%22%20fill%3D%22url%28%23D%29%22%2F%3E%3Cpath%20style%3D%22mix-blend-mode%3Amultiply%22%20opacity%3D%22.6%22%20d%3D%22M277.783%20492h-20.332l5.634-6.738c3.451-4.288%206.657-8.271%2010.117-10.695%208.102-5.674%2014.92-26.346%2019.249-39.472%202.426-7.356%204.071-12.342%204.722-10.992.569%201.181%201.87-1.171%204.081-5.168%204.835-8.737%2014.017-25.333%2029.404-30.085a22.25%2022.25%200%200%200%204.344-1.855v33.161c-4.196%204.878-8.065%209.455-10.966%2013.372-4.827%206.517-11.029%2012.027-17.046%2017.372l-.001.001c-7.601%206.752-14.907%2013.242-18.776%2021.171-2.558%205.243-6.432%2012.516-10.43%2019.928z%22%20fill%3D%22url%28%23E%29%22%2F%3E%3Cpath%20d%3D%22M310.804%20491.023c-12.349-5.072.585-27.02%205.859-21.218s-1.42%2023.081-5.859%2021.218z%22%20fill%3D%22url%28%23F%29%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M335%20387.205C279.791%20435.012%20214.253%20471.209%20142.182%20492H0V0h335v387.205z%22%20fill%3D%22url%28%23G%29%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CradialGradient%20id%3D%22A%22%20cx%3D%220%22%20cy%3D%220%22%20r%3D%221%22%20gradientTransform%3D%22translate%28-107.5%20-151%29%20rotate%2852.9791%29%20scale%28720.803%20718.846%29%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%230e48d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%2346e7c4%22%2F%3E%3C%2FradialGradient%3E%3ClinearGradient%20id%3D%22B%22%20x1%3D%22175.655%22%20y1%3D%22529.123%22%20x2%3D%22335.002%22%20y2%3D%22666.977%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%23ffdea4%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fabb52%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22C%22%20x1%3D%22247.325%22%20y1%3D%22-1675.2%22%20x2%3D%22247.325%22%20y2%3D%22-93.99%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%23e8efff%22%2F%3E%3Cstop%20offset%3D%22.21%22%20stop-color%3D%22%23f3f6ff%22%2F%3E%3Cstop%20offset%3D%22.54%22%20stop-color%3D%22%23fcfdff%22%2F%3E%3Cstop%20offset%3D%22.99%22%20stop-color%3D%22%23fff%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22D%22%20x1%3D%22-26.589%22%20y1%3D%22-201.298%22%20x2%3D%22687.074%22%20y2%3D%2280.247%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22E%22%20x1%3D%22174.639%22%20y1%3D%22583.038%22%20x2%3D%22380.238%22%20y2%3D%22226.93%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%2376fbde%22%2F%3E%3Cstop%20offset%3D%22.32%22%20stop-color%3D%22%23abf8da%22%2F%3E%3Cstop%20offset%3D%22.62%22%20stop-color%3D%22%23d9f5d8%22%2F%3E%3Cstop%20offset%3D%22.86%22%20stop-color%3D%22%23f5f4d6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff3d5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22F%22%20x1%3D%22363.331%22%20y1%3D%22433.424%22%20x2%3D%22235.402%22%20y2%3D%22552.246%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20stop-color%3D%22%23fff%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ca5f4b%22%2F%3E%3C%2FlinearGradient%3E%3CradialGradient%20id%3D%22G%22%20cx%3D%220%22%20cy%3D%220%22%20r%3D%221%22%20gradientTransform%3D%22rotate%28-180%29%20scale%28512%20512%29%22%20xlink%3Ahref%3D%22%23I%22%3E%3Cstop%20offset%3D%22.505%22%20stop-color%3D%22%2382f4f6%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%2382f4f6%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3CclipPath%20id%3D%22H%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h335v492H0z%22%2F%3E%3C%2FclipPath%3E%3ClinearGradient%20id%3D%22I%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var currentFont = 'Montserrat';
var fontFamily = "".concat(currentFont, ", -apple-system, BlinkMacSystemFont, Segoe UI, Roboto");
var Font = function () { return (React__default.createElement("style", null, "\n          @import url(https://fonts.googleapis.com/css2?family=".concat(currentFont, ":wght@400;700);\n    "))); };

var BannerWrapper = styled(Box$1)(templateObject_1 || (templateObject_1 = __makeTemplateObject$q(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: 40px ", "px;\n  color: ", ";\n  box-sizing: border-box;\n  border-radius: 10px;\n  font-family: ", ";\n\n  @media screen and (max-width: 920px) {\n    padding: 40px;\n  }\n\n  ", " {\n    padding: 30px 40px;\n  }\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: 40px ", "px;\n  color: ", ";\n  box-sizing: border-box;\n  border-radius: 10px;\n  font-family: ", ";\n\n  @media screen and (max-width: 920px) {\n    padding: 40px;\n  }\n\n  ", " {\n    padding: 30px 40px;\n  }\n"])), function (_a) {
    var isVertical = _a.isVertical;
    return (isVertical ? 'column' : 'row');
}, function (_a) {
    var isVertical = _a.isVertical;
    return (isVertical ? 30 : 60);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
}, fontFamily, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.md;
});
var templateObject_1;

var LidoStakeBanner = function (props) {
    var referrerId = props.referrerId, direction = props.direction;
    var stakeLink = getStakeLink(referrerId);
    var defiLink = getDefiLink(referrerId);
    var defiApy = getDefiApy();
    var _a = useState(STATIC_DEFAULT_APY), apy = _a[0], setApy = _a[1];
    var _b = useState('100%'), width = _b[0], setWidth = _b[1];
    var isMobile = useBreakpoint('lg');
    var isVertical = isMobile || direction === 'vertical';
    useEffect(function () {
        if (direction === 'vertical') {
            setWidth(props.width);
        }
    }, [direction]);
    useEffect(function () {
        getStakeApy().then(function (stakeApy) {
            setApy(stakeApy);
        });
    }, []);
    var background = isVertical
        ? "url(".concat(BackgroundVertical, ") center bottom / cover")
        : "url(".concat(Background, ") right center / cover");
    return (React__default.createElement(BannerWrapper, { background: background, maxWidth: width, isVertical: isVertical },
        React__default.createElement(Box$1, { mr: isVertical ? 0 : 8 },
            React__default.createElement(SvgLidoLogoinline, null),
            React__default.createElement(Box$1, { mb: 12 }),
            React__default.createElement(Text$1, { style: { fontSize: 36, lineHeight: '50px' }, strong: true }, "".concat(apy, " APY + DeFi Yields")),
            React__default.createElement(Text$1, { size: "sm", style: { lineHeight: '26px' } },
                "Stake SOL with Lido and receive stSOL while staking. ",
                React__default.createElement("br", null),
                "Put stSOL in to ",
                React__default.createElement("strong", null, "DeFI integrations"),
                " and earn up to ",
                React__default.createElement("strong", null,
                    defiApy,
                    "% APY"))),
        isVertical && React__default.createElement(Box$1, { mb: 20 }),
        React__default.createElement(Box$1, { display: "flex", flexDirection: "column", justifyContent: "center", width: isVertical ? '100%' : 294 },
            React__default.createElement(Link$1, { href: stakeLink },
                React__default.createElement(Button$1, { color: "secondary", size: "lg", fullwidth: true, square: true }, "Stake SOL")),
            React__default.createElement(Box$1, { mb: 16 }),
            React__default.createElement(Link$1, { href: defiLink },
                React__default.createElement(Button$1, { variant: "outlined", color: "secondary", size: "lg", fullwidth: true, square: true }, "Explore 30+ integrations")))));
};

var Wrapper = function (props) { return (React__default.createElement(ThemeProvider, { theme: themeLight },
    React__default.createElement(Font, null),
    React__default.createElement(LidoStakeBanner, __assign$c({}, props)))); };
Wrapper.defaultProps = {
    width: '335px',
};

var SolidoSDK = /** @class */ (function () {
    function SolidoSDK(cluster, connection, referrerId) {
        this.lidoVersion = LidoVersion.v1;
        this.getStSolAccountsForUser = getStSolAccountsForUser.bind(this);
        this.getStakeTransaction = getStakeTransaction.bind(this);
        this.calculateMaxStakeAmount = calculateMaxStakeAmount.bind(this);
        this.findProgramAddress = findProgramAddress.bind(this);
        this.getDepositInstruction = getDepositInstruction.bind(this);
        this.getUnStakeTransaction = getUnStakeTransaction.bind(this);
        this.calculateMaxUnStakeAmount = calculateMaxUnStakeAmount.bind(this);
        this.isUnStakeAvailable = isUnStakeAvailable.bind(this);
        this.getWithdrawInstruction = getWithdrawInstruction.bind(this);
        this.getAccountInfo = getAccountInfo.bind(this);
        this.calculateStakeAccountAddress = calculateStakeAccountAddress.bind(this);
        // Transaction Info
        this.getTransactionInfo = getTransactionInfo.bind(this);
        this.getExchangeRate = getExchangeRate.bind(this);
        this.getTransactionCost = getTransactionCost.bind(this);
        this.getStakingRewardsFee = getStakingRewardsFee.bind(this);
        // Statistics
        this.getLidoStatistics = getLidoStatistics.bind(this);
        this.getTotalStaked = getTotalStaked.bind(this);
        this.getStakersCount = getStakersCount.bind(this);
        this.getMarketCap = getMarketCap.bind(this);
        this.getTotalRewards = getTotalRewards.bind(this);
        // @ts-expect-error for js users
        if (cluster === 'devnet') {
            throw new ErrorWrapper({ code: ERROR_CODE.UNSUPPORTED_CLUSTER });
        }
        this.programAddresses = clusterProgramAddresses[cluster];
        this.connection = connection;
        this.referrerId = referrerId;
    }
    SolidoSDK.prototype.signAndConfirmTransaction = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, wallet, setTxStage, signed, transactionHash, _a, blockhash, lastValidBlockHeight, status_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        transaction = props.transaction, wallet = props.wallet, setTxStage = props.setTxStage;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, wallet.signTransaction(transaction)];
                    case 2:
                        signed = _b.sent();
                        return [4 /*yield*/, this.connection.sendRawTransaction(signed.serialize())];
                    case 3:
                        transactionHash = _b.sent();
                        setTxStage === null || setTxStage === void 0 ? void 0 : setTxStage({ txStage: TX_STAGE.AWAITING_BLOCK, transactionHash: transactionHash });
                        return [4 /*yield*/, this.connection.getLatestBlockhash()];
                    case 4:
                        _a = _b.sent(), blockhash = _a.blockhash, lastValidBlockHeight = _a.lastValidBlockHeight;
                        return [4 /*yield*/, this.connection.confirmTransaction({
                                blockhash: blockhash,
                                lastValidBlockHeight: lastValidBlockHeight,
                                signature: transactionHash,
                            })];
                    case 5:
                        status_1 = (_b.sent()).value;
                        if (status_1 === null || status_1 === void 0 ? void 0 : status_1.err) {
                            throw status_1.err;
                        }
                        setTxStage === null || setTxStage === void 0 ? void 0 : setTxStage({ txStage: TX_STAGE.SUCCESS });
                        return [2 /*return*/, transactionHash];
                    case 6:
                        error_1 = _b.sent();
                        console.error(error_1);
                        setTxStage === null || setTxStage === void 0 ? void 0 : setTxStage({ txStage: TX_STAGE.ERROR });
                        throw new ErrorWrapper({ error: error_1, code: ERROR_CODE.CANNOT_CONFIRM_TRANSACTION });
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // Staking functions
    SolidoSDK.prototype.stake = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var amount, wallet, setTxStage, _a, transaction, stSolAccountAddress, transactionHash;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        amount = props.amount, wallet = props.wallet, setTxStage = props.setTxStage;
                        if (wallet.publicKey === null) {
                            throw new ErrorWrapper({ code: ERROR_CODE.NO_PUBLIC_KEY });
                        }
                        return [4 /*yield*/, this.getStakeTransaction({
                                amount: +amount,
                                payerAddress: new PublicKey(wallet.publicKey),
                            })];
                    case 1:
                        _a = _b.sent(), transaction = _a.transaction, stSolAccountAddress = _a.stSolAccountAddress;
                        setTxStage === null || setTxStage === void 0 ? void 0 : setTxStage({ txStage: TX_STAGE.AWAITING_SIGNING, stSolAccountAddress: stSolAccountAddress });
                        return [4 /*yield*/, this.signAndConfirmTransaction({
                                transaction: transaction,
                                wallet: wallet,
                                setTxStage: setTxStage,
                            })];
                    case 2:
                        transactionHash = _b.sent();
                        return [2 /*return*/, { transactionHash: transactionHash, stSolAccountAddress: stSolAccountAddress }];
                }
            });
        });
    };
    // UnStaking functions
    SolidoSDK.prototype.unStake = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var amount, wallet, setTxStage, _a, transaction, deactivatingSolAccountAddress, transactionHash;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        amount = props.amount, wallet = props.wallet, setTxStage = props.setTxStage;
                        if (wallet.publicKey === null) {
                            throw new ErrorWrapper({ code: ERROR_CODE.NO_PUBLIC_KEY });
                        }
                        return [4 /*yield*/, this.getUnStakeTransaction({
                                amount: +amount,
                                payerAddress: new PublicKey(wallet.publicKey),
                            })];
                    case 1:
                        _a = _b.sent(), transaction = _a.transaction, deactivatingSolAccountAddress = _a.deactivatingSolAccountAddress;
                        setTxStage === null || setTxStage === void 0 ? void 0 : setTxStage({ txStage: TX_STAGE.AWAITING_SIGNING, deactivatingSolAccountAddress: deactivatingSolAccountAddress });
                        return [4 /*yield*/, this.signAndConfirmTransaction({
                                transaction: transaction,
                                wallet: wallet,
                                setTxStage: setTxStage,
                            })];
                    case 2:
                        transactionHash = _b.sent();
                        return [2 /*return*/, {
                                transactionHash: transactionHash,
                                deactivatingSolAccountAddress: deactivatingSolAccountAddress,
                            }];
                }
            });
        });
    };
    return SolidoSDK;
}());

export { INSTRUCTION, Wrapper as LidoStakeBanner, LidoVersion, MAINNET_PROGRAM_ADDRESSES, SolidoSDK, TESTNET_PROGRAM_ADDRESSES, TX_STAGE, formatWithCommas, getStakeApy, lamportsToSol, solToLamports, toPrecision };
